import React, { useState, useEffect, useCallback, useRef } from 'react';
import './../../App.css';
import './Payroll.css';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css'; 
import {CreateTableForEmployeeSelect} from '../ManageTable';
import {CreateButton, CreateSearchBarWithPlaceHolder} from '../CommonObjects';
import {SetAuditTrail, SetAuditTrailBulk} from './../Reports/AuditTrailReportEmployeeSetup';
import {token, domain} from '../Security';
import axios from 'axios';
import { useTable, useSortBy } from "react-table";
import * as XLSX from 'xlsx'; // Import all exports from xlsx library
import loadingSpinner from './../../assets/loading.gif';
import { format } from 'date-fns';
import {globalTimeFormat} from './../Security';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
// icons
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import SettingsIcon from '@mui/icons-material/Settings';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import DownloadIcon from '@mui/icons-material/Download';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import FileOpenIcon from '@mui/icons-material/FileOpen';
import PaidIcon from '@mui/icons-material/Paid';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from "@mui/icons-material/Close";
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import PostAddIcon from '@mui/icons-material/PostAdd';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';

function Payroll({user, userAccess, isHideSideMenu}) {
    const [loadingRequest, setLoadingRequest] = useState(false);
    const [showSetting, setShowSetting] = useState(false);
    const settingRef = useRef(null);
    const buttonRef = useRef(null); 

    const [payrollData, setPayrollData] = useState([]);
    const [payrollDataAdjustment, setPayrollDataAdjustment] = useState([]);

    const [otherAdditionData, setOtherAdditionData] = useState([]);
    const [otherDeductionData, setOtherDeductionData] = useState([]);
    const [otherAdjustmentData, setOtherAdjustmentData] = useState([]);
    const [otherNightDiff, setOtherNightDiff] = useState([]);

    const [showUploadForm, setShowUploadForm] = useState(false)
    const [settingType, setSettingType] = useState("")
    const [payrollIdForUpload, setPayrollIdForUpload] = useState("")
    const [payTypeIdForUpload, setPayTypeIdForUpload] = useState("")
    //filters
    const [filterPayrollPeriodId, setFilterPayrollPeriodId] = useState("");
    const [filterPayTypeId, setFilterPayTypeId] = useState("");
    const [filterClassificationId, setFilterClassificationId] = useState("");
    const [filterLocationId, setFilterLocationId] = useState("");
    
    const [noDataMessage, setNoDataMessage] = useState(false);
    const [showPostMessage, setShowPostMessage] = useState(false);
    const [successPostMessage, setSuccessPostMessage] = useState(false);
    const [isGenerate, setIsGenerate] = useState(false);
    const [generateMessage, setGenerateMessage] = useState(false);
    const [showRevertPayrollForm, setShowRevertPayrollForm] = useState(false);
    const [showProcessPayrollForm, setShowProcessPayrollForm] = useState(false);
    const [showPostPayrollForm, setShowPostPayrollForm] = useState(false);
    const [isRevert, setIsRevert] = useState(false);
    const [isProcess, setIsProcess] = useState(false);
    const [isPost, setIsPost] = useState(false);
    const [isUpload, setIsUpload] = useState(false);

    const [loading, setLoading] = useState(false);
    const [filterData, setFilterData] = useState([]);

    const [type, setType] = useState(0)

    // const [employeeIds, setEmployeeIds] = useState([]);
    const fetchAllIdsData = useCallback(async () => {
        const apiUrl =  domain + "/api/Employee/basic-info/all/active";
        try {
            const response = await axios.get(apiUrl , {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // You can include other headers if needed
            }})
            
            const ids = response.data.map(employee => employee.employeeId);
            return ids;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, []);

    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }

        if (generateMessage) {
            const timeoutId = setTimeout(() => {
                setGenerateMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [generateMessage, showRequestMessage]);

    // =============================================================
    // ===================PROCESSED=================================
    // =============================================================
    const apiUrl =  domain + "/api/PayrollSummaryStaging/";

    const fetchDataProcessedPayroll = useCallback(async () => {
        if(!isGenerate) return;
        
        let classifiedData = filterClassificationId;

        if(!filterPayTypeId || !filterPayrollPeriodId || !classifiedData){ return; }
        try {
            setLoading(true);

            const response = await axios.get(apiUrl + `process/${filterPayTypeId}/${filterPayrollPeriodId}/${classifiedData}/${filterLocationId ? filterLocationId : 0}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
            // const filteredDatas = response.data.filter(filteredData => filteredData.payrollPeriodId === parseInt(filterPayrollPeriodId));
            // const newFilteredDatas = filteredDatas.filter(filteredData => filteredData.payTypeId === parseInt(filterPayTypeId));
            // setPayrollData(newFilteredDatas); // Set the response data to the state
            // setFilterData(newFilteredDatas); // Set the response data to the state

            setPayrollData(response.data); // Set the response data to the state
            setFilterData(response.data); // Set the response data to the state
            // setIsGenerate(false);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }, [apiUrl, isGenerate, filterPayrollPeriodId, filterPayTypeId, filterClassificationId, filterLocationId, setPayrollData]);
    // =============================================================
    // ===================PROCESSED=================================
    // =============================================================


    // =============================================================
    // ===================ADJUSTMENTS===============================
    // =============================================================
    const [loadingOtherAddition, setLoadingOtherAddition] = useState(false);
    const [loadingOtherDedujction, setLoadingOtherDedujction] = useState(false);
    const [loadingAdjustment, setLoadingAdjustment] = useState(false);
    const [loadingNightDiff, setLoadingNightDiff] = useState(false);
    const [filterDataAddition, setFilterDataAddition] = useState([]);
    const [filterDataDeduction, setFilterDataDeduction] = useState([]);
    const [filterDataAdjustment, setFilterDataAdjustment] = useState([]);
    const [filterDataNightDiff, setFilterDataNightDiff] = useState([]);

    const fetchAdditionData = useCallback(async () => {
        const apiUrl =  domain + "/api/";
        if(!isGenerate) return;

        let classifiedData = filterClassificationId;

        if(!filterPayTypeId || !filterPayrollPeriodId || !classifiedData){ return; }
        try {
            setLoadingOtherAddition(true);
            const response = await axios.get(apiUrl + `OtherAdditionStaging/paytype/${filterPayTypeId}/payrollperiod/${filterPayrollPeriodId}/classification/${classifiedData}/location/${filterLocationId ? filterLocationId : 0}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // You can include other headers if needed
                }
            });
            setOtherAdditionData(response.data); // Set the response data to the state
            setFilterDataAddition(response.data); // Set the response data to the state
            setIsUpload(false);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoadingOtherAddition(false);
        }
    }, [setIsUpload, isGenerate, filterPayTypeId, filterPayrollPeriodId, filterClassificationId, filterLocationId, setOtherAdditionData]);
    const fetchDeductionData = useCallback(async () => {
        const apiUrl =  domain + "/api/";
        if(!isGenerate) return;

        let classifiedData = filterClassificationId;

        if(!filterPayTypeId || !filterPayrollPeriodId || !classifiedData){ return; }
        try {
            setLoadingOtherDedujction(true);
            const response = await axios.get(apiUrl + `OtherDeductionStaging/paytype/${filterPayTypeId}/payrollperiod/${filterPayrollPeriodId}/classification/${classifiedData}/location/${filterLocationId ? filterLocationId : 0}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
            setOtherDeductionData(response.data); // Set the response data to the state
            setFilterDataDeduction(response.data); // Set the response data to the state
            setIsUpload(false);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoadingOtherDedujction(false);
        }
    }, [setIsUpload, isGenerate, filterPayTypeId, filterPayrollPeriodId, filterClassificationId, filterLocationId, setOtherDeductionData]);
    const fetchAdjustmentData = useCallback(async () => {
        const apiUrl =  domain + "/api/";
        if(!isGenerate) return;

        let classifiedData = filterClassificationId;

        if(!filterPayTypeId || !filterPayrollPeriodId || !classifiedData){ return; }
        try {
            setLoadingAdjustment(true);
            const response = await axios.get(apiUrl + `OtherAdjustmentStaging/paytype/${filterPayTypeId}/payrollperiod/${filterPayrollPeriodId}/classification/${classifiedData}/location/${filterLocationId ? filterLocationId : 0}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
            setOtherAdjustmentData(response.data); // Set the response data to the state
            setFilterDataAdjustment(response.data); // Set the response data to the state
            setIsUpload(false);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoadingAdjustment(false);
        }
    }, [setIsUpload, isGenerate, filterPayTypeId, filterPayrollPeriodId, filterClassificationId, filterLocationId, setOtherAdjustmentData]);
    const fetchNightDiffData = useCallback(async () => {
        const apiUrl =  domain + "/api/";
        if(!isGenerate) return;

        let classifiedData = filterClassificationId;

        if(!filterPayTypeId || !filterPayrollPeriodId || !classifiedData){ return; }
        try {
            setLoadingNightDiff(true);
            const response = await axios.get(apiUrl + `NightDifferentialsStaging/paytype/${filterPayTypeId}/payrollperiod/${filterPayrollPeriodId}/classification/${classifiedData}/location/${filterLocationId ? filterLocationId : 0}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
            setOtherNightDiff(response.data); // Set the response data to the state
            setFilterDataNightDiff(response.data); // Set the response data to the state
            setIsUpload(false);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoadingNightDiff(false);
        }
    }, [setIsUpload, isGenerate, filterPayTypeId, filterPayrollPeriodId, filterClassificationId, filterLocationId, setOtherNightDiff]);
    // =============================================================
    // ===================ADJUSTMENTS===============================
    // =============================================================
    const handleGenerate = async () => {
        let classifiedData = filterClassificationId;

        if (!filterPayrollPeriodId || !filterPayTypeId || !classifiedData) {
            setGenerateMessage(true);
            return;
        }

        setIsGenerate(true);
    };
    const handlePost = async (event) => {
        event.preventDefault();

        let classifiedData = filterClassificationId;
    
        // Constructing the URL with the correct format
        const apiUrl =  domain + `/api/PayrollSummaryStaging/post/${filterPayTypeId}/${filterPayrollPeriodId}/classification/${classifiedData}`;
    
        try {
            setLoadingRequest(true);
            // Making the Axios POST request with the constructed URL
            await axios.post(apiUrl, null, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
    
            // Rest of your logic for success
            setShowRequestMessage(true);
            setIsSuccess(true);
            // Fetch updated data
            await fetchAdditionData();
            await fetchDeductionData();
            await fetchAdjustmentData();
            await fetchNightDiffData();
            await fetchDataProcessedPayroll();
            
            closePostMessage();
        } catch (error) {
            // Handling errors
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("Fail to post data!");
        } finally {
            setLoadingRequest(false);
        }
    };

    const handleSetting = () =>{
        setShowSetting(!showSetting);
    };
    const closePostMessage = () => {
        setShowPostMessage(false);
    };
    useEffect(() => {
        if (noDataMessage) {
            const timeoutId = setTimeout(() => {
                setNoDataMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        if (successPostMessage) {
            const timeoutId = setTimeout(() => {
                setSuccessPostMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
    }, [noDataMessage, successPostMessage]);
    useEffect(() => {
        var settingIcon = document.getElementById("setting-icon");

        if(showSetting){
            //change the down icon to up
            settingIcon.setAttribute("data-testid", "KeyboardArrowUpIcon"); //Up Arrow Test ID
            settingIcon.children[0].setAttribute("d", `M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6z`); // Up Arrow.Path d attribute    
        } else {
            //change the up icon to down
            settingIcon.setAttribute("data-testid", "KeyboardArrowDownIcon"); // Down Arrow Test ID
            settingIcon.children[0].setAttribute("d", `M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z`); // Down Arrow.Path d attribute
        }

        const handleClickOutside = (event) => {
            if (settingRef.current && !settingRef.current.contains(event.target)) {
                if(buttonRef.current && !buttonRef.current.contains(event.target)){
                    setShowSetting(false);
                }
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };


    }, [showSetting]);
    
    const generateDownloadTemplate = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet();

        const header = ['EmployeeId', 'EmployeeName', 'Description', 'Amount'];
        const headerRow = worksheet.addRow(header);
        worksheet.columns = [
            { key: 'employeePersonalInformationEmployeeId', width: 30 },
            { key: 'employeePersonalInformationFullName', width: 30 },
            { key: 'description', width: 30 },
            { key: 'amount', width: 30 },
        ];
        headerRow.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });

        worksheet.addRow(['<EMP1234>', '<LastName, FirstName>', '<Description>', '<500.00>']);

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'Template.xlsx');
    };
    const generateDownloadAdjustmentTemplate = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet();

        const header = ['EmployeeId', 'EmployeeName', 'Description', 'Amount', 'AdjustmentDate', 'ReferenceId'];
        const headerRow = worksheet.addRow(header);
        worksheet.columns = [
            { key: 'employeePersonalInformationEmployeeId', width: 30 },
            { key: 'employeePersonalInformationFullName', width: 30 },
            { key: 'description', width: 30 },
            { key: 'amount', width: 30 },
            { key: 'adjustmentDate', width: 30 },
            { key: 'referenceId', width: 20 },
        ];
        headerRow.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });

        worksheet.addRow(['<EMP1234>', '<LastName, FirstName>', '<Description>', '<500.00>', '<mm/dd/yyyy>', '<REF00001>']);

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'Template.xlsx');
    };
    const generateDownloadNightDiffTemplate = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet();

        const header = ['EmployeeId', 'EmployeeName', 'Amount'];
        const headerRow = worksheet.addRow(header);
        worksheet.columns = [
            { key: 'employeePersonalInformationEmployeeId', width: 30 },
            { key: 'employeePersonalInformationFullName', width: 30 },
            { key: 'amount', width: 30 },
        ];
        headerRow.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });

        worksheet.addRow(['<EMP1234>', '<LastName, FirstName>', '<500.00>']);

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'Template.xlsx');
    };
    //For Upload Part
    const [errorData, setErrorData] = useState([]);
    const [isErrorUpload, setIsErrorUpload] = useState(false);
    const downloadError = useCallback((entries) => {
        const allData = [];

        entries.forEach(entry => {
            const data = [
                [entry.employeeId, entry.employeeName, entry.description, entry.amount, entry.error]
            ];

            allData.push(...data);
        });

        allData.unshift(['EmployeeId', 'EmployeeName', 'Description', 'Amount', 'Error(NOTE: Please delete this column if you want to re-use this worksheet)']);

        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.aoa_to_sheet(allData);
        XLSX.utils.book_append_sheet(workbook, worksheet, 'RegularDataSheet');

        const excelBuffer = XLSX.write(workbook, { type: 'binary', bookType: 'xlsx' });

        const blob = new Blob([s2ab(excelBuffer)], { type: 'application/octet-stream' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.style = 'display: none';
        a.href = url;
        a.download = 'ErrorFile.xlsx';
        a.click();

        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
    }, []);
    const downloadErrorAdjustment = useCallback((entries) => {
        const allData = [];

        entries.forEach(entry => {
            const data = [
                [entry.employeeId, entry.employeeName, entry.description, entry.amount, entry.adjustmentDate, entry.referenceId, entry.error]
            ];

            allData.push(...data);
        });

        allData.unshift(['EmployeeId', 'EmployeeName', 'Description', 'Amount', 'AdjusmentDate', 'ReferenceId', 'Error(NOTE: Please delete this column if you want to re-use this worksheet)']);

        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.aoa_to_sheet(allData);
        XLSX.utils.book_append_sheet(workbook, worksheet, 'RegularDataSheet');

        const excelBuffer = XLSX.write(workbook, { type: 'binary', bookType: 'xlsx' });

        const blob = new Blob([s2ab(excelBuffer)], { type: 'application/octet-stream' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.style = 'display: none';
        a.href = url;
        a.download = 'ErrorFile.xlsx';
        a.click();

        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
    }, []);
    const downloadErrorNightDifferential = useCallback((entries) => {
        const allData = [];

        entries.forEach(entry => {
            const data = [
                [entry.employeeId, entry.employeeName, entry.amount, entry.error]
            ];

            allData.push(...data);
        });

        allData.unshift(['EmployeeId', 'EmployeeName', 'Amount', 'Error(NOTE: Please delete this column if you want to re-use this worksheet)']);

        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.aoa_to_sheet(allData);
        XLSX.utils.book_append_sheet(workbook, worksheet, 'RegularDataSheet');

        const excelBuffer = XLSX.write(workbook, { type: 'binary', bookType: 'xlsx' });

        const blob = new Blob([s2ab(excelBuffer)], { type: 'application/octet-stream' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.style = 'display: none';
        a.href = url;
        a.download = 'ErrorFile.xlsx';
        a.click();

        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
    }, []);
    function parseExcelFile(file, type) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
        
            reader.onload = (e) => {
                try {
                    const binaryString = e.target.result;
                    const workbook = XLSX.read(binaryString, { type: 'binary' });
                    const sheetName = workbook.SheetNames[0];
                    const sheet = workbook.Sheets[sheetName];
                    
                    // Get all rows except the first one (header row)
                    const excelData = XLSX.utils.sheet_to_json(sheet, {
                        header: type === "Other Adjustments" ? ['employeeId', 'employeeName', 'description', 'amount', "adjustmentDate", "referenceId"] : 
                                type === "Night Differential" ? ['employeeId', 'employeeName', 'amount'] :
                                        ['employeeId', 'employeeName', 'description', 'amount'],
                        range: 1, // Skip the first row (header row)
                        defval: "" // Include empty cells
                    });
                    
                    resolve(excelData);
                } catch (error) {
                    reject(error);
                }
            };
        
            reader.readAsArrayBuffer(file);
        });
    }
    const handleFileUpload = async (files, type, payrollPeriodId, payTypeId) => {
        if (!files || files.length === 0) {
            console.error('No files selected');
            return;
        }

        const employeeIds = await fetchAllIdsData();

        setLoadingRequest(true);
        let finalData = [];
        
        const file = files[0];
        var apiUrl = "";
        if(type === "Other Additions"){
            apiUrl =  domain + "/api/OtherAdditionStaging/bulk";
        } else if(type === "Other Deductions"){
            apiUrl =  domain + "/api/OtherDeductionStaging/bulk";
        } else if(type === "Other Adjustments"){
            apiUrl =  domain + "/api/OtherAdjustmentStaging/bulk";
        } else if(type === "Night Differential"){
            apiUrl =  domain + "/api/NightDifferentialsStaging/bulk";
        }
        
        parseExcelFile(file, type)
        .then(async (data) => {
            let isError = false;

            data.forEach((entry) => {
                let errorMsg = "";

                for (let i = 0; i < Object.keys(entry).length; i++) {
                    const header = Object.keys(entry)[i];
                    const values = Object.values(entry)[i];
                    if(values === null 
                        || values === undefined
                        || values === ""
                    ){
                        errorMsg = "Has an empty value. ";
                        setIsErrorUpload(true);
                        isError = true;
                    }

                    if(header === "employeeId"){
                        const foundEmployee = employeeIds.find(employee =>  employee === values.toString());
                        if(!foundEmployee){
                            errorMsg = errorMsg + "Invalid employee id. ";
                            setIsErrorUpload(true);
                            isError = true;
                        }
                    }

                    if(header === "amount"){
                        if(isNaN(values)){
                            errorMsg = errorMsg + "Amount is an invalid value. ";
                            setIsErrorUpload(true);
                            isError = true;
                        }
                    }

                    if (type === "Other Adjustments") {
                        /* if(header === "noOfHours"){
                            if(isNaN(values)){
                                errorMsg = errorMsg + "Number of hours is an invalid value. ";
                                setIsErrorUpload(true);
                                isError = true;
                            }
                        } */

                        if (header === "adjustmentDate") { 
                            console.log(values);
                            
                            // Check if values is NOT a valid date
                            if (isNaN(Date.parse(values))) {  
                                errorMsg = errorMsg + "Invalid adjustment date. ";
                                setIsErrorUpload(true);
                                isError = true;
                            }
                        }
                            

                        /* if(header === "referenceId"){
                            if(isNaN(values)){
                                errorMsg = errorMsg + "Invalid reference id. ";
                                setIsErrorUpload(true);
                                isError = true;
                            }
                        } */
                    }
                }

                const newErrorData = {
                    employeeId: entry.employeeId,
                    employeeName: entry.employeeName,
                    ...(type !== "Night Differential" && { description: entry.description }),
                    amount: entry.amount,
                    ...(type === "Other Adjustments" && { adjustmentDate: entry.adjustmentDate }),
                    ...(type === "Other Adjustments" && { referenceId:  entry.referenceId }),
                    error: errorMsg 
                };

                setErrorData(prevErrorData => [...prevErrorData, newErrorData]);
            });

            if(isError) {
                return;
            }

            const extractNumber = (referenceId) => {
                // Extract digits using regex
                const match = referenceId.match(/\d+/);
                
                // Check if match exists, remove leading zeros, and convert to integer
                return match ? parseInt(match[0], 10) : 0;
            };
            

            data.forEach((entry) => {
                let adjustmentDateFormatted = ""

                if (type === "Other Adjustments") {
                    const parts = entry.adjustmentDate.split('/');

                    const formattedDate = `${parts[2]}-${parts[0].padStart(2, '0')}-${parts[1].padStart(2, '0')}T00:00`;

                    adjustmentDateFormatted = formattedDate;
                }
                
                const _data = {
                    employeePersonalInformationEmployeeId: entry.employeeId.toString(),
                    payrollPeriodId: parseInt(payrollPeriodId),
                    payTypeId: parseInt(payTypeId),
                    ...(type !== "Night Differential" && { description: entry.description }),
                    amount: parseInt(entry.amount),
                    ...(type === "Other Adjustments" && { adjustmentDate: adjustmentDateFormatted }),
                    ...(type === "Other Adjustments" && { referenceId:  extractNumber(entry.referenceId) }),
                    ...(type === "Other Adjustments" && { transactionType:  "Leave" }),
                };

                finalData.push(_data);
            });

            console.log('Final bulkData:', JSON.stringify(finalData, null, 2));

            try {
                axios.post(apiUrl, finalData, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                })

                let field = "";

                if(type === "Other Additions"){
                    field = "Upload Other Additions";
                } else if(type === "Other Deductions"){
                    field = "Upload Other Deductions";
                } else if(type === "Other Adjustments"){
                    field = "Upload Other Adjustments";
                } else if(type === "Night Differential"){
                    field = "Upload Night Differential";
                }

                await SetAuditTrail({
                    setupArea: "Payroll", 
                    actionTaken: "insert", 
                    field: field, 
                    newValue: "[bulk data]", 
                    oldValue: "-", 
                    dateSaved: new Date(), 
                    savedById: user.id
                });

                setTimeout(async () => {
                    await fetchAdditionData();
                    await fetchDeductionData();
                    await fetchAdjustmentData();
                    await fetchNightDiffData();
                    await fetchDataProcessedPayroll();
                }, 1000);

                setShowRequestMessage(true);
                setIsSuccess(true);
                setIsUpload(true);
                setIsErrorUpload(false);
                setErrorData([]);
                
        
            } catch (error) {
                console.error('Error parsing Excel file:', error);
                setShowRequestMessage(true);
                setIsSuccess(false);
                
                if (error.response && error.response.data && error.response.data.errors) {
                    const errorMessage = error.response.data.errors["$"][0]; // Accessing the error message
                    setRequestMessage(errorMessage);
                } else if (error.response && error.response.data && error.response.data.message) {
                    const errorMessage = error.response.data.message; // Fallback to general message
                    setRequestMessage(errorMessage);
                } else {
                    setRequestMessage("An unknown error occurred."); // Default message
                }
            }
        })
        .catch((error) => {
            setLoadingRequest(false);
            console.error('Error parsing Excel file:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        });

        setLoadingRequest(false)
    }
    
    useEffect(() => {
        if(isErrorUpload){
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage('Please check the ErrorFile.xlsx');
            setIsUpload(false);
            setIsErrorUpload(false);
            setErrorData([]);

            if(settingType === "Other Adjustments"){
                downloadErrorAdjustment(errorData);
            } else if(settingType === "Night Differential"){
                downloadErrorNightDifferential(errorData);
            } else {
                downloadError(errorData);
            }
        }
    }, [isErrorUpload, downloadError, downloadErrorAdjustment, downloadErrorNightDifferential, errorData, settingType]);

    const openUploadFormHandleClick = () =>{
        setShowUploadForm(true);
    }
    const closeUploadFormHandleClick = () =>{
        setShowUploadForm(false);
    }
    const openRevertPayrollForm = () =>{
        setShowRevertPayrollForm(true);
    }
    const closeRevertPayrollForm = () =>{
        setShowRevertPayrollForm(false);
    }
    const openProcessPayrollForm = () =>{
        setShowProcessPayrollForm(true);
    }
    const closeProcessPayrollForm = () =>{
        setShowProcessPayrollForm(false);
    }
    const openPostPayrollForm = () =>{
        setShowPostPayrollForm(true);
    }
    const closePostPayrollForm = () =>{
        setShowPostPayrollForm(false);
    }
    
    const s2ab = s => {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
    };
    
    const [currentFilterPayTypeIdPayTypeId, setCurrentFilterPayTypeIdPayTypeId] = useState("");
    useEffect(() => {
        if(currentFilterPayTypeIdPayTypeId !== filterPayTypeId){
            setCurrentFilterPayTypeIdPayTypeId(filterPayTypeId);
            setFilterClassificationId("");
            setFilterPayrollPeriodId("");
        }
    }, [currentFilterPayTypeIdPayTypeId, filterPayTypeId])

    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                    <div className="PayrollInfo">
                        <div className='sub-title row' style={{padding:"5px 20px"}}>
                            <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Payroll >"} </span>
                            <span style={{borderBottom:"1px solid black"}}>{"Process Payroll"}</span>
                        </div>
                        <div className="payrollHeader row">
                            <div style={{width:"70%", color:"#668fca"}} className='payroll-title row'>
                                <PaidIcon style={{padding:"0 10px 0 0"}}/>
                                <h3>Process Payroll</h3>
                            </div>
                            <div style={{width:"30%",textAlign:"right"}}>
                                <button ref={buttonRef} onClick={handleSetting} title="Setting" type="button" className="setting">
                                    <SettingsIcon/>
                                    <KeyboardArrowDownIcon id="setting-icon"/>
                                </button>
                                <div ref={settingRef}>
                                    {showSetting && 
                                        <SettingInit
                                        generateDownloadTemplate={generateDownloadTemplate}
                                        generateDownloadAdjustmentTemplate={generateDownloadAdjustmentTemplate}
                                        generateDownloadNightDiffTemplate={generateDownloadNightDiffTemplate}
                                        openUploadFormHandleClick={openUploadFormHandleClick}
                                        openRevertPayrollForm={openRevertPayrollForm}
                                        openProcessPayrollForm={openProcessPayrollForm}
                                        openPostPayrollForm={openPostPayrollForm}
                                        setSettingType={setSettingType}
                                        />}
                                </div>
                                
                            </div>
                        </div>
                        <div className="payroll-body">
                            <div style={{padding:"10px"}}>
                                <div className='filters-payroll'>
                                    <span>Filter</span>
                                    <div className="payroll-item-holder info-item-holder row" style={{justifyContent:"space-evenly", padding: "0 10px 20px 10px"}}>
                                        <div className="filter-item-payroll popUp-item info-item column">
                                            <div className="info-item-label">Pay Type</div>
                                            <div className="info-item-input">
                                                <PayTypeIdSelect payTypeId={filterPayTypeId} setPayTypeId={setFilterPayTypeId}/>
                                            </div>
                                            <span style={{
                                                visibility: "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up Pay Type first
                                            </span>
                                        </div>
                                        <div className="filter-item-payroll popUp-item info-item column">
                                            <div className="info-item-label">Payroll Period</div>
                                            <div className="info-item-input">
                                                <PayrollPeriodIdSelectFilter payrollPeriodId={filterPayrollPeriodId} setPayrollPeriodId={setFilterPayrollPeriodId} payTypeId={filterPayTypeId}/>
                                            </div>
                                            <span style={{
                                                visibility: !filterPayTypeId ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up Pay Type first
                                            </span>
                                        </div>
                                        { userAccess.length <= 0 &&
                                            <div className="filter-item-payroll popUp-item info-item column">
                                                <div className="info-item-label">Classification Type</div>
                                                <div className="info-item-input">
                                                    <ClassificationIdSelectDummy/>
                                                </div>
                                                <span style={{
                                                    visibility: "hidden",
                                                    color:"#ff6565", 
                                                    fontSize:"12px"}}>Please fill up Pay Type first
                                                </span>
                                            </div>
                                        }
                                        <div className="filter-item-payroll popUp-item info-item column">
                                            <div className="info-item-label">Classification Type</div>
                                            <div className="info-item-input">
                                                <ClassificationIdSelectFilter classificationId={filterClassificationId} setClassificationId={setFilterClassificationId} payTypeId={filterPayTypeId}/>
                                            </div>
                                            <span style={{
                                                visibility: !filterPayTypeId ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up Pay Type first
                                            </span>
                                        </div>
                                        
                                        <div className="filter-item-payroll popUp-item info-item column"  style={{display: "none"}}>
                                            <div className="info-item-label">Location</div>
                                            <div className="info-item-input">
                                                <LocationIdSelect2 locationId={filterLocationId} setLocationId={setFilterLocationId}/>
                                            </div>
                                            <span style={{
                                                visibility: "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up Pay Type first
                                            </span>
                                        </div>
                                    </div>
                                    <div className="rightSide-btn" style={{marginRight:"5px"}}>{CreateButton("", "generate row", handleGenerate, "GENERATE", RestartAltIcon)}</div>
                                </div>
                            </div>
                            <ShowTab
                                    type={type}
                                    setType={setType}
                                    filterPayrollPeriodId={filterPayrollPeriodId}
                                    filterPayTypeId={filterPayTypeId}
                                    filterClassificationId={filterClassificationId}
                                    userAccess={userAccess}
                                    payrollData={payrollData}
                                    setPayrollData={setPayrollData}
                                    payrollDataAdjustment={payrollDataAdjustment}
                                    setPayrollDataAdjustment={setPayrollDataAdjustment}
                                    otherAdditionData={otherAdditionData}
                                    otherDeductionData={otherDeductionData}
                                    otherAdjustmentData={otherAdjustmentData}
                                    otherNightDiff={otherNightDiff}
                                    setOtherAdditionData={setOtherAdditionData}
                                    setOtherDeductionData={setOtherDeductionData}
                                    setOtherAdjustmentData={setOtherAdjustmentData}
                                    setOtherNightDiff={setOtherNightDiff}
                                    showPostMessage={showPostMessage}
                                    isGenerate={isGenerate}
                                    setIsGenerate={setIsGenerate}
                                    isRevert={isRevert}
                                    isProcess={isProcess}
                                    isPost={isPost}
                                    isUpload={isUpload}
                                    setIsUpload={setIsUpload}

                                    loading={loading}
                                    fetchData={fetchDataProcessedPayroll}
                                    filterData={filterData}
                                    loadingOtherAddition={loadingOtherAddition}
                                    loadingOtherDedujction={loadingOtherDedujction}
                                    loadingAdjustment={loadingAdjustment}
                                    loadingNightDiff={loadingNightDiff}
                                    filterDataAddition={filterDataAddition}
                                    filterDataDeduction={filterDataDeduction}
                                    filterDataAdjustment={filterDataAdjustment}
                                    filterDataNightDiff={filterDataNightDiff}
                                    fetchAdditionData={fetchAdditionData}
                                    fetchDeductionData={fetchDeductionData}
                                    fetchAdjustmentData={fetchAdjustmentData}
                                    fetchNightDiffData={fetchNightDiffData}
                                    fetchDataProcessedPayroll={fetchDataProcessedPayroll}
                                    user={user}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <UploadForm  isOpen={showUploadForm} 
                    onClose={closeUploadFormHandleClick}
                    payrollPeriodId={payrollIdForUpload}
                    payTypeId={payTypeIdForUpload}
                    setPayrollPeriodId={setPayrollIdForUpload}
                    setPayTypeId={setPayTypeIdForUpload}
                    type={settingType}
                    handleFileUpload={handleFileUpload}
            >
            </UploadForm>
            <PostMessage  isOpen={showPostMessage} 
                    onClose={closePostMessage}
                    handlePost={handlePost}
            >
            </PostMessage>
            <RevertPayrollForm  isOpen={showRevertPayrollForm} 
                    onClose={closeRevertPayrollForm}
                    fetchOtherAddition={fetchAdditionData}
                    fetchOtherDeduction={fetchDeductionData}
                    fetchOtherAdjustment={fetchAdjustmentData}
                    fetchNightDiffData={fetchNightDiffData}
                    fetchProcess={fetchDataProcessedPayroll}
                    setIsRevert={setIsRevert}
                    isGenerate={isGenerate}
                    user={user}
            >
            </RevertPayrollForm>
            <ProcessPayrollForm  isOpen={showProcessPayrollForm} 
                    onClose={closeProcessPayrollForm}
                    fetchOtherAddition={fetchAdditionData}
                    fetchOtherDeduction={fetchDeductionData}
                    fetchOtherAdjustment={fetchAdjustmentData}
                    fetchNightDiffData={fetchNightDiffData}
                    fetchProcess={fetchDataProcessedPayroll}
                    setIsProcess={setIsProcess}
                    isGenerate={isGenerate}
                    user={user}
            >
            </ProcessPayrollForm>
            <PostPayrollForm  isOpen={showPostPayrollForm} 
                    onClose={closePostPayrollForm}
                    fetchOtherAddition={fetchAdditionData}
                    fetchOtherDeduction={fetchDeductionData}
                    fetchOtherAdjustment={fetchAdjustmentData}
                    fetchNightDiffData={fetchNightDiffData}
                    fetchProcess={fetchDataProcessedPayroll}
                    setIsPost={setIsPost}
                    isGenerate={isGenerate}
                    user={user}
            >
            </PostPayrollForm>
            <GenerateMessage form={noDataMessage}
                message={"No data to post!"}
                isSuccess={false}
            > 
            </GenerateMessage>
            <GenerateMessage form={successPostMessage}
                    message={"Data posted!"}
                    isSuccess={true}
            > 
            </GenerateMessage>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            <GenerateMessage form={generateMessage}
                    message={"Please select payroll period, pay type and classification type!"}
                    isSuccess={false}
            > 
            </GenerateMessage>
            {loadingRequest ? (
            <div style={{ position:"fixed", top:"50%", left:"50%", transform:"translate(-50%, -50%)", zIndex:"3005"}}>
                    <img src={loadingSpinner} alt="Loading..." />
                </div>
            ) : (
                <></>
                )
            }
        </div>
    )
}

function ShowTab({
    type,
    setType,
    filterPayrollPeriodId,
    filterPayTypeId,
    filterClassificationId,
    userAccess,
    payrollData, 
    setPayrollData,
    payrollDataAdjustment, 
    setPayrollDataAdjustment,
    otherAdditionData,
    otherDeductionData,
    otherAdjustmentData,
    otherNightDiff,
    setOtherAdditionData,
    setOtherDeductionData,
    setOtherAdjustmentData,
    setOtherNightDiff,
    showPostMessage,
    isGenerate,
    setIsGenerate,
    isRevert,
    isProcess,
    isPost,
    isUpload,
    setIsUpload,

    loading,
    fetchData,
    filterData,
    loadingOtherAddition,
    loadingOtherDedujction,
    loadingAdjustment,
    loadingNightDiff,
    filterDataAddition,
    filterDataDeduction,
    filterDataAdjustment,
    filterDataNightDiff,
    fetchAdditionData,
    fetchDeductionData,
    fetchAdjustmentData,
    fetchNightDiffData,
    fetchDataProcessedPayroll,
    user
}){

    console.log({payrollData})
    var processedHeader = [
        "Id",
        "Employee Id",
        "Name",
        "Classification",
        "Pay Type",
        "Total Basic",
        "Rate",
        "Total Days",
        "Days Absent",
        "Absent/s",
        "Days Leave",
        "Leave/s",
        "Hours Undertime",
        "Undertime",
        "Hours Late",
        "Late",
        "Hours Night Differential",
        "Night Differential",
        "Night Differential Adjustment",
        "Allowance",
        "Benefits",
        "Benefits List",
        "Total Days Regular Holidays",
        "Total Regular Holiday Worked",
        "Total Regular Holidays",
        "Total Days Special Non-Working Holidays",
        "Total Special Non-Working Holidays",
        "Hours OT Regular",
        "Total OT Regular",
        // "Hours OT Exceeded",
        // "Total OT Exceeded",
        "Hours OT Restday",
        "Total OT Restday",
        // "Hours Exceeded",
        // "Total Exceeded",
        "Hours Holiday Special",
        "Total Holiday Special",
        // "Hours Exceeded",
        // "Total Exceeded",
        "Hours Holiday Regular",
        "Total Holiday Regular",
        // "Hours Exceeded",
        // "Total Exceeded",
        "Hours Restday Holiday Special",
        "Total Restday Holiday Special",
        // "Hours Exceeded",
        // "Total Exceeded",
        "Hours Restday Holiday Regular",
        "Total Restday Holiday Regular",
        "Total OT Food Allowance",
        // "Hours Exceeded",
        // "Total Exceeded",
        "SSS",
        "Pagibig",
        "Philhealth",
        "SSS Loan",
        "SSS Calamity Loan",
        "Pagibig Loan",
        "Pagibig Calamity Loan",
        "Cash Advance",
        "Other Cash Advance",
        "Other Cash Advance List",
        "Company Loans",
        "Company Loans List",
        "Tax",
        "Additions",
        "Exterior Works",
        "Addback",
        "Deductions",
        "VALE",
        "Adjustments",
        "Total Gross Pay",
        "Total Net Pay",
        "Date Processed",
        // "User ID",
        // ""
    ]
    var processedAccessor = [
        "id",
        "employeePersonalInformationEmployeeId",
        "employeePersonalInformationFullName",
        "classificationDescription",
        "payTypeDescription",
        "totalBasic",
        "rate",
        "totalDays",
        "totalDaysAbsents",
        "totalAbsents",
        "totalDaysLeaves",
        "totalLeaves",
        "totalHoursUndertime",
        "totalUndertime",
        "totalHoursLate",
        "totalLate",
        "totalNighDiff",
        "totalNighDiffAmount",
        "totalNightDiffAdjustment",
        "totalAllowance",
        "totalBenefits",
        "benefits",
        "totalDaysRegularHolidays",
        "totalRegularHolidayWorked",
        "totalRegularHolidays",
        "totalDaysSpecialNonWorkingHolidays",
        "totalSpecialNonWorkingHolidays",
        "totalHoursOTRegular",
        "totalOTRegular",
        // "totalHoursOTRegularExceeded",
        // "totalOTRegularExceeded",
        "totalHoursOTRestday",
        "totalOTRestday",
        // "totalHoursOTRestdayExceeded",
        // "totalOTRestdayExceeded",
        "totalHoursOTHolidaySpecial",
        "totalOTHolidaySpecial",
        // "totalHoursOTHolidaySpecialExceeded",
        // "totalOTHolidaySpecialExceeded",
        "totalHoursOTHolidayRegular",
        "totalOTHolidayRegular",
        // "totalHoursOTHolidayRegularExceeded",
        // "totalOTHolidayRegularExceeded",
        "totalHoursOTRestdayHolidaySpecial",
        "totalOTRestdayHolidaySpecial",
        // "totalHoursOTRestdayHolidaySpecialExceeded",
        // "totalOTRestdayHolidaySpecialExceeded",
        "totalHoursOTRestdayHolidayRegular",
        "totalOTRestdayHolidayRegular",
        "otFoodAllowance",
        // "totalHoursOTRestdayHolidayRegularExceeded",
        // "totalOTRestdayHolidayRegularExceeded",
        "totalSSS",
        "totalPagibig",
        "totalPhilhealth",
        "totalSSSLoan",
        "totalSSSCalamityLoan",
        "totalPagibigLoan",
        "totalPagibigCalamityLoan",
        "totalCashAdvance",
        "totalOtherCashAdvance",
        "otherCashAdvances",
        "totalCompanyLoan",
        "companyLoans",
        "totalTax",
        "totalAddition",
        "additionExteriorWorks",
        "additionAddback",
        "totalDeduction",
        "deductionVale",
        "totalAdjustment",
        "totalGrossPay",
        "totalNetPay",
        "dateProcessed",
        // "userId",
        // "manage"
    ]
    const [currentPage, setCurrentPage] = useState(1);
    const [loadingRequest, setLoadingRequest] = useState(false);
    const [selectedTab, setSelectedTab] = useState(0);
    // Add
    const [showAddForm, setShowAddForm] = useState(false);
    const [payrollPeriodId, setPayrollPeriodId] = useState("");
    const [employeePersonalInformationId, setEmployeePersonalInformationId] = useState("");
    const [employeePersonalInformationFullName, setEmployeePersonalInformationFullName] = useState("");
    const [payTypeId, setPayTypeId] = useState("");
    const [totalEcola, setTotalEcola] = useState("");
    const [totalAllowance, setTotalAllowance] = useState("");
    const [totalTax, setTotalTax] = useState("");
    const [totalDays, setTotalDays] = useState("");
    const [totalDaysAbsents, setTotalDaysAbsents] = useState("");
    const [totalAbsents, setTotalAbsents] = useState("");
    const [totalDaysLeaves, setTotalDaysLeaves] = useState("");
    const [totalLeaves, setTotalLeaves] = useState("");
    const [totalDeduction, setTotalDeduction] = useState("");
    const [totalAddition, setTotalAddition] = useState("");
    const [totalAdjustment, setTotalAdjustment] = useState("");
    const [rate, setRate] = useState("");
    const [totalNighDiff, setTotalNighDiff] = useState("");
    const [totalHoursOTRegular, setTotalHoursOTRegular] = useState("");
    const [totalOTRegular, setTotalOTRegular] = useState("");
    const [totalHoursOTRegularExceeded, setTotalHoursOTRegularExceeded] = useState("");
    const [totalOTRegularExceeded, setTotalOTRegularExceeded] = useState("");
    const [totalHoursOTRestday, setTotalHoursOTRestday] = useState("");
    const [totalOTRestday, setTotalOTRestday] = useState("");
    const [totalHoursOTRestdayExceeded, setTotalHoursOTRestdayExceeded] = useState("");
    const [totalOTRestdayExceeded, setTotalOTRestdayExceeded] = useState("");
    const [totalHoursOTHolidaySpecial, setTotalHoursOTHolidaySpecial] = useState("");
    const [totalOTHolidaySpecial, setTotalOTHolidaySpecial] = useState("");
    const [totalHoursOTHolidaySpecialExceeded, setTotalHoursOTHolidaySpecialExceeded] = useState("");
    const [totalOTHolidaySpecialExceeded, setTotalOTHolidaySpecialExceeded] = useState("");
    const [totalHoursOTHolidayRegular, setTotalHoursOTHolidayRegular] = useState("");
    const [totalOTHolidayRegular, setTotalOTHolidayRegular] = useState("");
    const [totalHoursOTHolidayRegularExceeded, setTotalHoursOTHolidayRegularExceeded] = useState("");
    const [totalOTHolidayRegularExceeded, setTotalOTHolidayRegularExceeded] = useState("");
    const [totalHoursOTRestdayHolidaySpecial, setTotalHoursOTRestdayHolidaySpecial] = useState("");
    const [totalOTRestdayHolidaySpecial, setTotalOTRestdayHolidaySpecial] = useState("");
    const [totalHoursOTRestdayHolidaySpecialExceeded, setTotalHoursOTRestdayHolidaySpecialExceeded] = useState("");
    const [totalOTRestdayHolidaySpecialExceeded, setTotalOTRestdayHolidaySpecialExceeded] = useState("");
    const [totalHoursOTRestdayHolidayRegular, setTotalHoursOTRestdayHolidayRegular] = useState("");
    const [totalOTRestdayHolidayRegular, setTotalOTRestdayHolidayRegular] = useState("");
    const [totalHoursOTRestdayHolidayRegularExceeded, setTotalHoursOTRestdayHolidayRegularExceeded] = useState("");
    const [totalOTRestdayHolidayRegularExceeded, setTotalOTRestdayHolidayRegularExceeded] = useState("");
    const [totalSSS, setTotalSSS] = useState("");
    const [totalPagibig, setTotalPagibig] = useState("");
    const [totalPhilhealth, setTotalPhilhealth] = useState("");
    const [totalHoursUndertime, setTotalHoursUndertime] = useState("");
    const [totalUndertime, setTotalUndertime] = useState("");
    const [totalHoursLate, setTotalHoursLate] = useState("");
    const [totalLate, setTotalLate] = useState("");
    const [totalBasic, setTotalBasic] = useState("");
    const [totalGrossPay, setTotalGrossPay] = useState("");
    const [totalNetPay, setTotalNetPay] = useState("");
    const [dateProcessed, setDateProcessed] = useState("");
    const [userId, setUserId] = useState("");
    //Update
    const [showEditForm, setShowEditForm] = useState(false);
    const [editById, setEditById] = useState("");
    const [dataToEdit, setDataToEdit] = useState([]);
    // Delete
    const [showDeleteForm, setShowDeleteForm] = useState(false);
    const [deleteById, setDeleteById] = useState([]);
    // Delete All
    const [showDeleteAllForm, setShowDeleteAllForm] = useState(false);
    const [payrollIdForDelete, setPayrollIdForDelete] = useState("");

    const [showEmployeeForm, setShowEmployeeForm] = useState(false);
    // const [generateMessage, setGenerateMessage] = useState(false);
    const [successPostMessage, setSuccessPostMessage] = useState(false);
    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);

    const apiUrl =  domain + "/api/PayrollSummaryStaging/";

    const handleFilter = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();
        var res  = filterData.filter((f) =>
                f.employeePersonalInformationFullName.toLowerCase().includes(lowercaseValue)
                );

        setPayrollData(res);
    };
    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!payrollPeriodId || !employeePersonalInformationId || !payTypeId) {
            alert("Required to fill up all data");
            return; // Exit early if fields are empty
        }

        const currentDate = new Date();

        const data = {
            payrollPeriodId: payrollPeriodId,
            employeePersonalInformationId: employeePersonalInformationId,
            payTypeId: payTypeId,
            totalEcola: totalEcola ? totalEcola : 0,
            totalAllowance: totalAllowance ? totalAllowance : 0,
            totalTax: totalTax ? totalTax : 0,
            totalDays: totalDays ? totalDays : 0,
            totalDaysAbsents: totalDaysAbsents ? totalDaysAbsents : 0,
            totalAbsents: totalAbsents ? totalAbsents : 0,
            totalDaysLeaves: totalDaysLeaves ? totalDaysLeaves : 0,
            totalLeaves: totalLeaves ? totalLeaves : 0,
            totalDeduction: totalDeduction ? totalDeduction : 0,
            totalAddition: totalAddition ? totalAddition : 0,
            totalAdjustment: totalAdjustment ? totalAdjustment : 0,
            rate: rate ? rate : 0,
            totalNighDiff: totalNighDiff ? totalNighDiff : 0,
            totalHoursOTRegular: totalHoursOTRegular ? totalHoursOTRegular : 0,
            totalOTRegular: totalOTRegular ? totalOTRegular : 0,
            totalHoursOTRegularExceeded: totalHoursOTRegularExceeded ? totalHoursOTRegularExceeded : 0,
            totalOTRegularExceeded: totalOTRegularExceeded ? totalOTRegularExceeded : 0,
            totalHoursOTRestday: totalHoursOTRestday ? totalHoursOTRestday : 0,
            totalOTRestday: totalOTRestday ? totalOTRestday : 0,
            totalHoursOTRestdayExceeded: totalHoursOTRestdayExceeded ? totalHoursOTRestdayExceeded : 0,
            totalOTRestdayExceeded: totalOTRestdayExceeded ? totalOTRestdayExceeded : 0,
            totalHoursOTHolidaySpecial: totalHoursOTHolidaySpecial ? totalHoursOTHolidaySpecial : 0,
            totalOTHolidaySpecial: totalOTHolidaySpecial ? totalOTHolidaySpecial : 0,
            totalHoursOTHolidaySpecialExceeded: totalHoursOTHolidaySpecialExceeded ? totalHoursOTHolidaySpecialExceeded : 0,
            totalOTHolidaySpecialExceeded: totalOTHolidaySpecialExceeded ? totalOTHolidaySpecialExceeded : 0,
            totalHoursOTHolidayRegular: totalHoursOTHolidayRegular ? totalHoursOTHolidayRegular : 0,
            totalOTHolidayRegular: totalOTHolidayRegular ? totalOTHolidayRegular : 0,
            totalHoursOTHolidayRegularExceeded: totalHoursOTHolidayRegularExceeded ? totalHoursOTHolidayRegularExceeded : 0,
            totalOTHolidayRegularExceeded: totalOTHolidayRegularExceeded ? totalOTHolidayRegularExceeded : 0,
            totalHoursOTRestdayHolidaySpecial: totalHoursOTRestdayHolidaySpecial ? totalHoursOTRestdayHolidaySpecial : 0,
            totalOTRestdayHolidaySpecial: totalOTRestdayHolidaySpecial ? totalOTRestdayHolidaySpecial : 0,
            totalHoursOTRestdayHolidaySpecialExceeded: totalHoursOTRestdayHolidaySpecialExceeded ? totalHoursOTRestdayHolidaySpecialExceeded : 0,
            totalOTRestdayHolidaySpecialExceeded: totalOTRestdayHolidaySpecialExceeded ? totalOTRestdayHolidaySpecialExceeded : 0,
            totalHoursOTRestdayHolidayRegular: totalHoursOTRestdayHolidayRegular ? totalHoursOTRestdayHolidayRegular : 0,
            totalOTRestdayHolidayRegular: totalOTRestdayHolidayRegular ? totalOTRestdayHolidayRegular : 0,
            totalHoursOTRestdayHolidayRegularExceeded: totalHoursOTRestdayHolidayRegularExceeded ? totalHoursOTRestdayHolidayRegularExceeded : 0,
            totalOTRestdayHolidayRegularExceeded: totalOTRestdayHolidayRegularExceeded ? totalOTRestdayHolidayRegularExceeded : 0,
            totalSSS: totalSSS ? totalSSS : 0,
            totalPagibig: totalPagibig ? totalPagibig : 0,
            totalPhilhealth: totalPhilhealth ? totalPhilhealth : 0,
            totalHoursUndertime: totalHoursUndertime ? totalHoursUndertime : 0,
            totalUndertime: totalUndertime ? totalUndertime : 0,
            totalHoursLate: totalHoursLate ? totalHoursLate : 0,
            totalLate: totalLate ? totalLate : 0,
            totalBasic: totalBasic ? totalBasic : 0,
            totalGrossPay: totalGrossPay ? totalGrossPay : 0,
            totalNetPay: totalNetPay ? totalNetPay : 0,
            dateProcessed: currentDate,
            userId: userId ? userId : 0
        };

        try {
            setLoadingRequest(true);
            await axios.post(apiUrl, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            console.log('Data added successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);
            
            // Reload table data and reset form fields
            await fetchData(); // Assuming fetchData() fetches the updated data for the table
            setPayrollPeriodId("");
            setEmployeePersonalInformationId("");
            setPayTypeId("");
            setTotalEcola("");
            setTotalAllowance("");
            setTotalTax("");
            setTotalDays("");
            setTotalDaysAbsents("");
            setTotalAbsents("");
            setTotalDaysLeaves("");
            setTotalLeaves("");
            setTotalDeduction("");
            setTotalAddition("");
            setTotalAdjustment("");
            setRate("");
            setTotalNighDiff("");
            setTotalHoursOTRegular("");
            setTotalOTRegular("");
            setTotalHoursOTRegularExceeded("");
            setTotalOTRegularExceeded("");
            setTotalHoursOTRestday("");
            setTotalOTRestday("");
            setTotalHoursOTRestdayExceeded("");
            setTotalOTRestdayExceeded("");
            setTotalHoursOTHolidaySpecial("");
            setTotalOTHolidaySpecial("");
            setTotalHoursOTHolidaySpecialExceeded("");
            setTotalOTHolidaySpecialExceeded("");
            setTotalHoursOTHolidayRegular("");
            setTotalOTHolidayRegular("");
            setTotalHoursOTHolidayRegularExceeded("");
            setTotalOTHolidayRegularExceeded("");
            setTotalHoursOTRestdayHolidaySpecial("");
            setTotalOTRestdayHolidaySpecial("");
            setTotalHoursOTRestdayHolidaySpecialExceeded("");
            setTotalOTRestdayHolidaySpecialExceeded("");
            setTotalHoursOTRestdayHolidayRegular("");
            setTotalOTRestdayHolidayRegular("");
            setTotalHoursOTRestdayHolidayRegularExceeded("");
            setTotalOTRestdayHolidayRegularExceeded("");
            setTotalSSS("");
            setTotalPagibig("");
            setTotalPhilhealth("");
            setTotalHoursUndertime("");
            setTotalUndertime("");
            setTotalHoursLate("");
            setTotalLate("");
            setTotalBasic("");
            setTotalGrossPay("");
            setTotalNetPay("");
            setDateProcessed("");
            setUserId("");
            setShowAddForm(false); // Hide the add form
        } catch (error) {
            console.error('There was a problem adding data:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setShowAddForm(false);
    };
    const handleUpdate = async (event) => {
        event.preventDefault();

        if (!payrollPeriodId || !employeePersonalInformationId || !payTypeId) {
            alert("Required to fill up all data");
            return; // Exit early if fields are empty
        }

        const data = {
            payrollPeriodId: payrollPeriodId,
            employeePersonalInformationId: employeePersonalInformationId,
            payTypeId: payTypeId,
            totalEcola: totalEcola ? totalEcola : 0,
            totalAllowance: totalAllowance ? totalAllowance : 0,
            totalTax: totalTax ? totalTax : 0,
            totalDays: totalDays ? totalDays : 0,
            totalDaysAbsents: totalDaysAbsents ? totalDaysAbsents : 0,
            totalAbsents: totalAbsents ? totalAbsents : 0,
            totalDaysLeaves: totalDaysLeaves ? totalDaysLeaves : 0,
            totalLeaves: totalLeaves ? totalLeaves : 0,
            totalDeduction: totalDeduction ? totalDeduction : 0,
            totalAddition: totalAddition ? totalAddition : 0,
            totalAdjustment: totalAdjustment ? totalAdjustment : 0,
            rate: rate ? rate : 0,
            totalNighDiff: totalNighDiff ? totalNighDiff : 0,
            totalHoursOTRegular: totalHoursOTRegular ? totalHoursOTRegular : 0,
            totalOTRegular: totalOTRegular ? totalOTRegular : 0,
            totalHoursOTRegularExceeded: totalHoursOTRegularExceeded ? totalHoursOTRegularExceeded : 0,
            totalOTRegularExceeded: totalOTRegularExceeded ? totalOTRegularExceeded : 0,
            totalHoursOTRestday: totalHoursOTRestday ? totalHoursOTRestday : 0,
            totalOTRestday: totalOTRestday ? totalOTRestday : 0,
            totalHoursOTRestdayExceeded: totalHoursOTRestdayExceeded ? totalHoursOTRestdayExceeded : 0,
            totalOTRestdayExceeded: totalOTRestdayExceeded ? totalOTRestdayExceeded : 0,
            totalHoursOTHolidaySpecial: totalHoursOTHolidaySpecial ? totalHoursOTHolidaySpecial : 0,
            totalOTHolidaySpecial: totalOTHolidaySpecial ? totalOTHolidaySpecial : 0,
            totalHoursOTHolidaySpecialExceeded: totalHoursOTHolidaySpecialExceeded ? totalHoursOTHolidaySpecialExceeded : 0,
            totalOTHolidaySpecialExceeded: totalOTHolidaySpecialExceeded ? totalOTHolidaySpecialExceeded : 0,
            totalHoursOTHolidayRegular: totalHoursOTHolidayRegular ? totalHoursOTHolidayRegular : 0,
            totalOTHolidayRegular: totalOTHolidayRegular ? totalOTHolidayRegular : 0,
            totalHoursOTHolidayRegularExceeded: totalHoursOTHolidayRegularExceeded ? totalHoursOTHolidayRegularExceeded : 0,
            totalOTHolidayRegularExceeded: totalOTHolidayRegularExceeded ? totalOTHolidayRegularExceeded : 0,
            totalHoursOTRestdayHolidaySpecial: totalHoursOTRestdayHolidaySpecial ? totalHoursOTRestdayHolidaySpecial : 0,
            totalOTRestdayHolidaySpecial: totalOTRestdayHolidaySpecial ? totalOTRestdayHolidaySpecial : 0,
            totalHoursOTRestdayHolidaySpecialExceeded: totalHoursOTRestdayHolidaySpecialExceeded ? totalHoursOTRestdayHolidaySpecialExceeded : 0,
            totalOTRestdayHolidaySpecialExceeded: totalOTRestdayHolidaySpecialExceeded ? totalOTRestdayHolidaySpecialExceeded : 0,
            totalHoursOTRestdayHolidayRegular: totalHoursOTRestdayHolidayRegular ? totalHoursOTRestdayHolidayRegular : 0,
            totalOTRestdayHolidayRegular: totalOTRestdayHolidayRegular ? totalOTRestdayHolidayRegular : 0,
            totalHoursOTRestdayHolidayRegularExceeded: totalHoursOTRestdayHolidayRegularExceeded ? totalHoursOTRestdayHolidayRegularExceeded : 0,
            totalOTRestdayHolidayRegularExceeded: totalOTRestdayHolidayRegularExceeded ? totalOTRestdayHolidayRegularExceeded : 0,
            totalSSS: totalSSS ? totalSSS : 0,
            totalPagibig: totalPagibig ? totalPagibig : 0,
            totalPhilhealth: totalPhilhealth ? totalPhilhealth : 0,
            totalHoursUndertime: totalHoursUndertime ? totalHoursUndertime : 0,
            totalUndertime: totalUndertime ? totalUndertime : 0,
            totalHoursLate: totalHoursLate ? totalHoursLate : 0,
            totalLate: totalLate ? totalLate : 0,
            totalBasic: totalBasic ? totalBasic : 0,
            totalGrossPay: totalGrossPay ? totalGrossPay : 0,
            totalNetPay: totalNetPay ? totalNetPay : 0,
            dateProcessed: dateProcessed,
            userId: userId ? userId : 0
        };

        try {
            setLoadingRequest(true);
            await axios.put(apiUrl + `${editById}`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            console.log('Data added successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);
            
            // Reload table data and reset form fields
            await fetchData(); // Assuming fetchData() fetches the updated data for the table
            setPayrollPeriodId("");
            setEmployeePersonalInformationId("");
            setPayTypeId("");
            setTotalEcola("");
            setTotalAllowance("");
            setTotalTax("");
            setTotalDays("");
            setTotalDaysAbsents("");
            setTotalAbsents("");
            setTotalDaysLeaves("");
            setTotalLeaves("");
            setTotalDeduction("");
            setTotalAddition("");
            setTotalAdjustment("");
            setRate("");
            setTotalNighDiff("");
            setTotalHoursOTRegular("");
            setTotalOTRegular("");
            setTotalHoursOTRegularExceeded("");
            setTotalOTRegularExceeded("");
            setTotalHoursOTRestday("");
            setTotalOTRestday("");
            setTotalHoursOTRestdayExceeded("");
            setTotalOTRestdayExceeded("");
            setTotalHoursOTHolidaySpecial("");
            setTotalOTHolidaySpecial("");
            setTotalHoursOTHolidaySpecialExceeded("");
            setTotalOTHolidaySpecialExceeded("");
            setTotalHoursOTHolidayRegular("");
            setTotalOTHolidayRegular("");
            setTotalHoursOTHolidayRegularExceeded("");
            setTotalOTHolidayRegularExceeded("");
            setTotalHoursOTRestdayHolidaySpecial("");
            setTotalOTRestdayHolidaySpecial("");
            setTotalHoursOTRestdayHolidaySpecialExceeded("");
            setTotalOTRestdayHolidaySpecialExceeded("");
            setTotalHoursOTRestdayHolidayRegular("");
            setTotalOTRestdayHolidayRegular("");
            setTotalHoursOTRestdayHolidayRegularExceeded("");
            setTotalOTRestdayHolidayRegularExceeded("");
            setTotalSSS("");
            setTotalPagibig("");
            setTotalPhilhealth("");
            setTotalHoursUndertime("");
            setTotalUndertime("");
            setTotalHoursLate("");
            setTotalLate("");
            setTotalBasic("");
            setTotalGrossPay("");
            setTotalNetPay("");
            setDateProcessed("");
            setUserId("");
            setShowEditForm(false); // Hide the add form
        } catch (error) {
            console.error('There was a problem adding data:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setShowEditForm(false);
    };
    const handleDelete = async () => {
        try {
            setLoadingRequest(true);
            await axios.delete(apiUrl + `${deleteById}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            console.log('Deleted successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);
        
            // Reload table data and reset state
            await fetchData(); // Assuming fetchData() fetches the updated data for the table
            setShowDeleteForm(false);
            setDeleteById("");
        } catch (error) {
            console.error('There was a problem deleting employee:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }
        
        setShowDeleteForm(false);
    };
    const handleDeleteAll = async () => {
        if (!payrollIdForDelete) {
            alert("Please select payroll period id");
            return; // Exit early if fields are empty
        }

        try {
            setLoadingRequest(true);
            await axios.delete(apiUrl + `payrollperiod/${payrollIdForDelete}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            await SetAuditTrail({
                setupArea: "Payroll", 
                actionTaken: "logout", 
                field: "Processed Delete All", 
                newValue: `-`, 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });

            await fetchData(); // Assuming fetchData() fetches the updated data for the table

            console.log('Deleted successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);
        
            // Reload table data and reset state
            setShowDeleteAllForm(false);
            setPayrollIdForDelete("");
        } catch (error) {
            console.error('There was a problem deleting employee:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }
        
        setShowDeleteAllForm(false);
    };
    const handleGenerate = useCallback( async () => {
        await fetchAdditionData();
        await fetchDeductionData();
        await fetchAdjustmentData();
        await fetchNightDiffData();
        await fetchDataProcessedPayroll();
    }, [fetchAdditionData, 
        fetchDeductionData,
        fetchAdjustmentData,
        fetchNightDiffData,
        fetchDataProcessedPayroll,
    ]);
    useEffect(() => {
        fetchAdditionData();
        fetchDeductionData();
        fetchAdjustmentData();
        fetchNightDiffData();
        fetchDataProcessedPayroll();
    }, [type, 
        handleGenerate,
        showPostMessage,
        fetchAdditionData,
        fetchDeductionData,
        fetchAdjustmentData,
        fetchNightDiffData,
        fetchDataProcessedPayroll,
        isGenerate,
        isRevert,
        isProcess,
        isPost,
        isUpload
    ]);
    
    const handleSelectChange = (index) => {
        setSelectedTab(index);
        setType(index)
    };

    useEffect(() => {
        if(showEditForm){
            setPayrollPeriodId(dataToEdit.payrollPeriodId);
            setEmployeePersonalInformationId(dataToEdit.employeePersonalInformationId);
            setEmployeePersonalInformationFullName(dataToEdit.employeePersonalInformationFullName);
            setPayTypeId(dataToEdit.payTypeId);
            setTotalEcola(dataToEdit.totalEcola);
            setTotalAllowance(dataToEdit.totalAllowance);
            setTotalTax(dataToEdit.totalTax);
            setTotalDays(dataToEdit.totalDays);
            setTotalDaysAbsents(dataToEdit.totalDaysAbsents);
            setTotalAbsents(dataToEdit.totalAbsents);
            setTotalDaysLeaves(dataToEdit.totalDaysLeaves);
            setTotalLeaves(dataToEdit.totalLeaves);
            setTotalDeduction(dataToEdit.totalDeduction);
            setTotalAddition(dataToEdit.totalAddition);
            setTotalAdjustment(dataToEdit.totalAdjustment);
            setRate(dataToEdit.rate);
            setTotalNighDiff(dataToEdit.totalNighDiff);
            setTotalHoursOTRegular(dataToEdit.totalHoursOTRegular);
            setTotalOTRegular(dataToEdit.totalOTRegular);
            setTotalHoursOTRegularExceeded(dataToEdit.totalHoursOTRegularExceeded);
            setTotalOTRegularExceeded(dataToEdit.totalOTRegularExceeded);
            setTotalHoursOTRestday(dataToEdit.totalHoursOTRestday);
            setTotalOTRestday(dataToEdit.totalOTRestday);
            setTotalHoursOTRestdayExceeded(dataToEdit.totalHoursOTRestdayExceeded);
            setTotalOTRestdayExceeded(dataToEdit.totalOTRestdayExceeded);
            setTotalHoursOTHolidaySpecial(dataToEdit.totalHoursOTHolidaySpecial);
            setTotalOTHolidaySpecial(dataToEdit.totalOTHolidaySpecial);
            setTotalHoursOTHolidaySpecialExceeded(dataToEdit.totalHoursOTHolidaySpecialExceeded);
            setTotalOTHolidaySpecialExceeded(dataToEdit.totalOTHolidaySpecialExceeded);
            setTotalHoursOTHolidayRegular(dataToEdit.totalHoursOTHolidayRegular);
            setTotalOTHolidayRegular(dataToEdit.totalOTHolidayRegular);
            setTotalHoursOTHolidayRegularExceeded(dataToEdit.totalHoursOTHolidayRegularExceeded);
            setTotalOTHolidayRegularExceeded(dataToEdit.totalOTHolidayRegularExceeded);
            setTotalHoursOTRestdayHolidaySpecial(dataToEdit.totalHoursOTRestdayHolidaySpecial);
            setTotalOTRestdayHolidaySpecial(dataToEdit.totalOTRestdayHolidaySpecial);
            setTotalHoursOTRestdayHolidaySpecialExceeded(dataToEdit.totalHoursOTRestdayHolidaySpecialExceeded);
            setTotalOTRestdayHolidaySpecialExceeded(dataToEdit.totalOTRestdayHolidaySpecialExceeded);
            setTotalHoursOTRestdayHolidayRegular(dataToEdit.totalHoursOTRestdayHolidayRegular);
            setTotalOTRestdayHolidayRegular(dataToEdit.totalOTRestdayHolidayRegular);
            setTotalHoursOTRestdayHolidayRegularExceeded(dataToEdit.totalHoursOTRestdayHolidayRegularExceeded);
            setTotalOTRestdayHolidayRegularExceeded(dataToEdit.totalOTRestdayHolidayRegularExceeded);
            setTotalSSS(dataToEdit.totalSSS);
            setTotalPagibig(dataToEdit.totalPagibig);
            setTotalPhilhealth(dataToEdit.totalPhilhealth);
            setTotalHoursUndertime(dataToEdit.totalHoursUndertime);
            setTotalUndertime(dataToEdit.totalUndertime);
            setTotalHoursLate(dataToEdit.totalHoursLate);
            setTotalLate(dataToEdit.totalLate);
            setTotalBasic(dataToEdit.totalBasic);
            setTotalGrossPay(dataToEdit.totalGrossPay);
            setTotalNetPay(dataToEdit.totalNetPay);
            setDateProcessed(dataToEdit.dateProcessed);
            setUserId(dataToEdit.userId);
        }

        if (successPostMessage) {
            const timeoutId = setTimeout(() => {
                setSuccessPostMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showEditForm, 
        dataToEdit, 
        successPostMessage, 
        type, 
        handleGenerate, 
        showPostMessage, 
        fetchData,
        isGenerate,
        isRevert,
        isProcess,
        isPost
    ]); 
    const editHandleClick = (data) => {
        setEditById(data.id);
        setDataToEdit(data);
        setShowEditForm(true);
    };
    const deleteHandleClick = (data) => {
        setShowDeleteForm(true);
        setDeleteById(data.id);
    };
    const deleteAllHandleClick = (data) => {
        setShowDeleteAllForm(true);
    };
    const closeAddHandleClick = () => {
        setShowAddForm(false);
    };
    const closeEditHandleClick = () => {
        setShowEditForm(false);
    };
    const closeDeleteHandleClick = () => {
        setShowDeleteForm(false);
    };
    const closeDeleteAllHandleClick = () => {
        setShowDeleteAllForm(false);
    };
    const closeEmployeeForm = () => {
        setShowEmployeeForm(false);
    };

    function formatDate(dateString) {
        if(!dateString){
            return '';
        }
        const date = new Date(dateString);
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based in JavaScript
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
    }

    const exportToExcel = async () => {
        if(payrollData.length === 0) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("No data to extract");
            return;
        }
        
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet();

        const arrayList = (type, value) => {
            if (type === 'otherCashAdvances' || type === "companyLoans" ) {
                if (Array.isArray(value) && value.length > 0) {
                    // Format each cash advance as 'description - defaultDeduction'
                    return value.map(ca => `${ca.description} - ${ca.defaultDeduction}`).join(', ');
                }
                return '';
            }

            if (type === 'benefits' ) {
                if (Array.isArray(value) && value.length > 0) {
                    // Format each cash advance as 'description - defaultDeduction'
                    return value.map(ca => `${ca.name} - ${ca.amount}`).join(', ');
                }
                return '';
            }
        }

        const header = [
            "Id",
            "Employee Id",
            "Name",
            "Classification",
            "Pay Type",
            "Total Basic",
            "Rate",
            "Total Days",
            "Days Absent",
            "Absent/s",
            "Days Leave",
            "Leave/s",
            "Hours Undertime",
            "Undertime",
            "Hours Late",
            "Late",
            "Hours Night Differential",
            "Night Differential",
            "Allowance",
            "Benefits",
            "Benefits List",
            "Total Days Regular Holidays",
            "Total Regular Holiday Worked",
            "Total Regular Holidays",
            "Total Days Special Non-Working Holidays",
            "Total Special Non-Working Holidays",
            "Hours OT Regular",
            "Total OT Regular",
            "Hours OT Restday",
            "Total OT Restday",
            "Hours Holiday Special",
            "Total Holiday Special",
            "Hours Holiday Regular",
            "Total Holiday Regular",
            "Hours Restday Holiday Special",
            "Total Restday Holiday Special",
            "Hours Restday Holiday Regular",
            "Total Restday Holiday Regular",
            "Total OT Food Allowance",
            "SSS",
            "Pagibig",
            "Philhealth",
            "SSS Loan",
            "SSS Calamity Loan",
            "Pagibig Loan",
            "Pagibig Calamity Loan",
            "Cash Advance",
            "Other Cash Advance",
            "Other Cash Advance List",
            "Company Loans",
            "Company Loans List",
            "Tax",
            "Additions",
            "Exterior Works",
            "Addback",
            "Deductions",
            "Vale",
            "Adjustments",
            "Total Gross Pay",
            "Total Net Pay",
            "Date Processed",
        ];
        const headerRow = worksheet.addRow(header);
        worksheet.columns = [
            { key: 'id', width: 30 },
            { key: 'employeePersonalInformationEmployeeId', width: 30 },
            { key: 'employeePersonalInformationFullName', width: 30 },
            { key: 'classificationDescription', width: 30 },
            { key: 'payTypeDescription', width: 30 },
            { key: 'totalBasic', width: 30 },
            { key: 'rate', width: 20 },
            { key: 'totalDays', width: 20 },
            { key: 'totalDaysAbsents', width: 20 },
            { key: 'totalAbsents', width: 20 },
            { key: 'totalDaysLeaves', width: 20 },
            { key: 'totalLeaves', width: 20 },
            { key: 'totalHoursUndertime', width: 20 },
            { key: 'totalUndertime', width: 20 },
            { key: 'totalHoursLate', width: 20 },
            { key: 'totalLate', width: 20 },
            { key: 'totalNighDiff', width: 20 },
            { key: 'totalNighDiffAmount', width: 20 },
            { key: 'totalLate', width: 20 },
            { key: 'totalAllowance', width: 20 },
            { key: 'totalBenefits', width: 20 },
            { key: 'benefits', width: 20 },
            { key: 'totalDaysRegularHolidays', width: 20 },
            { key: 'totalRegularHolidayWorked', width: 20 },
            { key: 'totalRegularHolidays', width: 20 },
            { key: 'totalDaysSpecialNonWorkingHolidays', width: 20 },
            { key: 'totalSpecialNonWorkingHolidays', width: 20 },
            { key: 'totalHoursOTRegular', width: 20 },
            { key: 'totalOTRegular', width: 20 },
            { key: 'totalHoursOTRestday', width: 20 },
            { key: 'totalOTRestday', width: 20 },
            { key: 'totalHoursOTHolidaySpecial', width: 20 },
            { key: 'totalOTHolidaySpecial', width: 20 },
            { key: 'totalHoursOTHolidayRegular', width: 20 },
            { key: 'totalOTHolidayRegular', width: 20 },
            { key: 'otFoodAllowance', width: 20 },
            { key: 'totalSSS', width: 20 },
            { key: 'totalPagibig', width: 20 },
            { key: 'totalPhilhealth', width: 20 },
            { key: 'totalSSSLoan', width: 20 },
            { key: 'totalSSSCalamityLoan', width: 20 },
            { key: 'totalPagibigLoan', width: 20 },
            { key: 'totalPagibigCalamityLoan', width: 20 },
            { key: 'totalCashAdvance', width: 20 },
            { key: 'totalOtherCashAdvance', width: 20 },
            { key: 'otherCashAdvances', width: 20 },
            { key: 'totalCompanyLoan', width: 20 },
            { key: 'companyLoans', width: 20 },
            { key: 'totalTax', width: 20 },
            { key: 'totalAddition', width: 20 },
            { key: 'additionExteriorWorks', width: 20 },
            { key: 'additionAddback', width: 20 },
            { key: 'totalDeduction', width: 20 },
            { key: 'deductionVale', width: 20 },
            { key: 'totalAdjustment', width: 20 },
            { key: 'totalGrossPay', width: 20 },
            { key: 'totalNetPay', width: 20 },
            { key: 'dateProcessed', width: 20 },
        ];
        headerRow.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });
    
        payrollData.forEach((item) => {
            worksheet.addRow([
                item.id,
                item.employeePersonalInformationEmployeeId,
                item.employeePersonalInformationFullName,
                item.classificationDescription,
                item.payTypeDescription,
                item.totalBasic.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.rate.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.totalDays.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.totalDaysAbsents.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.totalAbsents.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.totalDaysLeaves.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.totalLeaves.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.totalHoursUndertime.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.totalUndertime.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.totalHoursLate.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.totalLate.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.totalNighDiff.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.totalNighDiffAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.totalAllowance.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.totalBenefits.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                arrayList("benefits", item.benefits),
                item.totalDaysRegularHolidays.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.totalRegularHolidayWorked.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.totalRegularHolidays,
                item.totalDaysSpecialNonWorkingHolidays.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.totalSpecialNonWorkingHolidays.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.totalHoursOTRegular.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.totalOTRegular.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.totalHoursOTRestday.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.totalOTRestday.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.totalHoursOTHolidaySpecial.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.totalOTHolidaySpecial.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.totalHoursOTHolidayRegular.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.totalOTHolidayRegular.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.totalHoursOTRestdayHolidaySpecial.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.totalOTRestdayHolidaySpecial.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.totalHoursOTRestdayHolidayRegular.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.totalOTRestdayHolidayRegular.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.otFoodAllowance.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.totalSSS.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.totalPagibig.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.totalPhilhealth.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.totalSSSLoan.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.totalSSSCalamityLoan.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.totalPagibigLoan.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.totalPagibigCalamityLoan.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.totalCashAdvance.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.totalOtherCashAdvance.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                arrayList("otherCashAdvances", item.otherCashAdvances),
                item.totalCompanyLoan.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                arrayList("companyLoans", item.companyLoans),
                item.totalTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.totalAddition.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.additionExteriorWorks.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.additionAddback.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.totalDeduction.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.deductionVale.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.totalAdjustment.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.totalGrossPay.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.totalNetPay.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                formatDate(item.dateProcessed),
            ]);
        });

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'Payroll_data.xlsx');
    };

    return (
        <div>
            <Tabs selectedIndex={selectedTab} onSelect={index => handleSelectChange(index)}>
                <TabList>
                    <Tab><b>ADJUSTMENTS</b></Tab>
                    <Tab><b>PROCESSED</b></Tab>
                </TabList>
                <div className="payrollTab">
                    <TabPanel>
                        <div>
                            <ShowAdjustmentButtons  
                                                    otherAdditionData={otherAdditionData}
                                                    otherDeductionData={otherDeductionData}
                                                    otherAdjustmentData={otherAdjustmentData}
                                                    otherNightDiff={otherNightDiff}
                                                    setOtherAdditionData={setOtherAdditionData}
                                                    setOtherDeductionData={setOtherDeductionData}
                                                    setOtherAdjustmentData={setOtherAdjustmentData}
                                                    setOtherNightDiff={setOtherNightDiff}
                                                    payrollData={payrollDataAdjustment} 
                                                    setPayrollData={setPayrollDataAdjustment}
                                                    filterPayrollPeriodId={filterPayrollPeriodId}
                                                    filterPayTypeId={filterPayTypeId}
                                                    filterClassificationId={filterClassificationId}
                                                    userAccess={userAccess}
                                                    type={type}
                                                    showPostMessage={showPostMessage}
                                                    isGenerate={isGenerate}
                                                    setIsGenerate={setIsGenerate}
                                                    isRevert={isRevert}
                                                    isProcess={isProcess}
                                                    isPost={isPost}
                                                    isUpload={isUpload}
                                                    setIsUpload={setIsUpload}

                                                    loadingOtherAddition={loadingOtherAddition}
                                                    loadingOtherDedujction={loadingOtherDedujction}
                                                    loadingAdjustment={loadingAdjustment}
                                                    loadingNightDiff={loadingNightDiff}
                                                    filterDataAddition={filterDataAddition}
                                                    filterDataDeduction={filterDataDeduction}
                                                    filterDataAdjustment={filterDataAdjustment}
                                                    filterDataNightDiff={filterDataNightDiff}
                                                    fetchAdditionData={fetchAdditionData}
                                                    fetchDeductionData={fetchDeductionData}
                                                    fetchAdjustmentData={fetchAdjustmentData}
                                                    fetchNightDiffData={fetchNightDiffData}
                                                    fetchDataProcessedPayroll={fetchDataProcessedPayroll}
                                                    user={user}
                            />
                        </div>
                    </TabPanel>
                        
                    <TabPanel>
                        <div className="mainte-body-top row">
                                {CreateSearchBarWithPlaceHolder("", 
                                                                "mainte-search row", 
                                                                "mainte-search-icon", 
                                                                "mainte-search-input", 
                                                                (e) => handleFilter(e.target.value), 
                                                                "Search by name", 
                                                                SearchIcon)}
                        </div>
                        <div className="payroll-tab-header row">
                            <div className="payroll-tab-leftSide">
                                <div className="leftSide-btn row" style={{padding:"10px"}}>
                                    {/* <button onClick={postHandleClick} className='post row' style={{marginRight:"5px"}}><PostAddIcon/> POST</button> */}
                                    <button onClick={exportToExcel} className='extract row' style={{marginRight:"5px"}}><FileOpenIcon/> EXTRACT</button>
                                    {/* <button onClick={addHandleClick} className='add row' style={{marginRight:"5px"}}><NoteAddIcon/> ADD</button> */}
                                    <button onClick={deleteAllHandleClick} className='delete row'><NoteAddIcon/> DELETE ALL</button>
                                </div>
                            </div>
                        </div>
                        <div className="payroll-table2 container">
                            <CreateTable
                                dataList={payrollData}
                                dataHeader={processedHeader}
                                dataAccessor={processedAccessor}
                                editHandleClick={editHandleClick}
                                deleteHandleClick={deleteHandleClick}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                            />
                            {payrollData.length > 0 ? (
                                <div></div>
                            )
                            :
                            (
                                <div>
                                {loading ? (
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                                        <img src={loadingSpinner} alt="Loading..." />
                                    </div>
                                ) : (
                                        <div> {/*<p>No records to display</p>*/}</div>
                                    )
                                }
                                </div>
                            )}
                        </div>
                    </TabPanel>
                </div>
            </Tabs>
            <AddProcessForm    isOpen={showAddForm} 
                        onClose={closeAddHandleClick}
                        payrollPeriodId={payrollPeriodId}
                        employeePersonalInformationId={employeePersonalInformationId}
                        employeePersonalInformationFullName={employeePersonalInformationFullName}
                        payTypeId={payTypeId}
                        totalEcola={totalEcola}
                        totalAllowance={totalAllowance}
                        totalTax={totalTax}
                        totalDays={totalDays}
                        totalDaysAbsents={totalDaysAbsents}
                        totalAbsents={totalAbsents}
                        totalDaysLeaves={totalDaysLeaves}
                        totalLeaves={totalLeaves}
                        totalDeduction={totalDeduction}
                        totalAddition={totalAddition}
                        totalAdjustment={totalAdjustment}
                        rate={rate}
                        totalNighDiff={totalNighDiff}
                        totalHoursOTRegular={totalHoursOTRegular}
                        totalOTRegular={totalOTRegular}
                        totalHoursOTRegularExceeded={totalHoursOTRegularExceeded}
                        totalOTRegularExceeded={totalOTRegularExceeded}
                        totalHoursOTRestday={totalHoursOTRestday}
                        totalOTRestday={totalOTRestday}
                        totalHoursOTRestdayExceeded={totalHoursOTRestdayExceeded}
                        totalOTRestdayExceeded={totalOTRestdayExceeded}
                        totalHoursOTHolidaySpecial={totalHoursOTHolidaySpecial}
                        totalOTHolidaySpecial={totalOTHolidaySpecial}
                        totalHoursOTHolidaySpecialExceeded={totalHoursOTHolidaySpecialExceeded}
                        totalOTHolidaySpecialExceeded={totalOTHolidaySpecialExceeded}
                        totalHoursOTHolidayRegular={totalHoursOTHolidayRegular}
                        totalOTHolidayRegular={totalOTHolidayRegular}
                        totalHoursOTHolidayRegularExceeded={totalHoursOTHolidayRegularExceeded}
                        totalOTHolidayRegularExceeded={totalOTHolidayRegularExceeded}
                        totalHoursOTRestdayHolidaySpecial={totalHoursOTRestdayHolidaySpecial}
                        totalOTRestdayHolidaySpecial={totalOTRestdayHolidaySpecial}
                        totalHoursOTRestdayHolidaySpecialExceeded={totalHoursOTRestdayHolidaySpecialExceeded}
                        totalOTRestdayHolidaySpecialExceeded={totalOTRestdayHolidaySpecialExceeded}
                        totalHoursOTRestdayHolidayRegular={totalHoursOTRestdayHolidayRegular}
                        totalOTRestdayHolidayRegular={totalOTRestdayHolidayRegular}
                        totalHoursOTRestdayHolidayRegularExceeded={totalHoursOTRestdayHolidayRegularExceeded}
                        totalOTRestdayHolidayRegularExceeded={totalOTRestdayHolidayRegularExceeded}
                        totalSSS={totalSSS}
                        totalPagibig={totalPagibig}
                        totalPhilhealth={totalPhilhealth}
                        totalHoursUndertime={totalHoursUndertime}
                        totalUndertime={totalUndertime}
                        totalHoursLate={totalHoursLate}
                        totalLate={totalLate}
                        totalBasic={totalBasic}
                        totalGrossPay={totalGrossPay}
                        totalNetPay={totalNetPay}
                        dateProcessed={dateProcessed}
                        userId={userId}
                        setPayrollPeriodId={setPayrollPeriodId}
                        setEmployeePersonalInformationId={setEmployeePersonalInformationId}
                        setPayTypeId={setPayTypeId}
                        setTotalEcola={setTotalEcola}
                        setTotalAllowance={setTotalAllowance}
                        setTotalTax={setTotalTax}
                        setTotalDays={setTotalDays}
                        setTotalDaysAbsents={setTotalDaysAbsents}
                        setTotalAbsents={setTotalAbsents}
                        setTotalDaysLeaves={setTotalDaysLeaves}
                        setTotalLeaves={setTotalLeaves}
                        setTotalDeduction={setTotalDeduction}
                        setTotalAddition={setTotalAddition}
                        setTotalAdjustment={setTotalAdjustment}
                        setRate={setRate}
                        setTotalNighDiff={setTotalNighDiff}
                        setTotalHoursOTRegular={setTotalHoursOTRegular}
                        setTotalOTRegular={setTotalOTRegular}
                        setTotalHoursOTRegularExceeded={setTotalHoursOTRegularExceeded}
                        setTotalOTRegularExceeded={setTotalOTRegularExceeded}
                        setTotalHoursOTRestday={setTotalHoursOTRestday}
                        setTotalOTRestday={setTotalOTRestday}
                        setTotalHoursOTRestdayExceeded={setTotalHoursOTRestdayExceeded}
                        setTotalOTRestdayExceeded={setTotalOTRestdayExceeded}
                        setTotalHoursOTHolidaySpecial={setTotalHoursOTHolidaySpecial}
                        setTotalOTHolidaySpecial={setTotalOTHolidaySpecial}
                        setTotalHoursOTHolidaySpecialExceeded={setTotalHoursOTHolidaySpecialExceeded}
                        setTotalOTHolidaySpecialExceeded={setTotalOTHolidaySpecialExceeded}
                        setTotalHoursOTHolidayRegular={setTotalHoursOTHolidayRegular}
                        setTotalOTHolidayRegular={setTotalOTHolidayRegular}
                        setTotalHoursOTHolidayRegularExceeded={setTotalHoursOTHolidayRegularExceeded}
                        setTotalOTHolidayRegularExceeded={setTotalOTHolidayRegularExceeded}
                        setTotalHoursOTRestdayHolidaySpecial={setTotalHoursOTRestdayHolidaySpecial}
                        setTotalOTRestdayHolidaySpecial={setTotalOTRestdayHolidaySpecial}
                        setTotalHoursOTRestdayHolidaySpecialExceeded={setTotalHoursOTRestdayHolidaySpecialExceeded}
                        setTotalOTRestdayHolidaySpecialExceeded={setTotalOTRestdayHolidaySpecialExceeded}
                        setTotalHoursOTRestdayHolidayRegular={setTotalHoursOTRestdayHolidayRegular}
                        setTotalOTRestdayHolidayRegular={setTotalOTRestdayHolidayRegular}
                        setTotalHoursOTRestdayHolidayRegularExceeded={setTotalHoursOTRestdayHolidayRegularExceeded}
                        setTotalOTRestdayHolidayRegularExceeded={setTotalOTRestdayHolidayRegularExceeded}
                        setTotalSSS={setTotalSSS}
                        setTotalPagibig={setTotalPagibig}
                        setTotalPhilhealth={setTotalPhilhealth}
                        setTotalHoursUndertime={setTotalHoursUndertime}
                        setTotalUndertime={setTotalUndertime}
                        setTotalHoursLate={setTotalHoursLate}
                        setTotalLate={setTotalLate}
                        setTotalBasic={setTotalBasic}
                        setTotalGrossPay={setTotalGrossPay}
                        setTotalNetPay={setTotalNetPay}
                        setDateProcessed={setDateProcessed}
                        setUserId={setUserId}
                        setShowEmployeeForm={setShowEmployeeForm}
                        handleSubmit={handleSubmit}
            >
            </AddProcessForm>
            <EditProcessForm  isOpen={showEditForm} 
                    onClose={closeEditHandleClick}
                    payrollPeriodId={payrollPeriodId}
                    employeePersonalInformationId={employeePersonalInformationId}
                    employeePersonalInformationFullName={employeePersonalInformationFullName}
                    payTypeId={payTypeId}
                    totalEcola={totalEcola}
                    totalAllowance={totalAllowance}
                    totalTax={totalTax}
                    totalDays={totalDays}
                    totalDaysAbsents={totalDaysAbsents}
                    totalAbsents={totalAbsents}
                    totalDaysLeaves={totalDaysLeaves}
                    totalLeaves={totalLeaves}
                    totalDeduction={totalDeduction}
                    totalAddition={totalAddition}
                    totalAdjustment={totalAdjustment}
                    rate={rate}
                    totalNighDiff={totalNighDiff}
                    totalHoursOTRegular={totalHoursOTRegular}
                    totalOTRegular={totalOTRegular}
                    totalHoursOTRegularExceeded={totalHoursOTRegularExceeded}
                    totalOTRegularExceeded={totalOTRegularExceeded}
                    totalHoursOTRestday={totalHoursOTRestday}
                    totalOTRestday={totalOTRestday}
                    totalHoursOTRestdayExceeded={totalHoursOTRestdayExceeded}
                    totalOTRestdayExceeded={totalOTRestdayExceeded}
                    totalHoursOTHolidaySpecial={totalHoursOTHolidaySpecial}
                    totalOTHolidaySpecial={totalOTHolidaySpecial}
                    totalHoursOTHolidaySpecialExceeded={totalHoursOTHolidaySpecialExceeded}
                    totalOTHolidaySpecialExceeded={totalOTHolidaySpecialExceeded}
                    totalHoursOTHolidayRegular={totalHoursOTHolidayRegular}
                    totalOTHolidayRegular={totalOTHolidayRegular}
                    totalHoursOTHolidayRegularExceeded={totalHoursOTHolidayRegularExceeded}
                    totalOTHolidayRegularExceeded={totalOTHolidayRegularExceeded}
                    totalHoursOTRestdayHolidaySpecial={totalHoursOTRestdayHolidaySpecial}
                    totalOTRestdayHolidaySpecial={totalOTRestdayHolidaySpecial}
                    totalHoursOTRestdayHolidaySpecialExceeded={totalHoursOTRestdayHolidaySpecialExceeded}
                    totalOTRestdayHolidaySpecialExceeded={totalOTRestdayHolidaySpecialExceeded}
                    totalHoursOTRestdayHolidayRegular={totalHoursOTRestdayHolidayRegular}
                    totalOTRestdayHolidayRegular={totalOTRestdayHolidayRegular}
                    totalHoursOTRestdayHolidayRegularExceeded={totalHoursOTRestdayHolidayRegularExceeded}
                    totalOTRestdayHolidayRegularExceeded={totalOTRestdayHolidayRegularExceeded}
                    totalSSS={totalSSS}
                    totalPagibig={totalPagibig}
                    totalPhilhealth={totalPhilhealth}
                    totalHoursUndertime={totalHoursUndertime}
                    totalUndertime={totalUndertime}
                    totalHoursLate={totalHoursLate}
                    totalLate={totalLate}
                    totalBasic={totalBasic}
                    totalGrossPay={totalGrossPay}
                    totalNetPay={totalNetPay}
                    dateProcessed={dateProcessed}
                    userId={userId}
                    setPayrollPeriodId={setPayrollPeriodId}
                    setEmployeePersonalInformationId={setEmployeePersonalInformationId}
                    setPayTypeId={setPayTypeId}
                    setTotalEcola={setTotalEcola}
                    setTotalAllowance={setTotalAllowance}
                    setTotalTax={setTotalTax}
                    setTotalDays={setTotalDays}
                    setTotalDaysAbsents={setTotalDaysAbsents}
                    setTotalAbsents={setTotalAbsents}
                    setTotalDaysLeaves={setTotalDaysLeaves}
                    setTotalLeaves={setTotalLeaves}
                    setTotalDeduction={setTotalDeduction}
                    setTotalAddition={setTotalAddition}
                    setTotalAdjustment={setTotalAdjustment}
                    setRate={setRate}
                    setTotalNighDiff={setTotalNighDiff}
                    setTotalHoursOTRegular={setTotalHoursOTRegular}
                    setTotalOTRegular={setTotalOTRegular}
                    setTotalHoursOTRegularExceeded={setTotalHoursOTRegularExceeded}
                    setTotalOTRegularExceeded={setTotalOTRegularExceeded}
                    setTotalHoursOTRestday={setTotalHoursOTRestday}
                    setTotalOTRestday={setTotalOTRestday}
                    setTotalHoursOTRestdayExceeded={setTotalHoursOTRestdayExceeded}
                    setTotalOTRestdayExceeded={setTotalOTRestdayExceeded}
                    setTotalHoursOTHolidaySpecial={setTotalHoursOTHolidaySpecial}
                    setTotalOTHolidaySpecial={setTotalOTHolidaySpecial}
                    setTotalHoursOTHolidaySpecialExceeded={setTotalHoursOTHolidaySpecialExceeded}
                    setTotalOTHolidaySpecialExceeded={setTotalOTHolidaySpecialExceeded}
                    setTotalHoursOTHolidayRegular={setTotalHoursOTHolidayRegular}
                    setTotalOTHolidayRegular={setTotalOTHolidayRegular}
                    setTotalHoursOTHolidayRegularExceeded={setTotalHoursOTHolidayRegularExceeded}
                    setTotalOTHolidayRegularExceeded={setTotalOTHolidayRegularExceeded}
                    setTotalHoursOTRestdayHolidaySpecial={setTotalHoursOTRestdayHolidaySpecial}
                    setTotalOTRestdayHolidaySpecial={setTotalOTRestdayHolidaySpecial}
                    setTotalHoursOTRestdayHolidaySpecialExceeded={setTotalHoursOTRestdayHolidaySpecialExceeded}
                    setTotalOTRestdayHolidaySpecialExceeded={setTotalOTRestdayHolidaySpecialExceeded}
                    setTotalHoursOTRestdayHolidayRegular={setTotalHoursOTRestdayHolidayRegular}
                    setTotalOTRestdayHolidayRegular={setTotalOTRestdayHolidayRegular}
                    setTotalHoursOTRestdayHolidayRegularExceeded={setTotalHoursOTRestdayHolidayRegularExceeded}
                    setTotalOTRestdayHolidayRegularExceeded={setTotalOTRestdayHolidayRegularExceeded}
                    setTotalSSS={setTotalSSS}
                    setTotalPagibig={setTotalPagibig}
                    setTotalPhilhealth={setTotalPhilhealth}
                    setTotalHoursUndertime={setTotalHoursUndertime}
                    setTotalUndertime={setTotalUndertime}
                    setTotalHoursLate={setTotalHoursLate}
                    setTotalLate={setTotalLate}
                    setTotalBasic={setTotalBasic}
                    setTotalGrossPay={setTotalGrossPay}
                    setTotalNetPay={setTotalNetPay}
                    setDateProcessed={setDateProcessed}
                    setUserId={setUserId}
                    handleUpdate={handleUpdate}
        >
            </EditProcessForm>
            <DeleteForm  isOpen={showDeleteForm} 
                    onClose={closeDeleteHandleClick}
                    handleDelete={handleDelete}
            >
            </DeleteForm>
            <DeleteAllPayrollSummaryForm  isOpen={showDeleteAllForm} 
                        onClose={closeDeleteAllHandleClick}
                        payrollPeriodId={payrollIdForDelete}
                        setPayrollPeriodId={setPayrollIdForDelete}
                        handleDelete={handleDeleteAll}
                >
            </DeleteAllPayrollSummaryForm>
            <EmployeeSelectForm  isOpen={showEmployeeForm} 
                    onClose={closeEmployeeForm}
                    setEmployeeId={setEmployeePersonalInformationId}
                    setEmployee={setEmployeePersonalInformationFullName}
                    userAccessData={userAccess}
            >
            </EmployeeSelectForm>
            <GenerateMessage form={successPostMessage}
                    message={"Data posted!"}
                    isSuccess={true}
            > 
            </GenerateMessage>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loadingRequest ? (
            <div style={{ position:"fixed", top:"50%", left:"50%", transform:"translate(-50%, -50%)", zIndex:"3005"}}>
                    <img src={loadingSpinner} alt="Loading..." />
                </div>
            ) : (
                <></>
                )
            }
        </div>
    );
}
function SettingInit({
    generateDownloadTemplate,
    generateDownloadAdjustmentTemplate,
    generateDownloadNightDiffTemplate,
    openUploadFormHandleClick,
    openRevertPayrollForm,
    openProcessPayrollForm,
    openPostPayrollForm,
    setSettingType
}){
    const handleUploadClick = (settingType) =>{
        openUploadFormHandleClick();
        setSettingType(settingType);
    }
    return(
        <div id='payroll-setting' className="payroll-setting column">
            <div className="payroll-setting-item row" onClick={()=>generateDownloadTemplate()}>
                <div style={{margin: "10px 5px 0 5px", color:"#1a75ff"}}><DownloadIcon/></div>
                Download Other Additions Template
            </div>
            <div className="payroll-setting-item row" onClick={()=>generateDownloadTemplate()}>
                <div style={{margin: "10px 5px 0 5px", color:"#1a75ff"}}><DownloadIcon/></div>
                Download Other Deductions Template
            </div>
            <div className="payroll-setting-item row" onClick={()=>generateDownloadAdjustmentTemplate()}>
                <div style={{margin: "10px 5px 0 5px", color:"#1a75ff"}}><DownloadIcon/></div>
                Download Other Adjustments Template
            </div>
            <div className="payroll-setting-item row" onClick={()=>generateDownloadNightDiffTemplate()}>
                <div style={{margin: "10px 5px 0 5px", color:"#1a75ff"}}><DownloadIcon/></div>
                Download Other Night Differential Template
            </div>
            <div className="payroll-setting-item row"onClick={()=>handleUploadClick("Other Additions")}>
                <div style={{margin: "10px 5px 0 5px", color:"#47d147"}}><FileUploadIcon/></div>
                Upload Other Additions
            </div>
            <div className="payroll-setting-item row"onClick={()=>handleUploadClick("Other Deductions")}>
                <div style={{margin: "10px 5px 0 5px", color:"#47d147"}}><FileUploadIcon/></div>
                Upload Other Deductions
            </div>
            <div className="payroll-setting-item row"onClick={()=>handleUploadClick("Other Adjustments")}>
                <div style={{margin: "10px 5px 0 5px", color:"#47d147"}}><FileUploadIcon/></div>
                Upload Other Adjustments
            </div>
            <div className="payroll-setting-item row"onClick={()=>handleUploadClick("Night Differential")}>
                <div style={{margin: "10px 5px 0 5px", color:"#47d147"}}><FileUploadIcon/></div>
                Upload Other Night Differential
            </div>
            <div className="payroll-setting-item row"onClick={()=>openRevertPayrollForm()}>
                <div style={{margin: "10px 5px 0 5px", color:"#ff4d4d"}}><SettingsBackupRestoreIcon/></div>
                Revert Payroll
            </div>
            <div className="payroll-setting-item row"onClick={()=>openProcessPayrollForm()}>
                <div style={{margin: "10px 5px 0 5px", color:"#ffaa00"}}><AccountTreeIcon/></div>
                Process Payroll
            </div>
            <div className="payroll-setting-item row"onClick={()=>openPostPayrollForm()}>
                <div style={{margin: "10px 5px 0 5px", color:"#1a75ff"}}><PostAddIcon/></div>
                Post Payroll
            </div>
        </div>
    )
}
function ShowAdjustmentButtons({
    payrollData, 
    setPayrollData,
    otherAdditionData,
    otherDeductionData,
    otherAdjustmentData,
    otherNightDiff,
    setOtherAdditionData,
    setOtherDeductionData,
    setOtherAdjustmentData,
    setOtherNightDiff,
    filterPayrollPeriodId,
    filterPayTypeId,
    filterClassificationId,
    userAccess,
    type,
    showPostMessage,
    isGenerate,
    setIsGenerate,
    isRevert,
    isProcess,
    isPost,
    isUpload,
    setIsUpload,

    loadingOtherAddition,
    loadingOtherDedujction,
    loadingAdjustment,
    loadingNightDiff,
    filterDataAddition,
    filterDataDeduction,
    filterDataAdjustment,
    filterDataNightDiff,
    fetchAdditionData,
    fetchDeductionData,
    fetchAdjustmentData,
    fetchNightDiffData,
    fetchDataProcessedPayroll,
    user
}) {
    var adjustmentsHeader = [
        "Id",
        "Name",
        "Description",
        "Amount",
        ""
    ]
    var adjustmentsAccesor = [
        "id",
        "employeePersonalInformationFullName",
        "description",
        "amount",
        "manage"
    ]

    var nightDiffHeader = [
        "Id",
        "Name",
        "Amount",
        ""
    ]
    var nightDiffAccessor = [
        "id",
        "employeePersonalInformationFullName",
        "amount",
        "manage"
    ]

    const [currentPage, setCurrentPage] = useState(1);
    const [loadingRequest, setLoadingRequest] = useState(false);
    const [adjustmentType, setAdjustmentType] = useState("OtherAdditionStaging");
    const [activeButton, setActiveButton] = useState('btn-tab-addition');
    //Add
    const [showAddForm, setShowAddForm] = useState(false);
    const [employeePersonalInformationId, setEmployeePersonalInformationId] = useState("");
    const [employeePersonalInformationFullName, setEmployeePersonalInformationFullName] = useState("");
    const [payrollPeriodId, setPayrollPeriodId] = useState("");
    const [payTypeId, setPayTypeId] = useState("");
    const [description, setDescription] = useState("");
    const [amount, setAmount] = useState("");
    const [noOfHours, setNoOfHours] = useState("");
    const [adjustmentDate, setAdjustmentDate] = useState("");
    const [referenceId, setReferenceId] = useState("");
    //Old
    const [oldEmployeePersonalInformationId, setOldEmployeePersonalInformationId] = useState("");
    const [oldPayrollPeriodId, setOldPayrollPeriodId] = useState("");
    const [oldPayTypeId, setOldPayTypeId] = useState("");
    const [oldDescription, setOldDescription] = useState("");
    const [oldAmount, setOldAmount] = useState("");
    const [oldAdjustmentDate, setOldAdjustmentDate] = useState("");
    const [oldReferenceId, setOldReferenceId] = useState("");
    //Update
    const [showEditForm, setShowEditForm] = useState(false);
    const [editById, setEditById] = useState("");
    const [dataToEdit, setDataToEdit] = useState([]);
    // Delete
    const [showDeleteForm, setShowDeleteForm] = useState(false);
    const [deleteById, setDeleteById] = useState([]);
    const [deleteData, setDeleteData] = useState([]);
    // Delete All
    const [showDeleteAllForm, setShowDeleteAllForm] = useState(false);
    const [payrollIdForDelete, setPayrollIdForDelete] = useState("");
    const [payTypeIdForDelete, setPayTypeIdForDelete] = useState("");

    const [showEmployeeForm, setShowEmployeeForm] = useState(false);
    const [referenceIdForm, setReferenceIdForm] = useState(false);
    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);

    const apiUrl =  domain + "/api/";

    const handleFilter = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();
        var res = []
        if(adjustmentType === "OtherAdditionStaging"){
            res = filterDataAddition.filter((f) =>
                f.employeePersonalInformationFullName.toLowerCase().includes(lowercaseValue)
                );

            setOtherAdditionData(res);
        } else if(adjustmentType === "OtherDeductionStaging"){
            res  = filterDataDeduction.filter((f) =>
                f.employeePersonalInformationFullName.toLowerCase().includes(lowercaseValue)
            );

            setOtherDeductionData(res);
        } else if(adjustmentType === "OtherAdjustmentStaging"){
            res  = filterDataAdjustment.filter((f) =>
                f.employeePersonalInformationFullName.toLowerCase().includes(lowercaseValue)
            );

            setOtherAdjustmentData(res);
        } else if(adjustmentType === "NightDifferentialsStaging"){
            res  = filterDataNightDiff.filter((f) =>
                f.employeePersonalInformationFullName.toLowerCase().includes(lowercaseValue)
            );

            setOtherNightDiff(res);
        }
    };
    const handleClick = (id) => {
        setCurrentPage(1);
        if(id === "btn-tab-addition"){
            setAdjustmentType("OtherAdditionStaging");
        } else if(id === "btn-tab-deductions"){
            setAdjustmentType("OtherDeductionStaging");
        } else if(id === "btn-tab-adjustments"){
            setAdjustmentType("OtherAdjustmentStaging");
        } else if(id === "btn-tab-nightDiff"){
            setAdjustmentType("NightDifferentialsStaging");
        }
        setActiveButton(id);
        handleOtherFunction(id);

    }
    const handleOtherFunction = (id) => {
        const additionTable = document.getElementById("addition-table");
        const deductionTable = document.getElementById("deduction-table");
        const adjustmentTable = document.getElementById("adjustment-table");
        const nightDiffTable = document.getElementById("nightDiff-table");
        
        switch (id) {
            case 'btn-tab-addition':
                additionTable.style.display = "block";
                deductionTable.style.display = "none";
                adjustmentTable.style.display = "none";
                nightDiffTable.style.display = "none";
                break;
            case 'btn-tab-deductions':
                additionTable.style.display = "none";
                deductionTable.style.display = "block";
                adjustmentTable.style.display = "none";
                nightDiffTable.style.display = "none";
                break;
            case 'btn-tab-adjustments':
                additionTable.style.display = "none";
                deductionTable.style.display = "none";
                adjustmentTable.style.display = "block";
                nightDiffTable.style.display = "none";
                break;
            case 'btn-tab-nightDiff':
                additionTable.style.display = "none";
                deductionTable.style.display = "none";
                adjustmentTable.style.display = "none";
                nightDiffTable.style.display = "block";
                break;
            default:
                break;
        }
    }
    const handleGenerate = useCallback( async () => {
        await fetchAdditionData();
        await fetchDeductionData();
        await fetchAdjustmentData();
        await fetchNightDiffData();
        await fetchDataProcessedPayroll();
    }, [fetchAdditionData,
        fetchDeductionData,
        fetchAdjustmentData,
        fetchNightDiffData,
        fetchDataProcessedPayroll]);

    useEffect(() => {
        fetchAdditionData();
        fetchDeductionData();
        fetchAdjustmentData();
        fetchNightDiffData();
        fetchDataProcessedPayroll();
    }, [type, 
        handleGenerate,
        showPostMessage,
        fetchAdditionData,
        fetchDeductionData,
        fetchAdjustmentData,
        fetchNightDiffData,
        fetchDataProcessedPayroll,
        isGenerate,
        isRevert,
        isProcess,
        isPost,
        isUpload
    ]);
    useEffect(() => {
        if(showEditForm){
            setEmployeePersonalInformationId(dataToEdit.employeePersonalInformationId)
            setEmployeePersonalInformationFullName(dataToEdit.employeePersonalInformationFullName);
            setPayrollPeriodId(dataToEdit.payrollPeriodId)
            setPayTypeId(dataToEdit.payTypeId)
            setDescription(dataToEdit.description)
            setAmount(dataToEdit.amount)
            setAdjustmentDate(dataToEdit.adjustmentDate)
            setReferenceId(dataToEdit.referenceId)

            setOldEmployeePersonalInformationId(dataToEdit.employeePersonalInformationId)
            setOldPayrollPeriodId(dataToEdit.payrollPeriodId)
            setOldPayTypeId(dataToEdit.payTypeId)
            setOldDescription(dataToEdit.description)
            setOldAmount(dataToEdit.amount)
            setOldAdjustmentDate(dataToEdit.adjustmentDate)
            setOldReferenceId(dataToEdit.referenceId)
        }

    }, [showEditForm, 
        dataToEdit,
    ]);

    const handleSubmit = async (event) => {
        event.preventDefault();

        const data = {
            employeePersonalInformationId: employeePersonalInformationId,
            payrollPeriodId: payrollPeriodId,
            payTypeId: payTypeId,
            ...(adjustmentType !== "NightDifferentialsStaging" && { description: description }),
            amount: amount,
            ...(adjustmentType === "OtherAdjustmentStaging" && { noOfHours: noOfHours }),
            ...(adjustmentType === "OtherAdjustmentStaging" && { adjustmentDate: adjustmentDate }),
            ...(adjustmentType === "OtherAdjustmentStaging" && { referenceId: referenceId ? referenceId : 0}),
            ...(adjustmentType === "OtherAdjustmentStaging" && { transactionType: "Leave"}),
        };

        console.log('Final bulkData:', JSON.stringify(data, null, 2));

        // ...(adjustmentType !== "OtherAdjustmentStaging" ? { amount: amount } : {})

        try {
            setLoadingRequest(true);
            const response = await axios.post(apiUrl + `${adjustmentType}`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            let field = "";

            if(adjustmentType === "OtherAdditionStaging"){
                field = "Other Addition Add";
            } else if(adjustmentType === "OtherDeductionStaging"){
                field = "Other Deduction Add";
            } else if(adjustmentType === "OtherAdjustmentStaging"){
                field = "Other Adjustment Add";
            } else if(adjustmentType === "NightDifferentialsStaging"){
                field = "Night Differential Add";
            }

            await SetAuditTrail({
                setupArea: "Payroll", 
                actionTaken: "insert", 
                field: field, 
                newValue: `${response.data.description}`, 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });

            await fetchAdditionData();
            await fetchDeductionData();
            await fetchAdjustmentData();
            await fetchNightDiffData();
            await fetchDataProcessedPayroll();

            console.log('Data added successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);
            
            // Reload table data and reset form fields
            setEmployeePersonalInformationId("");
            setPayrollPeriodId("");
            setPayTypeId("");
            setDescription("");
            setAmount("");
            setAdjustmentDate("");
            setReferenceId("");
            setNoOfHours("");
            setShowAddForm(false); // Hide the add form
            // fetchData(adjustmentType);
        } catch (error) {
            console.error('There was a problem adding data:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setShowAddForm(false);
    };
    const handleUpdate = async (event) => {
        event.preventDefault();

        const data = {
            employeePersonalInformationId: employeePersonalInformationId,
            payrollPeriodId: payrollPeriodId,
            payTypeId: payTypeId,
            ...(adjustmentType !== "NightDifferentialsStaging" && { description: description }),
            amount: amount,
            ...(adjustmentType === "OtherAdjustmentStaging" && { noOfHours: noOfHours }),
            ...(adjustmentType === "OtherAdjustmentStaging" && { adjustmentDate: adjustmentDate }),
            ...(adjustmentType === "OtherAdjustmentStaging" && { referenceId: referenceId }),
            ...(adjustmentType === "OtherAdjustmentStaging" && { transactionType: "Leave"}),
        };

        try {
            setLoadingRequest(true);
            await axios.put(apiUrl + `${adjustmentType}/${editById}`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            let field = "";

            if(adjustmentType === "OtherAdditionStaging"){
                field = "Other Addition Update";
            } else if(adjustmentType === "OtherDeductionStaging"){
                field = "Other Deduction Update";
            } else if(adjustmentType === "OtherAdjustmentStaging"){
                field = "Other Adjustment Update";
            }  else if(adjustmentType === "NightDifferentialsStaging"){
                field = "Night Differential Update";
            }

            let auditInfo = [];

            if(data.employeePersonalInformationId !== oldEmployeePersonalInformationId){
                auditInfo.push({
                    setupArea: "Payroll",
                    actionTaken: "update",
                    field: field,
                    newValue: `${data.employeePersonalInformationId}`,
                    oldValue: `${oldEmployeePersonalInformationId}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if(data.payrollPeriodId !== oldPayrollPeriodId){
                auditInfo.push({
                    setupArea: "Payroll",
                    actionTaken: "update",
                    field: field,
                    newValue: `${data.payrollPeriodId}`,
                    oldValue: `${oldPayrollPeriodId}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if(data.payTypeId !== oldPayTypeId){
                auditInfo.push({
                    setupArea: "Payroll",
                    actionTaken: "update",
                    field: field,
                    newValue: `${data.payTypeId}`,
                    oldValue: `${oldPayTypeId}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if(data.description !== oldDescription){
                auditInfo.push({
                    setupArea: "Payroll",
                    actionTaken: "update",
                    field: field,
                    newValue: `${data.description}`,
                    oldValue: `${oldDescription}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if(data.amount !== oldAmount){
                auditInfo.push({
                    setupArea: "Payroll",
                    actionTaken: "update",
                    field: field,
                    newValue: `${data.amount}`,
                    oldValue: `${oldAmount}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if(data.adjustmentDate !== oldAdjustmentDate){
                auditInfo.push({
                    setupArea: "Payroll",
                    actionTaken: "update",
                    field: field,
                    newValue: `${data.adjustmentDate}`,
                    oldValue: `${oldAdjustmentDate}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if(data.referenceId !== oldReferenceId){
                auditInfo.push({
                    setupArea: "Payroll",
                    actionTaken: "update",
                    field: field,
                    newValue: `${data.referenceId}`,
                    oldValue: `${oldReferenceId}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            await SetAuditTrailBulk({data: auditInfo});
            await fetchAdditionData();
            await fetchDeductionData();
            await fetchAdjustmentData();
            await fetchNightDiffData();
            await fetchDataProcessedPayroll();

            console.log('Data added successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);
            
            // Reload table data and reset form fields
            setEmployeePersonalInformationId("");
            setPayrollPeriodId("");
            setPayTypeId("");
            setDescription("");
            setAmount("");
            setAdjustmentDate("");
            setReferenceId("");
            setNoOfHours("");
            setShowEditForm(false); // Hide the add form
            // fetchData(adjustmentType);
        } catch (error) {
            console.error('There was a problem adding data:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setShowEditForm(false);
    };
    const handleDelete = async () => {
        try {
            setLoadingRequest(true);
            await axios.delete(apiUrl + `${adjustmentType}/${deleteById}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            let field = "";

            if(adjustmentType === "OtherAdditionStaging"){
                field = "Other Addition";
            } else if(adjustmentType === "OtherDeductionStaging"){
                field = "Other Deduction";
            } else if(adjustmentType === "OtherAdjustmentStaging"){
                field = "Other Adjustment";
            } else if(adjustmentType === "NightDifferentialsStaging"){
                field = "Night Differential";
            }

            await SetAuditTrail({
                setupArea: "Payroll", 
                actionTaken: "delete", 
                field: field, 
                newValue: `-`, 
                oldValue: `${deleteData.employeePersonalInformationFullName}`, 
                dateSaved: new Date(), 
                savedById: user.id
            });
            await fetchAdditionData();
            await fetchDeductionData();
            await fetchAdjustmentData();
            await fetchNightDiffData();
            await fetchDataProcessedPayroll();

            console.log('Deleted successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);
        
            // Reload table data and reset state
            setShowDeleteForm(false);
            setDeleteById("");
            // fetchData(adjustmentType);
        } catch (error) {
            console.error('There was a problem deleting employee:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }
        
        setShowDeleteForm(false);
    };
    const handleDeleteAll = async () => {
        if (!payrollIdForDelete) {
            alert("Please select payroll period id");
            return; // Exit early if fields are empty
        }

        try {
            setLoadingRequest(true);
            await axios.delete(apiUrl + `${adjustmentType}/paytype/${payTypeIdForDelete}/payrollperiod/${payrollIdForDelete}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            let field = "";

            if(adjustmentType === "OtherAdditionStaging"){
                field = "Other Addition";
            } else if(adjustmentType === "OtherDeductionStaging"){
                field = "Other Deduction";
            } else if(adjustmentType === "OtherAdjustmentStaging"){
                field = "Other Adjustment";
            } else if(adjustmentType === "NightDifferentialsStaging"){
                field = "Night Differential";
            }

            await SetAuditTrail({
                setupArea: "Payroll", 
                actionTaken: "delete all", 
                field: field, 
                newValue: `-`, 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });
            await fetchAdditionData();
            await fetchDeductionData();
            await fetchAdjustmentData();
            await fetchNightDiffData();
            await fetchDataProcessedPayroll();

            console.log('Deleted successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);
        
            // Reload table data and reset state
            setShowDeleteAllForm(false);
            setPayrollIdForDelete("");
            // fetchData(adjustmentType);
        } catch (error) {
            console.error('There was a problem deleting employee:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }
        
        setShowDeleteAllForm(false);
    };

    const addHandleClick = () => {
        setShowAddForm(true);
    };
    const editHandleClick = (data) => {
        setEditById(data.id);
        setDataToEdit(data);
        setShowEditForm(true);
    };
    const deleteHandleClick = (data) => {
        setShowDeleteForm(true);
        setDeleteById(data.id);
        setDeleteData(data);
    };
    const deleteAllHandleClick = (data) => {
        setShowDeleteAllForm(true);
    };
    const closeAddHandleClick = () => {
        setShowAddForm(false);
    };
    const closeEditHandleClick = () => {
        setShowEditForm(false);
    };
    const closeDeleteHandleClick = () => {
        setShowDeleteForm(false);
    };
    const closeDeleteAllHandleClick = () => {
        setShowDeleteAllForm(false);
    };
    const closeEmployeeForm = () => {
        setShowEmployeeForm(false);
    };
    const closeReferenceIdForm = () => {
        setReferenceIdForm(false);
    };

    return (
        <div>
            <div className="mainte-body-top row">
                    {CreateSearchBarWithPlaceHolder("", 
                                                    "mainte-search row", 
                                                    "mainte-search-icon", 
                                                    "mainte-search-input", 
                                                    (e) => handleFilter(e.target.value), 
                                                    "Search by name", 
                                                    SearchIcon)}
            </div>
            <div className="payroll-tab-header row">
                <div className="payroll-tab-leftSide row">
                    <div className="leftSide-btn"><button id={activeButton === 'btn-tab-addition' ? 'btn-tab-active' : ''} onClick={() => { handleClick('btn-tab-addition'); handleOtherFunction('btn-tab-addition'); }}>OTHER ADDITIONS</button></div>
                    <div className="leftSide-btn"><button id={activeButton === 'btn-tab-deductions' ? 'btn-tab-active' : ''} onClick={() => { handleClick('btn-tab-deductions'); handleOtherFunction('btn-tab-deductions'); }}>OTHER DEDUCTIONS</button></div>
                    <div className="leftSide-btn"><button id={activeButton === 'btn-tab-adjustments' ? 'btn-tab-active' : ''} onClick={() => { handleClick('btn-tab-adjustments'); handleOtherFunction('btn-tab-adjustments'); }}>ADJUSTMENTS</button></div>
                    <div className="leftSide-btn"><button id={activeButton === 'btn-tab-nightDiff' ? 'btn-tab-active' : ''} onClick={() => { handleClick('btn-tab-nightDiff'); handleOtherFunction('btn-tab-nightDiff'); }}>NIGHT DIFFERENTIAL</button></div>
                </div>
                <div className="payroll-tab-rightSide row">
                    <div className="rightSide-btn">{CreateButton("", "add row", addHandleClick, "NEW", NoteAddIcon)}</div>
                    <div className="rightSide-btn">{CreateButton("", "delete row", deleteAllHandleClick, "DELETE ALL", DeleteSweepIcon)}</div>
                </div>
            </div>
            <div className="payroll-tables">
            <div id='addition-table' className="payroll-table container" style={{display:"block"}}>
                <CreateTable
                    dataList={otherAdditionData} 
                    dataHeader={adjustmentsHeader}
                    dataAccessor={adjustmentsAccesor}
                    editHandleClick={editHandleClick}
                    deleteHandleClick={deleteHandleClick}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                />
                {otherAdditionData.length > 0 ? (
                    <div></div>
                )
                :
                (
                    <div>
                    {loadingOtherAddition ? (
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                            <img src={loadingSpinner} alt="Loading..." />
                        </div>
                    ) : (
                            <div> {/*<p>No records to display</p>*/}</div>
                        )
                    }
                    </div>
                )}
            </div>
            <div id='deduction-table' className="payroll-table container">
                <CreateTable
                    dataList={otherDeductionData}
                    dataHeader={adjustmentsHeader}
                    dataAccessor={adjustmentsAccesor}
                    editHandleClick={editHandleClick}
                    deleteHandleClick={deleteHandleClick}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                />
                {otherDeductionData.length > 0 ? (
                    <div></div>
                )
                :
                (
                    <div>
                    {loadingOtherDedujction ? (
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                            <img src={loadingSpinner} alt="Loading..." />
                        </div>
                    ) : (
                            <div> {/*<p>No records to display</p>*/}</div>
                        )
                    }
                    </div>
                )}
            </div>
            <div id='adjustment-table' className="payroll-table container">
                <CreateTable
                    dataList={otherAdjustmentData}
                    dataHeader={adjustmentsHeader}
                    dataAccessor={adjustmentsAccesor}
                    editHandleClick={editHandleClick}
                    deleteHandleClick={deleteHandleClick}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                />
                {otherAdjustmentData.length > 0 ? (
                    <div></div>
                )
                :
                (
                    <div>
                    {loadingAdjustment ? (
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                            <img src={loadingSpinner} alt="Loading..." />
                        </div>
                    ) : (
                            <div> {/*<p>No records to display</p>*/}</div>
                        )
                    }
                    </div>
                )}
            </div>
            <div id='nightDiff-table' className="payroll-table container">
                <CreateTable
                    dataList={otherNightDiff}
                    dataHeader={nightDiffHeader}
                    dataAccessor={nightDiffAccessor}
                    editHandleClick={editHandleClick}
                    deleteHandleClick={deleteHandleClick}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                />
                {otherNightDiff.length > 0 ? (
                    <div></div>
                )
                :
                (
                    <div>
                    {loadingNightDiff ? (
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                            <img src={loadingSpinner} alt="Loading..." />
                        </div>
                    ) : (
                            <div> {/*<p>No records to display</p>*/}</div>
                        )
                    }
                    </div>
                )}
            </div>
        </div>
        <AddForm  isOpen={showAddForm} 
                onClose={closeAddHandleClick}
                employeePersonalInformationId={employeePersonalInformationId}
                employeePersonalInformationFullName={employeePersonalInformationFullName}
                payrollPeriodId={payrollPeriodId}
                payTypeId={payTypeId}
                description={description}
                amount={amount}
                noOfHours={noOfHours}
                adjustmentDate={adjustmentDate}
                referenceId={referenceId}
                setEployeePersonalInformationId={setEmployeePersonalInformationId}
                setPayrollPeriodId={setPayrollPeriodId}
                setPayTypeId={setPayTypeId}
                setDescription={setDescription}
                setAmount={setAmount}
                setNoOfHours={setNoOfHours}
                setAdjustmentDate={setAdjustmentDate}
                setReferenceId={setReferenceId}
                setShowEmployeeForm={setShowEmployeeForm}
                setReferenceIdForm={setReferenceIdForm}
                adjustmentType={adjustmentType}
                handleSubmit={handleSubmit}
        ></AddForm>
        <EditForm  isOpen={showEditForm} 
                    onClose={closeEditHandleClick}
                    employeePersonalInformationId={employeePersonalInformationId}
                    employeePersonalInformationFullName={employeePersonalInformationFullName}
                    payrollPeriodId={payrollPeriodId}
                    payTypeId={payTypeId}
                    description={description}
                    amount={amount}
                    noOfHours={noOfHours}
                    adjustmentDate={adjustmentDate}
                    referenceId={referenceId}
                    setEployeePersonalInformationId={setEmployeePersonalInformationId}
                    setPayrollPeriodId={setPayrollPeriodId}
                    setPayTypeId={setPayTypeId}
                    setDescription={setDescription}
                    setAmount={setAmount}
                    setNoOfHours={setNoOfHours}
                    setAdjustmentDate={setAdjustmentDate}
                    setReferenceId={setReferenceId}
                    setShowEmployeeForm={setShowEmployeeForm}
                    setReferenceIdForm={setReferenceIdForm}
                    adjustmentType={adjustmentType}
                    handleUpdate={handleUpdate}
        >
        </EditForm>
        <DeleteForm  isOpen={showDeleteForm} 
                    onClose={closeDeleteHandleClick}
                    handleDelete={handleDelete}
            >
        </DeleteForm>
        <DeleteAllForm  isOpen={showDeleteAllForm} 
                    onClose={closeDeleteAllHandleClick}
                    payrollPeriodId={payrollIdForDelete}
                    payTypeId={payTypeIdForDelete}
                    setPayrollPeriodId={setPayrollIdForDelete}
                    setPayTypeId={setPayTypeIdForDelete}
                    handleDelete={handleDeleteAll}
            >
        </DeleteAllForm>
        <EmployeeSelectForm  isOpen={showEmployeeForm} 
                    onClose={closeEmployeeForm}
                    setEmployeeId={setEmployeePersonalInformationId}
                    setEmployee={setEmployeePersonalInformationFullName}
                    userAccessData={userAccess}
        >
        </EmployeeSelectForm>
        <ReferenceSelectForm  isOpen={referenceIdForm} 
                    employeePersonalInformationId={employeePersonalInformationId}
                    onClose={closeReferenceIdForm}
                    setReferenceId={setReferenceId}
                    setAdjustmentDate={setAdjustmentDate}
        >
        </ReferenceSelectForm>
        <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
        > 
        </GenerateMessage>
        {loadingRequest ? (
            <div style={{ position:"fixed", top:"50%", left:"50%", transform:"translate(-50%, -50%)", zIndex:"3005"}}>
                <img src={loadingSpinner} alt="Loading..." />
            </div>
        ) : (
            <></>
            )
        }
    </div>
    )
}
function AddProcessForm({
    isOpen, 
    onClose,
    payrollPeriodId,
    employeePersonalInformationId,
    employeePersonalInformationFullName,
    payTypeId,
    totalEcola,
    totalAllowance,
    totalTax,
    totalDays,
    totalDaysAbsents,
    totalAbsents,
    totalDaysLeaves,
    totalLeaves,
    totalDeduction,
    totalAddition,
    totalAdjustment,
    rate,
    totalNighDiff,
    totalHoursOTRegular,
    totalOTRegular,
    totalHoursOTRegularExceeded,
    totalOTRegularExceeded,
    totalHoursOTRestday,
    totalOTRestday,
    totalHoursOTRestdayExceeded,
    totalOTRestdayExceeded,
    totalHoursOTHolidaySpecial,
    totalOTHolidaySpecial,
    totalHoursOTHolidaySpecialExceeded,
    totalOTHolidaySpecialExceeded,
    totalHoursOTHolidayRegular,
    totalOTHolidayRegular,
    totalHoursOTHolidayRegularExceeded,
    totalOTHolidayRegularExceeded,
    totalHoursOTRestdayHolidaySpecial,
    totalOTRestdayHolidaySpecial,
    totalHoursOTRestdayHolidaySpecialExceeded,
    totalOTRestdayHolidaySpecialExceeded,
    totalHoursOTRestdayHolidayRegular,
    totalOTRestdayHolidayRegular,
    totalHoursOTRestdayHolidayRegularExceeded,
    totalOTRestdayHolidayRegularExceeded,
    totalSSS,
    totalPagibig,
    totalPhilhealth,
    totalHoursUndertime,
    totalUndertime,
    totalHoursLate,
    totalLate,
    totalBasic,
    totalGrossPay,
    totalNetPay,
    dateProcessed,
    userId,
    setPayrollPeriodId,
    setEmployeePersonalInformationId,
    setPayTypeId,
    setTotalEcola,
    setTotalAllowance,
    setTotalTax,
    setTotalDays,
    setTotalDaysAbsents,
    setTotalAbsents,
    setTotalDaysLeaves,
    setTotalLeaves,
    setTotalDeduction,
    setTotalAddition,
    setTotalAdjustment,
    setRate,
    setTotalNighDiff,
    setTotalHoursOTRegular,
    setTotalOTRegular,
    setTotalHoursOTRegularExceeded,
    setTotalOTRegularExceeded,
    setTotalHoursOTRestday,
    setTotalOTRestday,
    setTotalHoursOTRestdayExceeded,
    setTotalOTRestdayExceeded,
    setTotalHoursOTHolidaySpecial,
    setTotalOTHolidaySpecial,
    setTotalHoursOTHolidaySpecialExceeded,
    setTotalOTHolidaySpecialExceeded,
    setTotalHoursOTHolidayRegular,
    setTotalOTHolidayRegular,
    setTotalHoursOTHolidayRegularExceeded,
    setTotalOTHolidayRegularExceeded,
    setTotalHoursOTRestdayHolidaySpecial,
    setTotalOTRestdayHolidaySpecial,
    setTotalHoursOTRestdayHolidaySpecialExceeded,
    setTotalOTRestdayHolidaySpecialExceeded,
    setTotalHoursOTRestdayHolidayRegular,
    setTotalOTRestdayHolidayRegular,
    setTotalHoursOTRestdayHolidayRegularExceeded,
    setTotalOTRestdayHolidayRegularExceeded,
    setTotalSSS,
    setTotalPagibig,
    setTotalPhilhealth,
    setTotalHoursUndertime,
    setTotalUndertime,
    setTotalHoursLate,
    setTotalLate,
    setTotalBasic,
    setTotalGrossPay,
    setTotalNetPay,
    setDateProcessed,
    setUserId,
    setShowEmployeeForm,
    handleSubmit}) 
{
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if (!payrollPeriodId || !employeePersonalInformationId || !payTypeId) {
            setErrorState(true);
            return;
        }
        handleSubmit(e);
        setErrorState(false);
    };

    const handleClose = () => {
        onClose();
        setPayrollPeriodId("");
        setEmployeePersonalInformationId("");
        setPayTypeId("");
        setTotalEcola("");
        setTotalAllowance("");
        setTotalTax("");
        setTotalDays("");
        setTotalDaysAbsents("");
        setTotalAbsents("");
        setTotalDaysLeaves("");
        setTotalLeaves("");
        setTotalDeduction("");
        setTotalAddition("");
        setTotalAdjustment("");
        setRate("");
        setTotalNighDiff("");
        setTotalHoursOTRegular("");
        setTotalOTRegular("");
        setTotalHoursOTRegularExceeded("");
        setTotalOTRegularExceeded("");
        setTotalHoursOTRestday("");
        setTotalOTRestday("");
        setTotalHoursOTRestdayExceeded("");
        setTotalOTRestdayExceeded("");
        setTotalHoursOTHolidaySpecial("");
        setTotalOTHolidaySpecial("");
        setTotalHoursOTHolidaySpecialExceeded("");
        setTotalOTHolidaySpecialExceeded("");
        setTotalHoursOTHolidayRegular("");
        setTotalOTHolidayRegular("");
        setTotalHoursOTHolidayRegularExceeded("");
        setTotalOTHolidayRegularExceeded("");
        setTotalHoursOTRestdayHolidaySpecial("");
        setTotalOTRestdayHolidaySpecial("");
        setTotalHoursOTRestdayHolidaySpecialExceeded("");
        setTotalOTRestdayHolidaySpecialExceeded("");
        setTotalHoursOTRestdayHolidayRegular("");
        setTotalOTRestdayHolidayRegular("");
        setTotalHoursOTRestdayHolidayRegularExceeded("");
        setTotalOTRestdayHolidayRegularExceeded("");
        setTotalSSS("");
        setTotalPagibig("");
        setTotalPhilhealth("");
        setTotalHoursUndertime("");
        setTotalUndertime("");
        setTotalHoursLate("");
        setTotalLate("");
        setTotalBasic("");
        setTotalGrossPay("");
        setTotalNetPay("");
        setDateProcessed("");
        setUserId("");
        setErrorState(false);
    };
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Add Processed Payroll</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Employee</div>
                            <div className="info-item-input">
                                <div className="info-item-holder employee-select row" style={{flexDirection:"row", justifyContent:"normal"}}>
                                    <input
                                        readOnly
                                        className='employeeInput-select'
                                        placeholder="Employee"
                                        value={employeePersonalInformationId ? (employeePersonalInformationFullName) : employeePersonalInformationId}
                                    />
                                    <button className="select row"
                                            onClick={()=>setShowEmployeeForm(true)}
                                    ><SearchIcon/></button>
                                </div>
                                <span style={{
                                        visibility: !employeePersonalInformationId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Payroll Period</div>
                                <div className="info-item-input">
                                    <PayrollPeriodIdSelect payrollPeriodId={payrollPeriodId} setPayrollPeriodId={setPayrollPeriodId}/>
                                </div>
                                <span style={{
                                        visibility: !payrollPeriodId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Pay Type</div>
                                <div className="info-item-input">
                                    <PayTypeIdSelect payTypeId={payTypeId} setPayTypeId={setPayTypeId}/>
                                </div>
                                <span style={{
                                        visibility: !payTypeId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Ecola</div>
                                <div className="info-item-input">
                                    <input
                                    type='number'
                                    placeholder="Total Ecola"
                                    value={totalEcola}
                                    onChange={(e) => setTotalEcola(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Allowance</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Allowance"
                                        value={totalAllowance}
                                        onChange={(e) => setTotalAllowance(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Tax</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Tax"
                                        value={totalTax}
                                        onChange={(e) => setTotalTax(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Days</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Days"
                                        value={totalDays}
                                        onChange={(e) => setTotalDays(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Days Absents</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Days Absents"
                                        value={totalDaysAbsents}
                                        onChange={(e) => setTotalDaysAbsents(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Absents</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Absents"
                                        value={totalAbsents}
                                        onChange={(e) => setTotalAbsents(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Days Leaves</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Days Leaves"
                                        value={totalDaysLeaves}
                                        onChange={(e) => setTotalDaysLeaves(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Leaves</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Leaves"
                                        value={totalLeaves}
                                        onChange={(e) => setTotalLeaves(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Deduction</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Deduction"
                                        value={totalDeduction}
                                        onChange={(e) => setTotalDeduction(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Addition</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Addition"
                                        value={totalAddition}
                                        onChange={(e) => setTotalAddition(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Adjustment</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Adjustment"
                                        value={totalAdjustment}
                                        onChange={(e) => setTotalAdjustment(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Rate</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Rate"
                                        value={rate}
                                        onChange={(e) => setRate(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Night Diff</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Night Diff"
                                        value={totalNighDiff}
                                        onChange={(e) => setTotalNighDiff(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Hours OT Regular</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Hours OT Regular"
                                        value={totalHoursOTRegular}
                                        onChange={(e) => setTotalHoursOTRegular(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total OT Regular</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total OT Regular"
                                        value={totalOTRegular}
                                        onChange={(e) => setTotalOTRegular(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Hours OT Regular Exceeded</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Hours OT Regular Exceeded"
                                        value={totalHoursOTRegularExceeded}
                                        onChange={(e) => setTotalHoursOTRegularExceeded(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total OT Regular Exceeded</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total OT Regular Exceeded"
                                        value={totalOTRegularExceeded}
                                        onChange={(e) => setTotalOTRegularExceeded(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Hours OT Restday</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Hours OT Restday"
                                        value={totalHoursOTRestday}
                                        onChange={(e) => setTotalHoursOTRestday(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total OT Restday</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total OT Restday"
                                        value={totalOTRestday}
                                        onChange={(e) => setTotalOTRestday(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Hours OT Restday Exceeded</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Hours OT Restday Exceeded"
                                        value={totalHoursOTRestdayExceeded}
                                        onChange={(e) => setTotalHoursOTRestdayExceeded(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total OT Restday Exceeded</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total OT Restday Exceeded"
                                        value={totalOTRestdayExceeded}
                                        onChange={(e) => setTotalOTRestdayExceeded(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Hours OT Holiday Special</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Hours OT Holiday Special"
                                        value={totalHoursOTHolidaySpecial}
                                        onChange={(e) => setTotalHoursOTHolidaySpecial(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total OT Holiday Special</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total OT Holiday Special"
                                        value={totalOTHolidaySpecial}
                                        onChange={(e) => setTotalOTHolidaySpecial(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Hours OT Holiday Special Exceeded</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Hours OT Holiday Special Exceeded"
                                        value={totalHoursOTHolidaySpecialExceeded}
                                        onChange={(e) => setTotalHoursOTHolidaySpecialExceeded(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total OT Holiday Special Exceeded</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total OT Holiday Special Exceeded"
                                        value={totalOTHolidaySpecialExceeded}
                                        onChange={(e) => setTotalOTHolidaySpecialExceeded(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Hours OT Holiday Regular</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Hours OT Holiday Regular"
                                        value={totalHoursOTHolidayRegular}
                                        onChange={(e) => setTotalHoursOTHolidayRegular(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total OT Holiday Regular</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total OT Holiday Regular"
                                        value={totalOTHolidayRegular}
                                        onChange={(e) => setTotalOTHolidayRegular(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Hours OT Holiday Regular Exceeded</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Hours OT Holiday Regular Exceeded"
                                        value={totalHoursOTHolidayRegularExceeded}
                                        onChange={(e) => setTotalHoursOTHolidayRegularExceeded(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total OT Holiday Regular Exceeded</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total OT Holiday Regular Exceeded"
                                        value={totalOTHolidayRegularExceeded}
                                        onChange={(e) => setTotalOTHolidayRegularExceeded(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Hours OT Restday Holiday Special</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Hours OT Restday Holiday Special"
                                        value={totalHoursOTRestdayHolidaySpecial}
                                        onChange={(e) => setTotalHoursOTRestdayHolidaySpecial(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total OT Restday Holiday Special</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total OT Restday Holiday Special"
                                        value={totalOTRestdayHolidaySpecial}
                                        onChange={(e) => setTotalOTRestdayHolidaySpecial(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Hours OT Restday Holiday Special Exceeded</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Hours OT Restday Holiday Special Exceeded"
                                        value={totalHoursOTRestdayHolidaySpecialExceeded}
                                        onChange={(e) => setTotalHoursOTRestdayHolidaySpecialExceeded(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total OT Restday Holiday Special Exceeded</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total OT Restday Holiday Special Exceeded"
                                        value={totalOTRestdayHolidaySpecialExceeded}
                                        onChange={(e) => setTotalOTRestdayHolidaySpecialExceeded(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Hours OT Restday Holiday Regular</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Hours OT Restday Holiday Regular"
                                        value={totalHoursOTRestdayHolidayRegular}
                                        onChange={(e) => setTotalHoursOTRestdayHolidayRegular(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total OT Restday Holiday Regular</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total OT Restday Holiday Regular"
                                        value={totalOTRestdayHolidayRegular}
                                        onChange={(e) => setTotalOTRestdayHolidayRegular(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Hours OT Restday Holiday Regular Exceeded</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Hours OT Restday Holiday Regular Exceeded"
                                        value={totalHoursOTRestdayHolidayRegularExceeded}
                                        onChange={(e) => setTotalHoursOTRestdayHolidayRegularExceeded(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total OT Restday Holiday Regular Exceeded</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total OT Restday Holiday Regular Exceeded"
                                        value={totalOTRestdayHolidayRegularExceeded}
                                        onChange={(e) => setTotalOTRestdayHolidayRegularExceeded(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total SSS</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total SSS"
                                        value={totalSSS}
                                        onChange={(e) => setTotalSSS(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Pagibig</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Pagibig"
                                        value={totalPagibig}
                                        onChange={(e) => setTotalPagibig(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Philhealth</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Philhealth"
                                        value={totalPhilhealth}
                                        onChange={(e) => setTotalPhilhealth(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Hours Undertime</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Hours Undertime"
                                        value={totalHoursUndertime}
                                        onChange={(e) => setTotalHoursUndertime(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Undertime</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Undertime"
                                        value={totalUndertime}
                                        onChange={(e) => setTotalUndertime(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Hours Late</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Hours Late"
                                        value={totalHoursLate}
                                        onChange={(e) => setTotalHoursLate(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Late</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Late"
                                        value={totalLate}
                                        onChange={(e) => setTotalLate(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Basic</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Basic"
                                        value={totalBasic}
                                        onChange={(e) => setTotalBasic(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Gross Pay</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Gross Pay"
                                        value={totalGrossPay}
                                        onChange={(e) => setTotalGrossPay(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Net Pay</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Net Pay"
                                        value={totalNetPay}
                                        onChange={(e) => setTotalNetPay(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">User ID</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="User ID"
                                        value={userId}
                                        onChange={(e) => setUserId(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                SAVE
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function EditProcessForm({isOpen, 
    onClose, 
    payrollPeriodId,
    employeePersonalInformationId,
    employeePersonalInformationFullName,
    payTypeId,
    totalEcola,
    totalAllowance,
    totalTax,
    totalDays,
    totalDaysAbsents,
    totalAbsents,
    totalDaysLeaves,
    totalLeaves,
    totalDeduction,
    totalAddition,
    totalAdjustment,
    rate,
    totalNighDiff,
    totalHoursOTRegular,
    totalOTRegular,
    totalHoursOTRegularExceeded,
    totalOTRegularExceeded,
    totalHoursOTRestday,
    totalOTRestday,
    totalHoursOTRestdayExceeded,
    totalOTRestdayExceeded,
    totalHoursOTHolidaySpecial,
    totalOTHolidaySpecial,
    totalHoursOTHolidaySpecialExceeded,
    totalOTHolidaySpecialExceeded,
    totalHoursOTHolidayRegular,
    totalOTHolidayRegular,
    totalHoursOTHolidayRegularExceeded,
    totalOTHolidayRegularExceeded,
    totalHoursOTRestdayHolidaySpecial,
    totalOTRestdayHolidaySpecial,
    totalHoursOTRestdayHolidaySpecialExceeded,
    totalOTRestdayHolidaySpecialExceeded,
    totalHoursOTRestdayHolidayRegular,
    totalOTRestdayHolidayRegular,
    totalHoursOTRestdayHolidayRegularExceeded,
    totalOTRestdayHolidayRegularExceeded,
    totalSSS,
    totalPagibig,
    totalPhilhealth,
    totalHoursUndertime,
    totalUndertime,
    totalHoursLate,
    totalLate,
    totalBasic,
    totalGrossPay,
    totalNetPay,
    dateProcessed,
    userId,
    setPayrollPeriodId,
    setEmployeePersonalInformationId,
    setPayTypeId,
    setTotalEcola,
    setTotalAllowance,
    setTotalTax,
    setTotalDays,
    setTotalDaysAbsents,
    setTotalAbsents,
    setTotalDaysLeaves,
    setTotalLeaves,
    setTotalDeduction,
    setTotalAddition,
    setTotalAdjustment,
    setRate,
    setTotalNighDiff,
    setTotalHoursOTRegular,
    setTotalOTRegular,
    setTotalHoursOTRegularExceeded,
    setTotalOTRegularExceeded,
    setTotalHoursOTRestday,
    setTotalOTRestday,
    setTotalHoursOTRestdayExceeded,
    setTotalOTRestdayExceeded,
    setTotalHoursOTHolidaySpecial,
    setTotalOTHolidaySpecial,
    setTotalHoursOTHolidaySpecialExceeded,
    setTotalOTHolidaySpecialExceeded,
    setTotalHoursOTHolidayRegular,
    setTotalOTHolidayRegular,
    setTotalHoursOTHolidayRegularExceeded,
    setTotalOTHolidayRegularExceeded,
    setTotalHoursOTRestdayHolidaySpecial,
    setTotalOTRestdayHolidaySpecial,
    setTotalHoursOTRestdayHolidaySpecialExceeded,
    setTotalOTRestdayHolidaySpecialExceeded,
    setTotalHoursOTRestdayHolidayRegular,
    setTotalOTRestdayHolidayRegular,
    setTotalHoursOTRestdayHolidayRegularExceeded,
    setTotalOTRestdayHolidayRegularExceeded,
    setTotalSSS,
    setTotalPagibig,
    setTotalPhilhealth,
    setTotalHoursUndertime,
    setTotalUndertime,
    setTotalHoursLate,
    setTotalLate,
    setTotalBasic,
    setTotalGrossPay,
    setTotalNetPay,
    setDateProcessed,
    setUserId,
    setShowEmployeeForm,
    handleUpdate})
{
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if (!payrollPeriodId || !employeePersonalInformationId || !payTypeId) {
            setErrorState(true);
            return;
        }
        handleUpdate(e);
        setErrorState(false);
    };

    const handleClose = () => {
        setErrorState(false);
        onClose();
        setPayrollPeriodId("");
        setEmployeePersonalInformationId("");
        setPayTypeId("");
        setTotalEcola("");
        setTotalAllowance("");
        setTotalTax("");
        setTotalDays("");
        setTotalDaysAbsents("");
        setTotalAbsents("");
        setTotalDaysLeaves("");
        setTotalLeaves("");
        setTotalDeduction("");
        setTotalAddition("");
        setTotalAdjustment("");
        setRate("");
        setTotalNighDiff("");
        setTotalHoursOTRegular("");
        setTotalOTRegular("");
        setTotalHoursOTRegularExceeded("");
        setTotalOTRegularExceeded("");
        setTotalHoursOTRestday("");
        setTotalOTRestday("");
        setTotalHoursOTRestdayExceeded("");
        setTotalOTRestdayExceeded("");
        setTotalHoursOTHolidaySpecial("");
        setTotalOTHolidaySpecial("");
        setTotalHoursOTHolidaySpecialExceeded("");
        setTotalOTHolidaySpecialExceeded("");
        setTotalHoursOTHolidayRegular("");
        setTotalOTHolidayRegular("");
        setTotalHoursOTHolidayRegularExceeded("");
        setTotalOTHolidayRegularExceeded("");
        setTotalHoursOTRestdayHolidaySpecial("");
        setTotalOTRestdayHolidaySpecial("");
        setTotalHoursOTRestdayHolidaySpecialExceeded("");
        setTotalOTRestdayHolidaySpecialExceeded("");
        setTotalHoursOTRestdayHolidayRegular("");
        setTotalOTRestdayHolidayRegular("");
        setTotalHoursOTRestdayHolidayRegularExceeded("");
        setTotalOTRestdayHolidayRegularExceeded("");
        setTotalSSS("");
        setTotalPagibig("");
        setTotalPhilhealth("");
        setTotalHoursUndertime("");
        setTotalUndertime("");
        setTotalHoursLate("");
        setTotalLate("");
        setTotalBasic("");
        setTotalGrossPay("");
        setTotalNetPay("");
        setDateProcessed("");
        setUserId("");
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Update Processed Payroll</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Employee</div>
                            <div className="info-item-input">
                                <div className="info-item-holder employee-select row" style={{flexDirection:"row", justifyContent:"normal"}}>
                                    <input
                                        readOnly
                                        className='employeeInput-select'
                                        placeholder="Employee"
                                        style={{cursor:"not-allowed"}}
                                        value={employeePersonalInformationId ? (employeePersonalInformationFullName) : employeePersonalInformationId}
                                    />
                                </div>
                                <span style={{
                                        visibility: !employeePersonalInformationId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Payroll Period</div>
                                <div className="info-item-input">
                                    <PayrollPeriodIdSelect payrollPeriodId={payrollPeriodId} setPayrollPeriodId={setPayrollPeriodId}/>
                                </div>
                                <span style={{
                                        visibility: !payrollPeriodId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Pay Type</div>
                                <div className="info-item-input">
                                    <PayTypeIdSelect payTypeId={payTypeId} setPayTypeId={setPayTypeId}/>
                                </div>
                                <span style={{
                                        visibility: !payTypeId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Ecola</div>
                                <div className="info-item-input">
                                    <input
                                    type='number'
                                    placeholder="Total Ecola"
                                    value={totalEcola}
                                    onChange={(e) => setTotalEcola(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Allowance</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Allowance"
                                        value={totalAllowance}
                                        onChange={(e) => setTotalAllowance(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Tax</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Tax"
                                        value={totalTax}
                                        onChange={(e) => setTotalTax(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Days</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Days"
                                        value={totalDays}
                                        onChange={(e) => setTotalDays(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Days Absents</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Days Absents"
                                        value={totalDaysAbsents}
                                        onChange={(e) => setTotalDaysAbsents(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Absents</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Absents"
                                        value={totalAbsents}
                                        onChange={(e) => setTotalAbsents(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Days Leaves</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Days Leaves"
                                        value={totalDaysLeaves}
                                        onChange={(e) => setTotalDaysLeaves(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Leaves</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Leaves"
                                        value={totalLeaves}
                                        onChange={(e) => setTotalLeaves(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Deduction</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Deduction"
                                        value={totalDeduction}
                                        onChange={(e) => setTotalDeduction(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Addition</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Addition"
                                        value={totalAddition}
                                        onChange={(e) => setTotalAddition(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Adjustment</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Adjustment"
                                        value={totalAdjustment}
                                        onChange={(e) => setTotalAdjustment(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Rate</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Rate"
                                        value={rate}
                                        onChange={(e) => setRate(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Night Diff</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Night Diff"
                                        value={totalNighDiff}
                                        onChange={(e) => setTotalNighDiff(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Hours OT Regular</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Hours OT Regular"
                                        value={totalHoursOTRegular}
                                        onChange={(e) => setTotalHoursOTRegular(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total OT Regular</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total OT Regular"
                                        value={totalOTRegular}
                                        onChange={(e) => setTotalOTRegular(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Hours OT Regular Exceeded</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Hours OT Regular Exceeded"
                                        value={totalHoursOTRegularExceeded}
                                        onChange={(e) => setTotalHoursOTRegularExceeded(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total OT Regular Exceeded</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total OT Regular Exceeded"
                                        value={totalOTRegularExceeded}
                                        onChange={(e) => setTotalOTRegularExceeded(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Hours OT Restday</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Hours OT Restday"
                                        value={totalHoursOTRestday}
                                        onChange={(e) => setTotalHoursOTRestday(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total OT Restday</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total OT Restday"
                                        value={totalOTRestday}
                                        onChange={(e) => setTotalOTRestday(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Hours OT Restday Exceeded</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Hours OT Restday Exceeded"
                                        value={totalHoursOTRestdayExceeded}
                                        onChange={(e) => setTotalHoursOTRestdayExceeded(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total OT Restday Exceeded</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total OT Restday Exceeded"
                                        value={totalOTRestdayExceeded}
                                        onChange={(e) => setTotalOTRestdayExceeded(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Hours OT Holiday Special</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Hours OT Holiday Special"
                                        value={totalHoursOTHolidaySpecial}
                                        onChange={(e) => setTotalHoursOTHolidaySpecial(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total OT Holiday Special</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total OT Holiday Special"
                                        value={totalOTHolidaySpecial}
                                        onChange={(e) => setTotalOTHolidaySpecial(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Hours OT Holiday Special Exceeded</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Hours OT Holiday Special Exceeded"
                                        value={totalHoursOTHolidaySpecialExceeded}
                                        onChange={(e) => setTotalHoursOTHolidaySpecialExceeded(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total OT Holiday Special Exceeded</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total OT Holiday Special Exceeded"
                                        value={totalOTHolidaySpecialExceeded}
                                        onChange={(e) => setTotalOTHolidaySpecialExceeded(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Hours OT Holiday Regular</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Hours OT Holiday Regular"
                                        value={totalHoursOTHolidayRegular}
                                        onChange={(e) => setTotalHoursOTHolidayRegular(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total OT Holiday Regular</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total OT Holiday Regular"
                                        value={totalOTHolidayRegular}
                                        onChange={(e) => setTotalOTHolidayRegular(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Hours OT Holiday Regular Exceeded</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Hours OT Holiday Regular Exceeded"
                                        value={totalHoursOTHolidayRegularExceeded}
                                        onChange={(e) => setTotalHoursOTHolidayRegularExceeded(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total OT Holiday Regular Exceeded</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total OT Holiday Regular Exceeded"
                                        value={totalOTHolidayRegularExceeded}
                                        onChange={(e) => setTotalOTHolidayRegularExceeded(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Hours OT Restday Holiday Special</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Hours OT Restday Holiday Special"
                                        value={totalHoursOTRestdayHolidaySpecial}
                                        onChange={(e) => setTotalHoursOTRestdayHolidaySpecial(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total OT Restday Holiday Special</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total OT Restday Holiday Special"
                                        value={totalOTRestdayHolidaySpecial}
                                        onChange={(e) => setTotalOTRestdayHolidaySpecial(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Hours OT Restday Holiday Special Exceeded</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Hours OT Restday Holiday Special Exceeded"
                                        value={totalHoursOTRestdayHolidaySpecialExceeded}
                                        onChange={(e) => setTotalHoursOTRestdayHolidaySpecialExceeded(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total OT Restday Holiday Special Exceeded</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total OT Restday Holiday Special Exceeded"
                                        value={totalOTRestdayHolidaySpecialExceeded}
                                        onChange={(e) => setTotalOTRestdayHolidaySpecialExceeded(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Hours OT Restday Holiday Regular</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Hours OT Restday Holiday Regular"
                                        value={totalHoursOTRestdayHolidayRegular}
                                        onChange={(e) => setTotalHoursOTRestdayHolidayRegular(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total OT Restday Holiday Regular</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total OT Restday Holiday Regular"
                                        value={totalOTRestdayHolidayRegular}
                                        onChange={(e) => setTotalOTRestdayHolidayRegular(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Hours OT Restday Holiday Regular Exceeded</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Hours OT Restday Holiday Regular Exceeded"
                                        value={totalHoursOTRestdayHolidayRegularExceeded}
                                        onChange={(e) => setTotalHoursOTRestdayHolidayRegularExceeded(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total OT Restday Holiday Regular Exceeded</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total OT Restday Holiday Regular Exceeded"
                                        value={totalOTRestdayHolidayRegularExceeded}
                                        onChange={(e) => setTotalOTRestdayHolidayRegularExceeded(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total SSS</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total SSS"
                                        value={totalSSS}
                                        onChange={(e) => setTotalSSS(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Pagibig</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Pagibig"
                                        value={totalPagibig}
                                        onChange={(e) => setTotalPagibig(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Philhealth</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Philhealth"
                                        value={totalPhilhealth}
                                        onChange={(e) => setTotalPhilhealth(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Hours Undertime</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Hours Undertime"
                                        value={totalHoursUndertime}
                                        onChange={(e) => setTotalHoursUndertime(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Undertime</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Undertime"
                                        value={totalUndertime}
                                        onChange={(e) => setTotalUndertime(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Hours Late</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Hours Late"
                                        value={totalHoursLate}
                                        onChange={(e) => setTotalHoursLate(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Late</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Late"
                                        value={totalLate}
                                        onChange={(e) => setTotalLate(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Basic</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Basic"
                                        value={totalBasic}
                                        onChange={(e) => setTotalBasic(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Gross Pay</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Gross Pay"
                                        value={totalGrossPay}
                                        onChange={(e) => setTotalGrossPay(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Total Net Pay</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="Total Net Pay"
                                        value={totalNetPay}
                                        onChange={(e) => setTotalNetPay(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">User ID</div>
                                <div className="info-item-input">
                                    <input
                                        type='number'
                                        placeholder="User ID"
                                        value={userId}
                                        onChange={(e) => setUserId(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                UPDATE
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function AddForm({isOpen, 
    onClose,
    employeePersonalInformationId,
    employeePersonalInformationFullName,
    payrollPeriodId,
    payTypeId,
    description,
    amount,
    noOfHours,
    adjustmentDate,
    referenceId,
    setEployeePersonalInformationId,
    setPayrollPeriodId,
    setPayTypeId,
    setDescription,
    setAmount,
    setNoOfHours,
    setAdjustmentDate,
    setReferenceId,
    setShowEmployeeForm,
    setReferenceIdForm,
    adjustmentType,
    handleSubmit}) 
{
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if (!employeePersonalInformationId 
            || !payrollPeriodId 
            || !payTypeId
            || !amount
        ) {
            if(adjustmentType !== "NightDifferentialsStaging"){
                if(!description){
                    setErrorState(true);
                    return;
                }
            }

            if(adjustmentType === "OtherAdjustmentStaging"){
                if(!adjustmentDate && !referenceId){
                    setErrorState(true);
                    return;
                }
            }
            setErrorState(true);
            return;
        }
        handleSubmit(e);
        setErrorState(false);
    };

    const handleClose = () => {
        onClose();
        setEployeePersonalInformationId("");
        setPayrollPeriodId("");
        setPayTypeId("");
        setDescription("");
        setAmount("");
        setAdjustmentDate("");
        setReferenceId("");
        setErrorState(false);
    };

    var formType = "";
    
    if(adjustmentType === "OtherAdditionStaging"){
        formType = "Add Other Addition Payroll";
    } else if(adjustmentType === "OtherDeductionStaging"){
        formType = "Add Other Deduction Payroll";
    } else if(adjustmentType === "OtherAdjustmentStaging"){
        formType = "Add Other Adjustment Payroll";
    }  else if(adjustmentType === "NightDifferentialsStaging"){
        formType = "Add Night Differential Payroll";
    }

    var refValue = "";
    if (referenceId !== undefined && referenceId !== null && referenceId !== "" && referenceId !== 0) {
        const value = referenceId;
        const formattedNumber = value.toString().padStart(6, '0');
        refValue = `OT-${formattedNumber}`;
    }
        
    const [currentPayTypeId, setCurrentPayTypeId] = useState("");
    useEffect(() => {
        if(currentPayTypeId !== payTypeId){
            setCurrentPayTypeId(payTypeId);
            setPayrollPeriodId("");
        }
    }, [currentPayTypeId, payTypeId, setPayrollPeriodId])
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>{formType}</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Employee</div>
                            <div className="info-item-input">
                                <div className="info-item-holder employee-select row" style={{flexDirection:"row", justifyContent:"normal"}}>
                                    <input
                                        readOnly
                                        className='employeeInput-select'
                                        placeholder="Employee"
                                        value={employeePersonalInformationId ? (employeePersonalInformationFullName) : employeePersonalInformationId}
                                    />
                                    <button className="select row"
                                            onClick={()=>setShowEmployeeForm(true)}
                                    ><SearchIcon/></button>
                                </div>
                                <span style={{
                                        visibility: !employeePersonalInformationId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Pay Type</div>
                            <div className="info-item-input">
                                <PayTypeIdSelect payTypeId={payTypeId} setPayTypeId={setPayTypeId}/>
                            </div>
                            <span style={{
                                        visibility: !payTypeId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Payroll Period</div>
                            <div className="info-item-input">
                                <PayrollPeriodIdSelectFilter payrollPeriodId={payrollPeriodId} setPayrollPeriodId={setPayrollPeriodId} payTypeId={payTypeId}/>
                            </div>
                            <span style={{
                                        visibility: ((!payrollPeriodId && errorState) || !payTypeId) ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>{!payTypeId ? "Please select Pay Type first" : "Please fill up this field"}
                            </span>
                        </div>
                        {(adjustmentType !== "NightDifferentialsStaging") &&
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Description</div>
                                <div className="info-item-input">
                                    { adjustmentType === "OtherAdditionStaging" ?
                                        < AdditionDescriptionSelect description={description} setDescription={setDescription}/>
                                        :
                                        adjustmentType === "OtherDeductionStaging" ?
                                            <DeductionDescriptionSelect description={description} setDescription={setDescription}/>
                                            :
                                            <input
                                            placeholder="Description"
                                            value={description}
                                            onChange={(e) => setDescription(e.target.value)}
                                            />
                                    }
                                </div>
                                <span style={{
                                        visibility: !description && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        }
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Amount</div>
                            <div className="info-item-input">
                                <input
                                type='number'
                                placeholder="Amount"
                                value={amount}
                                onChange={(e) => setAmount(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !amount && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        {(adjustmentType === "OtherAdjustmentStaging") ?
                            <div>
                                <div className="popUp-item info-item column" style={{display: "none"}}>
                                    <div className="info-item-label">Number of Hours</div>
                                    <div className="info-item-input">
                                        <input
                                        type='number'
                                        placeholder="Number of Hours"
                                        value={noOfHours}
                                        onChange={(e) => setNoOfHours(e.target.value)}
                                        />
                                    </div>
                                    <span style={{
                                                visibility: !noOfHours && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                        </span>
                                </div>
                                <div className="popUp-item info-item column">
                                    <div className="info-item-label">Adjustment Date</div>
                                    <div className="info-item-input">
                                        <DateTimeInput date={adjustmentDate} setDate={setAdjustmentDate}/>
                                    </div>
                                    <span style={{
                                                visibility: !adjustmentDate && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                        </span>
                                </div>
                                <div className="popUp-item info-item column">
                                    <div className="info-item-label">Reference Id</div>
                                    <div className="info-item-input">
                                        <div className="info-item-holder employee-select row" style={{flexDirection:"row", justifyContent:"normal"}}>
                                            <input
                                                readOnly
                                                className='employeeInput-select'
                                                placeholder="Reference Id"
                                                value={refValue}
                                            />
                                            <button className="select row" disabled={!employeePersonalInformationId}
                                                    onClick={()=>setReferenceIdForm(true)}
                                            ><SearchIcon/></button>
                                        </div>
                                        <span style={{
                                                visibility: (!referenceId && errorState) || (!employeePersonalInformationId) ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>{!employeePersonalInformationId ? "Please select employee first" : "Please fill up this field"}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            :
                            <></>
                        }
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                SAVE
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function EditForm({isOpen, 
    onClose, 
    employeePersonalInformationId,
    employeePersonalInformationFullName,
    payrollPeriodId,
    payTypeId,
    description,
    amount,
    noOfHours,
    adjustmentDate,
    referenceId,
    setEployeePersonalInformationId,
    setPayrollPeriodId,
    setPayTypeId,
    setDescription,
    setAmount,
    setAdjustmentDate,
    setReferenceId,
    setShowEmployeeForm,
    setNoOfHours,
    setReferenceIdForm,
    adjustmentType,
    handleUpdate})
{
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if (!employeePersonalInformationId 
            || !payrollPeriodId 
            || !payTypeId
            || !amount
        ) {
            if(adjustmentType === "NightDifferentialsStaging"){
                if(!description){
                    setErrorState(true);
                    return;
                }
            }

            if(adjustmentType === "OtherAdjustmentStaging"){
                if(!adjustmentDate && !referenceId && !noOfHours){
                    setErrorState(true);
                    return;
                }
            }
            setErrorState(true);
            return;
        }
        handleUpdate(e);
        setErrorState(false);
    };

    const handleClose = () => {
        onClose();
        setEployeePersonalInformationId("");
        setPayrollPeriodId("");
        setPayTypeId("");
        setDescription("");
        setAmount("");
        setAdjustmentDate("");
        setReferenceId("");
        setErrorState(false);
    };

    var formType = "";
    
    if(adjustmentType === "OtherAdditionStaging"){
        formType = "Update Other Addition Payroll";
    } else if(adjustmentType === "OtherDeductionStaging"){
        formType = "Update Other Deduction Payroll";
    } else if(adjustmentType === "OtherAdjustmentStaging"){
        formType = "Update Other Adjustment Payroll";
    } else if(adjustmentType === "NightDifferentialsStaging"){
        formType = "Update Night Differential Payroll";
    }

    var refValue = "";
    if (referenceId !== undefined && referenceId !== null && referenceId !== "" && referenceId !== 0) {
        const value = referenceId;
        const formattedNumber = value.toString().padStart(6, '0');
        refValue = `OT-${formattedNumber}`;
    }
        
    const [currentPayTypeId, setCurrentPayTypeId] = useState("");
    useEffect(() => {
        if(currentPayTypeId !== payTypeId){
            setCurrentPayTypeId(payTypeId);
            setPayrollPeriodId("");
        }
    }, [currentPayTypeId, payTypeId, setPayrollPeriodId])

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>{formType}</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Employee</div>
                            <div className="info-item-input">
                                <div className="info-item-holder employee-select row" style={{flexDirection:"row", justifyContent:"normal"}}>
                                    <input
                                        readOnly
                                        className='employeeInput-select'
                                        placeholder="Employee"
                                        style={{cursor:"not-allowed"}}
                                        value={employeePersonalInformationId ? (employeePersonalInformationFullName) : employeePersonalInformationId}
                                    />
                                </div>
                            </div>
                            <span style={{
                                        visibility: !employeePersonalInformationId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Pay Type</div>
                            <div className="info-item-input">
                                <PayTypeIdSelect payTypeId={payTypeId} setPayTypeId={setPayTypeId}/>
                            </div>
                            <span style={{
                                        visibility: !payTypeId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Payroll Period</div>
                            <div className="info-item-input">
                                <PayrollPeriodIdSelectFilter payrollPeriodId={payrollPeriodId} setPayrollPeriodId={setPayrollPeriodId} payTypeId={payTypeId}/>
                            </div>
                            <span style={{
                                        visibility: ((!payrollPeriodId && errorState) || !payTypeId) ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>{!payTypeId ? "Please select Pay Type first" : "Please fill up this field"}
                            </span>
                        </div>
                        {(adjustmentType !== "NightDifferentialsStaging") &&
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Description</div>
                                <div className="info-item-input">
                                    <input
                                    placeholder="Description"
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                            visibility: !description && errorState ? "visible" : "hidden",
                                            color:"#ff6565", 
                                            fontSize:"12px"}}>Please fill up this field
                                    </span>
                            </div>
                        }
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Amount</div>
                            <div className="info-item-input">
                                <input
                                type='number'
                                placeholder="Amount"
                                value={amount}
                                onChange={(e) => setAmount(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !amount && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        {(adjustmentType === "OtherAdjustmentStaging") ?
                            <div>
                                <div className="popUp-item info-item column" style={{display: "none"}}>
                                    <div className="info-item-label">Number of Hours</div>
                                    <div className="info-item-input">
                                        <input
                                        type='number'
                                        placeholder="Number of Hours"
                                        value={noOfHours}
                                        onChange={(e) => setNoOfHours(e.target.value)}
                                        />
                                    </div>
                                    <span style={{
                                                visibility: !noOfHours && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                        </span>
                                </div>
                                <div className="popUp-item info-item column">
                                    <div className="info-item-label">Adjustment Date</div>
                                    <div className="info-item-input">
                                        <DateTimeInput date={adjustmentDate} setDate={setAdjustmentDate}/>
                                    </div>
                                    <span style={{
                                                visibility: !adjustmentDate && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                        </span>
                                </div>
                                <div className="popUp-item info-item column">
                                    <div className="info-item-label">Reference Id</div>
                                    <div className="info-item-input">
                                        <div className="info-item-holder employee-select row" style={{flexDirection:"row", justifyContent:"normal"}}>
                                            <input
                                                readOnly
                                                className='employeeInput-select'
                                                placeholder="Reference Id"
                                                value={refValue}
                                            />
                                            <button className="select row" disabled={!employeePersonalInformationId}
                                                    onClick={()=>setReferenceIdForm(true)}
                                            ><SearchIcon/></button>
                                        </div>
                                        <span style={{
                                                visibility: (!referenceId && errorState) || (!employeePersonalInformationId) ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>{!employeePersonalInformationId ? "Please select employee first" : "Please fill up this field"}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            :
                            <></>
                        }
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                UPDATE
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function DeleteForm({isOpen, 
    onClose, 
    handleDelete}
){
    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Delete!</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <span>Are you sure you want to delete this?</span>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleDelete}
                            style={{marginRight:"5px"}}>
                                DELETE
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={()=>handleClose()}>
                                CANCEL
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function PostMessage({isOpen, 
    onClose, 
    handlePost}
){
    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Post Data!</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <span>Are you sure you want to post this payroll?</span>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handlePost}
                            style={{marginRight:"5px"}}>
                                POST
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={()=>handleClose()}>
                                CANCEL
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function DeleteAllForm({isOpen, 
    onClose, 
    payrollPeriodId, 
    payTypeId,
    setPayrollPeriodId,
    setPayTypeId,
    handleDelete
}){
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if (!payrollPeriodId 
            || !payTypeId
        ) {
            setErrorState(true);
            return;
        }
        handleClose();
        handleDelete(e);
        setErrorState(false);
    };

    const handleClose = () => {
        onClose();
        setPayrollPeriodId("");
        setPayTypeId("");
        setErrorState(false);
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Delete!</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Payroll Period</div>
                            <div className="info-item-input">
                                <PayrollPeriodIdSelect payrollPeriodId={payrollPeriodId}
                                                    setPayrollPeriodId={setPayrollPeriodId}
                                />
                            </div>
                            <span style={{
                                        visibility: !payrollPeriodId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Pay Type</div>
                            <div className="info-item-input">
                                <PayTypeIdSelect payTypeId={payTypeId}
                                                setPayTypeId={setPayTypeId}
                                />
                            </div>
                            <span style={{
                                        visibility: !payTypeId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}
                            style={{marginRight:"5px"}}>
                                DELETE
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={()=>handleClose()}>
                                CANCEL
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function DeleteAllPayrollSummaryForm({isOpen, 
    onClose, 
    payrollPeriodId, 
    setPayrollPeriodId,
    handleDelete}
){
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if (!payrollPeriodId) {
            setErrorState(true);
            return;
        }
        handleDelete(e);
        handleClose();
        setErrorState(false);
    };
    
    const handleClose = () => {
        onClose();
        setPayrollPeriodId("");
        setErrorState(false);
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Delete!</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Payroll Period</div>
                            <div className="info-item-input">
                                <PayrollPeriodIdSelect payrollPeriodId={payrollPeriodId}
                                                    setPayrollPeriodId={setPayrollPeriodId}
                                />
                            </div>
                            <span style={{
                                        visibility: !payrollPeriodId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}
                            style={{marginRight:"5px"}}>
                                DELETE
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={()=>handleClose()}>
                                CANCEL
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function UploadForm({isOpen, 
    onClose, 
    payrollPeriodId, 
    payTypeId,
    setPayrollPeriodId,
    setPayTypeId,
    type,
    handleFileUpload}
){
    const handleClose = () => {
        onClose();
        setPayrollPeriodId("");
        setPayTypeId("");
        setFiles("");
    };

    const [files, setFiles] = useState([]);

    const handleBrowse = (e) => {
        const fileList = Array.from(e.target.files);
        setFiles(fileList);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        const fileList = Array.from(e.dataTransfer.files);
        setFiles(fileList);
        e.currentTarget.style.backgroundColor = "white";
    };
    const handleDragOver = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#bdbdbd7d";
    };
    const handleDragOut = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "white";
    };
    const clearFiles = () => {
        // Clear the files state
        setFiles([]);
        // Reset the value of the file input
        document.getElementById('fileInput').value = '';
    };

    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if(!payrollPeriodId || !payTypeId){
            setErrorState(true);
            return;
        }
        handleFileUpload(files, type, payrollPeriodId, payTypeId);
        handleClose();
        setErrorState(false);
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>{"Upload " + type}</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Pay Type</div>
                            <div className="info-item-input">
                                <PayTypeIdSelect payTypeId={payTypeId} setPayTypeId={setPayTypeId}/>
                            </div>
                            <span style={{
                                        visibility: !payTypeId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Payroll Period</div>
                            <div className="info-item-input">
                                <PayrollPeriodIdSelectFilter payrollPeriodId={payrollPeriodId} setPayrollPeriodId={setPayrollPeriodId} payTypeId={payTypeId}/>
                            </div>
                            <span style={{
                                        visibility: ((!payrollPeriodId && errorState) || !payTypeId) ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>{!payTypeId ? "Please select Pay Type first" : "Please fill up this field"}
                            </span>
                        </div>
                    </div>
                    <div>
                        <label htmlFor="fileInput" className='browse'>Browse...</label>
                        <input
                            type="file"
                            id="fileInput"
                            onChange={(e)=> handleBrowse(e)}
                            style={{ display: 'none' }}
                        />
                        <div
                            id='drop-files-here'
                            onDrop={(e)=>handleDrop(e)}
                            onDragOver={(e)=>handleDragOver(e)}
                            onDragLeave={(e)=>handleDragOut(e)}
                            style={{
                            border: '2px dashed #ccc',
                            borderRadius: '5px',
                            padding: '20px',
                            marginTop: '10px',
                            textAlign: 'center',
                            }}
                        >
                            Drop files here
                        </div>
                        {files.length > 0 && (
                            <div style={{border:"1px solid #97979745", padding:"10px"}}>
                                <span>Uploaded File:</span>
                                <ul>
                                    {files.map((file, index) => (
                                    <span key={index}>{file.name}</span>
                                    ))}
                                </ul>
                                <div className="buttons row" style={{display:"flex", justifyContent:"end"}}>
                                    <button id="add-family" 
                                    className="cancel row"
                                    onClick={()=>clearFiles()}
                                    style={{marginRight:"5px"}}>
                                        CLEAR
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                    {files.length > 0 && (
                        <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                            <button id="add-family" 
                                className="save row"
                                onClick={(e)=>submit(e)}
                                style={{marginRight:"5px"}}>
                                    UPLOAD
                            </button>
                            <button id="add-family" 
                                className="cancel row"
                                onClick={()=>handleClose()}>
                                    CANCEL
                            </button>
                        </div>)
                    }
                </div>
            )}
            </div>
        </>
    );
}
function RevertPayrollForm({isOpen, 
    onClose,
    fetchOtherAddition,
    fetchOtherDeduction,
    fetchOtherAdjustment,
    fetchNightDiffData,
    fetchProcess,
    setIsRevert,
    isGenerate,
    user
}){
    const [loadingPercentage, setLoadingPercentage] = useState(0);
    const [loadingRequest, setLoadingRequest] = useState(false);
    const [errorState, setErrorState] = useState(false);
    const [payrollPeriodId, setPayrollPeriodId] = useState("");
    const [payTypeId, setPayTypeId] = useState("");
    const [classificationId, setClassificationId] = useState("");
    const [locationId, setLocationId] = useState("");
    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const submit = (e) =>{
        if (!payrollPeriodId 
            || !payTypeId
            || !classificationId
            // || !locationId
        ) {
            setErrorState(true);
            return;
        }
        handleClose();
        handleRevert(e);
        setErrorState(false);
        setIsRevert(true);
    };

    const handleClose = () => {
        onClose();
        setPayrollPeriodId("");
        setPayTypeId("");
        setClassificationId("");
        setLocationId("");
        setErrorState(false);
    };
    const apiUrlRef = useRef( domain + `/api/PayrollSummaryStaging`);
    
    const handleRevert = async (event) => {
        event.preventDefault();
        const apiUrl = apiUrlRef.current + `/revert/${payTypeId}/${payrollPeriodId}/${classificationId}/${locationId ? locationId : 0}`;
        let progress = 10; // Start progress at 10%
    
        // Gradually increase progress while waiting for long API calls
        const simulateLoading = (targetPercentage, intervalTime = 500) => {
            return new Promise((resolve) => {
                const interval = setInterval(() => {
                    if (progress < targetPercentage) {
                        progress += 1; // Increase by 1% every interval
                        setLoadingPercentage(progress);
                    } else {
                        clearInterval(interval);
                        resolve(); // Stop when reaching the target percentage
                    }
                }, intervalTime); // Adjust interval time for smoother/slower increments
            });
        };
        
        try {
            setLoadingPercentage(10); // Initial 10%
            setLoadingRequest(true);
    
            // Simulate gradual loading progress while waiting for axios.post
            simulateLoading(30, 200); // Simulate increase to 30% slowly over 200ms per step
    
            // Actual axios call
            await axios.post(apiUrl, null, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            setLoadingPercentage(30);

            await SetAuditTrail({
                setupArea: "Payroll", 
                actionTaken: "revert", 
                field: "Revert Payroll", 
                newValue: `-`, 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });

            await simulateLoading(60, 100);

            await fetchOtherAddition();

            // Simulate gradual progress to 70%
            await simulateLoading(70, 100);

            await fetchOtherDeduction();

            // Simulate gradual progress to 80%
            await simulateLoading(80, 100);

            await fetchOtherAdjustment();
            await fetchNightDiffData();

            // Simulate gradual progress to 90%
            await simulateLoading(90, 100);

            await fetchProcess();
                
            setShowRequestMessage(true);
            setIsSuccess(true);
            
            // Final smooth increase to 95%
            simulateLoading(95, 100);
            handleClose();
        } catch (error) {
            // Stop any ongoing simulation
            setLoadingPercentage(progress); // Stop at the current percentage
            setLoadingRequest(false); // Set the loading state to false

            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);// Optionally simulate slow reset to 0 to show failure state

            await simulateLoading(0, 100); // Gradually decrease to 0 for a smoother UX
        } finally {
            // Finalize loading process and reset
            await simulateLoading(100, 100); // Gradually increment to 100% before closing
            setTimeout(() => {
                setLoadingPercentage(0);
                setLoadingRequest(false);
            }, 500); // Delay to show full completion before resetting
        }
    }
        
    const [currentPayTypeId, setCurrentPayTypeId] = useState("");
    useEffect(() => {
        if(currentPayTypeId !== payTypeId){
            setCurrentPayTypeId(payTypeId);
            setClassificationId("");
            setPayrollPeriodId("");
        }
    }, [currentPayTypeId, payTypeId])

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Revert Payroll</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body column" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Pay Type</div>
                            <div className="info-item-input">
                                <PayTypeIdSelect payTypeId={payTypeId} setPayTypeId={setPayTypeId}/>
                            </div>
                            <span style={{
                                        visibility: !payTypeId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Payroll Period</div>
                            <div className="info-item-input">
                                <PayrollPeriodIdSelectFilter payrollPeriodId={payrollPeriodId} setPayrollPeriodId={setPayrollPeriodId} payTypeId={payTypeId}/>
                            </div>
                            <span style={{
                                        visibility: ((!payrollPeriodId && errorState) || !payTypeId) ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>{!payTypeId ? "Please select Pay Type first" : "Please fill up this field"}
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Classification Type</div>
                            <div className="info-item-input">
                                <ClassificationIdSelectFilter classificationId={classificationId} setClassificationId={setClassificationId} payTypeId={payTypeId}/>
                            </div>
                            <span style={{
                                        visibility: ((!classificationId && errorState) || !payTypeId) ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>{!payTypeId ? "Please select Pay Type first" : "Please fill up this field"}
                            </span>
                        </div>
                        <div className="popUp-item info-item column" style={{display: "none"}}>
                            <div className="info-item-label">Location</div>
                            <div className="info-item-input">
                                <LocationIdSelect2 locationId={locationId} setLocationId={setLocationId}/>
                            </div>
                            <span style={{
                                        visibility: !locationId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}
                            style={{marginRight:"5px"}}>
                                REVERT
                        </button>
                    </div>
                </div>
            )}
            </div>
            <GenerateMessage form={showRequestMessage}
                        message={isSuccess ? "Request Success!" : requestMessage}
                        isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loadingRequest ? (
                <CustomLoader loadingPercentage={loadingPercentage}/>
            ) : (
                <></>
                )
            }
        </>
    );
}
function ProcessPayrollForm({isOpen, 
    onClose,
    fetchOtherAddition,
    fetchOtherDeduction,
    fetchOtherAdjustment,
    fetchNightDiffData,
    fetchProcess,
    setIsProcess,
    isGenerate,
    user
}){
    const [loadingPercentage, setLoadingPercentage] = useState(0);
    const [loadingRequest, setLoadingRequest] = useState(false);
    const [errorState, setErrorState] = useState(false);
    const [payrollPeriodId, setPayrollPeriodId] = useState("");
    const [payTypeId, setPayTypeId] = useState("");
    const [classificationId, setClassificationId] = useState("");
    const [locationId, setLocationId] = useState("");

    const [isAllowanceCredited, setIsAllowanceCredited] = useState(false);
    const [isBenefitCredited, setIsBenefitCredited] = useState(false);
    const [isTaxDeductionPeriod, setIsTaxDeductionPeriod] = useState(false);
    const [isLoanDeductionPeriod, setIsLoanDeductionPeriod] = useState(false);
    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const submit = (e) =>{
        if (!payrollPeriodId 
            || !payTypeId
            || !classificationId
            // || !locationId
        ) {
            setErrorState(true);
            return;
        }
        handleClose();
        handleProcess(e);
        setErrorState(false);
        setIsProcess(true);
    };

    const handleClose = () => {
        onClose();
        setPayrollPeriodId("");
        setPayTypeId("");
        setClassificationId("");
        setLocationId("");
        setIsAllowanceCredited(false);
        setIsBenefitCredited(false);
        setIsTaxDeductionPeriod(false);
        setIsLoanDeductionPeriod(false);
        setErrorState(false);
    };

    const apiUrlRef = useRef( domain + `/api/PayrollSummaryStaging`);
    
    const handleProcess = async (event) => {
        event.preventDefault();
        // const apiUrl = apiUrlRef.current + `/process/${payTypeId}/${payrollPeriodId}/classification/${classificationId}`;
        const apiUrl = apiUrlRef.current + `/process/${payTypeId}/${payrollPeriodId}/classification/${classificationId}/location/${locationId ? locationId : 0}/isAllowance/${isAllowanceCredited}/isBenefit/${isBenefitCredited}/isTax/${isTaxDeductionPeriod}/isLoan/${isLoanDeductionPeriod}`;
        let progress = 10; // Start progress at 10%
    
        // Gradually increase progress while waiting for long API calls
        const simulateLoading = (targetPercentage, intervalTime = 500) => {
            return new Promise((resolve) => {
                const interval = setInterval(() => {
                    if (progress < targetPercentage) {
                        progress += 1; // Increase by 1% every interval
                        setLoadingPercentage(progress);
                    } else {
                        clearInterval(interval);
                        resolve(); // Stop when reaching the target percentage
                    }
                }, intervalTime); // Adjust interval time for smoother/slower increments
            });
        };
    
        try {
            setLoadingPercentage(10); // Initial 10%
            setLoadingRequest(true);
    
            // Simulate gradual loading progress while waiting for axios.post
            simulateLoading(30, 200); // Simulate increase to 30% slowly over 200ms per step
    
            // Actual axios call
            await axios.post(apiUrl, null, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
    
            setLoadingPercentage(30); // Set immediate jump to 40% after axios call finishes
    
            await SetAuditTrail({
                setupArea: "Payroll",
                actionTaken: "process",
                field: "Process Payroll",
                newValue: `-`,
                oldValue: "-",
                dateSaved: new Date(),
                savedById: user.id
            });
    
            await simulateLoading(60, 100);

            await fetchOtherAddition();

            // Simulate gradual progress to 70%
            await simulateLoading(70, 100);

            await fetchOtherDeduction();

            // Simulate gradual progress to 80%
            await simulateLoading(80, 100);

            await fetchOtherAdjustment();
            await fetchNightDiffData();

            // Simulate gradual progress to 90%
            await simulateLoading(90, 100);

            await fetchProcess();
    
            setShowRequestMessage(true);
            setIsSuccess(true);
    
            // Final smooth increase to 95%
            simulateLoading(95, 100);
            handleClose();
        } catch (error) {
            // Stop any ongoing simulation
            setLoadingPercentage(progress); // Stop at the current percentage
            setLoadingRequest(false); // Set the loading state to false

            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);// Optionally simulate slow reset to 0 to show failure state

            await simulateLoading(0, 100); // Gradually decrease to 0 for a smoother UX
        } finally {
            // Finalize loading process and reset
            await simulateLoading(100, 100); // Gradually increment to 100% before closing
            setTimeout(() => {
                setLoadingPercentage(0);
                setLoadingRequest(false);
            }, 500); // Delay to show full completion before resetting
        }
    };
        
    const [currentPayTypeId, setCurrentPayTypeId] = useState("");
    useEffect(() => {
        if(currentPayTypeId !== payTypeId){
            setCurrentPayTypeId(payTypeId);
            setClassificationId("");
            setPayrollPeriodId("");
        }
    }, [currentPayTypeId, payTypeId])

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Process Payroll</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body column" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Pay Type</div>
                            <div className="info-item-input">
                                <PayTypeIdSelect payTypeId={payTypeId} setPayTypeId={setPayTypeId}/>
                            </div>
                            <span style={{
                                        visibility: !payTypeId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Payroll Period</div>
                            <div className="info-item-input">
                                <PayrollPeriodIdSelectFilter payrollPeriodId={payrollPeriodId} setPayrollPeriodId={setPayrollPeriodId} payTypeId={payTypeId}/>
                            </div>
                            <span style={{
                                        visibility: ((!payrollPeriodId && errorState) || !payTypeId) ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>{!payTypeId ? "Please select Pay Type first" : "Please fill up this field"}
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Classification Type</div>
                            <div className="info-item-input">
                                <ClassificationIdSelectFilter classificationId={classificationId} setClassificationId={setClassificationId} payTypeId={payTypeId}/>
                            </div>
                            <span style={{
                                        visibility: ((!classificationId && errorState) || !payTypeId) ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>{!payTypeId ? "Please select Pay Type first" : "Please fill up this field"}
                            </span>
                        </div>
                        <div className="popUp-item info-item column" style={{display: "none"}}>
                            <div className="info-item-label">Location</div>
                            <div className="info-item-input">
                                <LocationIdSelect2 locationId={locationId} setLocationId={setLocationId}/>
                            </div>
                            <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item row" style={{alignItems:"center"}}>
                            <div className="info-item-label" style={{paddingRight:"10px"}}>Is Allowance Credited?</div>
                            <div className="info-item-input">
                                <input type="checkbox" 
                                id="isActive-checkbox" 
                                className="checkbox" 
                                name="" 
                                checked={isAllowanceCredited}
                                onChange={(e)=>setIsAllowanceCredited(e.target.checked)}/>
                            </div>
                        </div>
                        <div className="popUp-item info-item row" style={{alignItems:"center"}}>
                            <div className="info-item-label" style={{paddingRight:"10px"}}>Is Benefits Credited?</div>
                            <div className="info-item-input">
                                <input type="checkbox" 
                                id="isActive-checkbox" 
                                className="checkbox" 
                                name="" 
                                checked={isBenefitCredited}
                                onChange={(e)=>setIsBenefitCredited(e.target.checked)}/>
                            </div>
                        </div>
                        <div className="popUp-item info-item row" style={{alignItems:"center"}}>
                            <div className="info-item-label" style={{paddingRight:"10px"}}>Is Tax Deduction Period?</div>
                            <div className="info-item-input">
                                <input type="checkbox" 
                                id="isActive-checkbox" 
                                className="checkbox" 
                                name="" 
                                checked={isTaxDeductionPeriod}
                                onChange={(e)=>setIsTaxDeductionPeriod(e.target.checked)}/>
                            </div>
                        </div>
                        <div className="popUp-item info-item row" style={{alignItems:"center"}}>
                            <div className="info-item-label" style={{paddingRight:"10px"}}>Is Loan Deduction Period?</div>
                            <div className="info-item-input">
                                <input type="checkbox" 
                                id="isActive-checkbox" 
                                className="checkbox" 
                                name="" 
                                checked={isLoanDeductionPeriod}
                                onChange={(e)=>setIsLoanDeductionPeriod(e.target.checked)}/>
                            </div>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}
                            style={{marginRight:"5px"}}>
                                PROCESS
                        </button>
                    </div>
                </div>
            )}
            </div>
            <GenerateMessage form={showRequestMessage}
                        message={isSuccess ? "Request Success!" : requestMessage}
                        isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loadingRequest ? (
                <CustomLoader loadingPercentage={loadingPercentage}/>
            ) : (
                <></>
                )
            }
        </>
    );
}
function PostPayrollForm({isOpen, 
    onClose,
    fetchOtherAddition,
    fetchOtherDeduction,
    fetchOtherAdjustment,
    fetchNightDiffData,
    fetchProcess,
    setIsPost,
    isGenerate,
    user
}){
    const [loadingPercentage, setLoadingPercentage] = useState(0);
    const [loadingRequest, setLoadingRequest] = useState(false);
    const [errorState, setErrorState] = useState(false);
    const [payrollPeriodId, setPayrollPeriodId] = useState("");
    const [payTypeId, setPayTypeId] = useState("");
    const [classificationId, setClassificationId] = useState("");
    const [locationId, setLocationId] = useState("");
    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const submit = (e) =>{
        if (!payrollPeriodId 
            || !payTypeId
            || !classificationId
            // || !locationId
        ) {
            setErrorState(true);
            return;
        }
        handleClose();
        handlePost(e);
        setErrorState(false);
        setIsPost(true);
    };

    const handleClose = () => {
        onClose();
        setPayrollPeriodId("");
        setPayTypeId("");
        setClassificationId("");
        setLocationId("");
        setErrorState(false);
    };
    const apiUrlRef = useRef( domain + `/api/PayrollSummaryStaging`);
    
    const handlePost = async (event) => {
        event.preventDefault();
        const apiUrl = apiUrlRef.current + `/post/${payTypeId}/${payrollPeriodId}/classification/${classificationId}/location/${locationId ? locationId : 0}`;
        let progress = 10; // Start progress at 10%
    
        // Gradually increase progress while waiting for long API calls
        const simulateLoading = (targetPercentage, intervalTime = 500) => {
            return new Promise((resolve) => {
                const interval = setInterval(() => {
                    if (progress < targetPercentage) {
                        progress += 1; // Increase by 1% every interval
                        setLoadingPercentage(progress);
                    } else {
                        clearInterval(interval);
                        resolve(); // Stop when reaching the target percentage
                    }
                }, intervalTime); // Adjust interval time for smoother/slower increments
            });
        };

        try {
            setLoadingPercentage(10); // Initial 10%
            setLoadingRequest(true);
    
            // Simulate gradual loading progress while waiting for axios.post
            simulateLoading(30, 200); // Simulate increase to 30% slowly over 200ms per step
    
            // Actual axios call
            await axios.post(apiUrl, null, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            
            setLoadingPercentage(30);

            await SetAuditTrail({
                setupArea: "Payroll", 
                actionTaken: "post", 
                field: "Post Payroll", 
                newValue: `-`, 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });

            await simulateLoading(60, 100);

            await fetchOtherAddition();

            // Simulate gradual progress to 70%
            await simulateLoading(70, 100);

            await fetchOtherDeduction();

            // Simulate gradual progress to 80%
            await simulateLoading(80, 100);

            await fetchOtherAdjustment();
            await fetchNightDiffData();

            // Simulate gradual progress to 90%
            await simulateLoading(90, 100);

            await fetchProcess();
    
            setShowRequestMessage(true);
            setIsSuccess(true);
    
            // Final smooth increase to 95%
            simulateLoading(95, 100);
            handleClose();
        } catch (error) {
            // Stop any ongoing simulation
            setLoadingPercentage(progress); // Stop at the current percentage
            setLoadingRequest(false); // Set the loading state to false

            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);// Optionally simulate slow reset to 0 to show failure state

            await simulateLoading(0, 100); // Gradually decrease to 0 for a smoother UX
        } finally {
            // Finalize loading process and reset
            await simulateLoading(100, 100); // Gradually increment to 100% before closing
            setTimeout(() => {
                setLoadingPercentage(0);
                setLoadingRequest(false);
            }, 0); // Delay to show full completion before resetting
        }
    }
        
    const [currentPayTypeId, setCurrentPayTypeId] = useState("");
    useEffect(() => {
        if(currentPayTypeId !== payTypeId){
            setCurrentPayTypeId(payTypeId);
            setClassificationId("");
            setPayrollPeriodId("");
        }
    }, [currentPayTypeId, payTypeId])

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Post Payroll</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body column" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Pay Type</div>
                            <div className="info-item-input">
                                <PayTypeIdSelect payTypeId={payTypeId} setPayTypeId={setPayTypeId}/>
                            </div>
                            <span style={{
                                        visibility: !payTypeId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Payroll Period</div>
                            <div className="info-item-input">
                                <PayrollPeriodIdSelectFilter payrollPeriodId={payrollPeriodId} setPayrollPeriodId={setPayrollPeriodId} payTypeId={payTypeId}/>
                            </div>
                            <span style={{
                                        visibility: ((!payrollPeriodId && errorState) || !payTypeId) ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>{!payTypeId ? "Please select Pay Type first" : "Please fill up this field"}
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Classification Type</div>
                            <div className="info-item-input">
                                <ClassificationIdSelectFilter classificationId={classificationId} setClassificationId={setClassificationId} payTypeId={payTypeId}/>
                            </div>
                            <span style={{
                                        visibility: ((!classificationId && errorState) || !payTypeId) ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>{!payTypeId ? "Please select Pay Type first" : "Please fill up this field"}
                            </span>
                        </div>
                        <div className="popUp-item info-item column" style={{display: "none"}}>
                            <div className="info-item-label">Location</div>
                            <div className="info-item-input">
                                <LocationIdSelect2 locationId={locationId} setLocationId={setLocationId}/>
                            </div>
                            <span style={{
                                        visibility: !locationId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}
                            style={{marginRight:"5px"}}>
                                POST
                        </button>
                    </div>
                </div>
            )}
            </div>
            <GenerateMessage form={showRequestMessage}
                        message={isSuccess ? "Request Success!" : requestMessage}
                        isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loadingRequest ? (
                <CustomLoader loadingPercentage={loadingPercentage}/>
            ) : (
                <></>
                )
            }
            {/* {loadingRequest ? (
                <div style={{
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    zIndex: "2000",
                    display: "flex",
                    flexDirection: "column", // Stacks items vertically
                    alignItems: "center", // Centers items horizontally
                    textAlign: "center" // Ensures text is centered
                }}>
                    <img src={loadingSpinner} alt="Loading..." />
                    {loadingPercentage !== 0 && <p style={{color: "rgb(104, 104, 104)"}}>{`Loading: ${loadingPercentage}%`}</p>}
                </div>
            ) : (
                <></>
                )
            } */}
        </>
    );
}
function EmployeeSelectForm({isOpen, 
    onClose,
    setEmployeeId,
    setEmployee,
    userAccessData
}) 
{
    var header = [
        "Id",
        "Name",
    ]
    var accessor = [
        "employeeId",
        "fullName"
    ]

    const handleClose = () => {
        onClose();
        fetchData();
    };
    const handleProceed = () => {
        onClose();
        setEmployeeId(selectedEmployee.id);
        setEmployee(selectedEmployee.fullName);
        fetchData();
    };

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [employees, setEmployees] = useState([]);
    const [employeesInfo, setEmployeesInfo] = useState([]);
    const [allEmployeesBasicInfo, setAllEmployeesBasicInfo] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [filterDataIndex, setFilterDataIndex] = useState(0);
    const [searchPlaceholder, setSearchPlaceholder] = useState("Search by name");

    const [classificationFilterForAdminHRHead, setClassificationFilterForAdminHRHead] = useState("0");
    const [currentClassificationFilter, setCurrentClassificationFilter] = useState("");

    /* const fetchDataAllData = useCallback(async () => {
        const apiUrl =  domain + "/api/Employee";
        try {
            const response = await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
                return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, []); */

    const fetchData = useCallback(async () => {
        const apiUrl =  domain + "/api/Employee/active";

        try {
            setLoading(true);
            const response = await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
            // const employeeAllData = await fetchDataAllData();
            setEmployeesInfo(response.data);
            setAllEmployeesBasicInfo(response.data);
            setEmployees(response.data);
            setFilterData(response.data);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }, []);

    const handleFilter = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();
        var res = [];

        switch (filterDataIndex) {
            case 0:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 1:
                res = filterData.filter((f) =>
                f.employeeId.toString().startsWith(lowercaseValue)
                );
                break;
            default:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                
                break;
        }

        setEmployees(res);
    };

    useEffect(()=>{
        let classifiedData = allEmployeesBasicInfo;
        let classificiationFilter = classificationFilterForAdminHRHead;

        setCurrentClassificationFilter(classificiationFilter);

        if(classificiationFilter !== "0" && classificiationFilter !== "All"){
            const _classified = allEmployeesBasicInfo.filter(employee => {
                const foundEmployee = employeesInfo.find(_employee => _employee.employeeId === employee.employeeId);
                
                if (foundEmployee.employeeInformation && foundEmployee.employeeInformation.classificationId) {
                    return foundEmployee.employeeInformation.classificationId.toString() === classificiationFilter;
                }
                return false;
            });
            
            classifiedData = _classified;
        }

        if(classificiationFilter !== currentClassificationFilter){
            setEmployees(classifiedData);
            setFilterData(classifiedData);
        }
    }, [
        classificationFilterForAdminHRHead,
        currentClassificationFilter,
        employees,
        employeesInfo,
        allEmployeesBasicInfo,
    ])
    
    useEffect(() => {
        switch (filterDataIndex) {
            case 0:
                setSearchPlaceholder("Search by name")
                break;
            case 1:
                setSearchPlaceholder("Search by id")
                break;
            default:
                setSearchPlaceholder("Search by name")
                break;
        }
        fetchData();
    }, [fetchData, filterDataIndex]);
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Select Employee</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="transaction-body">
                            <div className='filters-payroll'>
                                <span>Filter</span>
                                <div className="payroll-item-holder info-item-holder row" style={{padding: "0 10px 20px 10px", justifyContent: "normal"}}>
                                    <div className="filter-item-payroll popUp-item info-item column">
                                        <div className="info-item-label">Filter</div>
                                        <div className="info-item-input">
                                            <EmployeeFilter setFilterDataIndex={setFilterDataIndex}/>
                                        </div>
                                    </div>
                                    {userAccessData.length <= 0 && 
                                        <div className="filter-item-payroll popUp-item info-item column">
                                            <div className="info-item-label">Classification Type</div>
                                            <div className="info-item-input">
                                                <ClassificationIdSelectWithAllDummy/>
                                            </div>
                                        </div>
                                    }
                                    <div className="filter-item-payroll popUp-item info-item column">
                                        <div className="info-item-label">Classification Type</div>
                                        <div className="info-item-input">
                                            <ClassificationIdSelectWithAll1 classificationId={classificationFilterForAdminHRHead} setClassificationId={setClassificationFilterForAdminHRHead}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="transaction-body-top row">
                                {CreateSearchBarWithPlaceHolder("", 
                                                                "transaction-search row", 
                                                                "transaction-search-icon", 
                                                                "transaction-search-input", 
                                                                (e)=>handleFilter(e.target.value), 
                                                                searchPlaceholder,
                                                                SearchIcon)}
                            </div>
                        </div>
                        <div className="select-employee-table">
                            <CreateTableForEmployeeSelect
                                dataList={employees}
                                dataHeader={header}
                                dataAccessor={accessor}
                                setSelectedEmployee={setSelectedEmployee}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                            />
                            {employees.length > 0 ? (
                                    <div></div>
                            )
                            :
                            (
                                <div>
                                {loading ? (
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                                        <img src={loadingSpinner} alt="Loading..." />
                                    </div>
                                ) : (
                                        <div> {/*<p>No records to display</p>*/}</div>
                                    )
                                }
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"50px 20px 0 20px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleProceed}>
                                PROCEED
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function EmployeeFilter({setFilterDataIndex}){
    const [selectedOption, setSelectedOption] = useState("All");

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "EmployeeId":
                setFilterDataIndex(1);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }
    };

    return (
        <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
            <option value="All">All</option>
            <option value="EmployeeId">Employee Id</option>
        </select>
    );
};
function ReferenceSelectForm({isOpen, 
    onClose,
    employeePersonalInformationId,
    setReferenceId,
    setAdjustmentDate
}) 
{
    var header = [
        "Reference No.",
        "Employee",
        "Request Date",
        "Request",
        "Status",
        "",
    ]
    var accessor = [
        "referenceNumber",
        "employeePersonalInformationFullName",
        "date",
        "requestTypeDescription",
        "status",
        "manage"
    ]

    const [viewData, setViewData] = useState([]);
    const [showViewData, setShowViewData] = useState(false);
    const [reference, setReference] = useState([]);
    const [selectedReference, setSelectedReference] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [filterDataIndex, setFilterDataIndex] = useState(0);
    const [searchPlaceholder, setSearchPlaceholder] = useState("Search by reference id");

    const handleClose = () => {
        onClose();
        fetchData();
    };
    const handleProceed = () => {
        onClose();
        if(selectedReference.length !== 0){
            setReferenceId(selectedReference.referenceNumber);
            setAdjustmentDate(selectedReference.dateRequested);
        }
        fetchData();
    };
    const viewHandleClick = (data) => {
        setViewData(data);
        setShowViewData(true);
    }
    const closeViewHandleClick = () => {
        setShowViewData(false);
    }

    const fetchData = useCallback(async () => {
        const apiUrl =  domain + `/api/OvertimeRequest/employee/${employeePersonalInformationId}`;

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            const filteredDatas = response.data.filter(filteredData => filteredData.status === "Approved");
            setReference(filteredDatas); // Set the response data to the state
            setFilterData(filteredDatas); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }, [employeePersonalInformationId]);
    const handleFilter = (value) => {
        const lowercaseValue = value.toLowerCase();
        var res = [];

        switch (filterDataIndex) {
            case 0:
                res = filterData.filter((f) =>
                f.referenceNumber.toString().startsWith(lowercaseValue)
                );
                break;
            case 1:
                res = filterData.filter((f) =>
                f.employeePersonalInformationFullName.toLowerCase().includes(lowercaseValue)
                );
                break;
            default:
                res = filterData.filter((f) =>
                f.referenceNumber.toString().startsWith(lowercaseValue)
                );
                break;
        }

        setReference(res);
    };

    useEffect(() => {
        switch (filterDataIndex) {
            case 0:
                setSearchPlaceholder("Search by reference id")
                break;
            case 1:
                setSearchPlaceholder("Search by employee")
                break;
            default:
                setSearchPlaceholder("Search by reference id")
                break;
        }
        
        if(isOpen){
            fetchData();
        }
    }, [filterDataIndex, fetchData, isOpen]);
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Select Reference Id</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="transaction-body">
                            <ReferenceFilter setFilterDataIndex={setFilterDataIndex}/>
                            <div className="transaction-body-top row">
                                {CreateSearchBarWithPlaceHolder("", 
                                                                "transaction-search row", 
                                                                "transaction-search-icon", 
                                                                "transaction-search-input", 
                                                                (e)=>handleFilter(e.target.value), 
                                                                searchPlaceholder,
                                                                SearchIcon)}
                            </div>
                        </div>
                    <div className="popUp-body selectModal">
                        <div className="select-employee-table">
                            <CreateTableForReferenceSelect
                                dataList={reference}
                                dataHeader={header}
                                dataAccessor={accessor}
                                setSelectedReference={setSelectedReference}
                                viewHandleClick={viewHandleClick}
                            />
                            {reference.length > 0 ? (
                                    <div></div>
                            )
                            :
                            (
                                <div> {/*<p>No records to display</p>*/}</div>
                            )}
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"50px 20px 0 20px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleProceed}>
                                PROCEED
                        </button>
                    </div>
                </div>
            )}
            </div>
            <ViewOTForm  isOpen={showViewData} 
                    onClose={closeViewHandleClick}
                    viewData={viewData}
            >
            </ViewOTForm>
        </>
    );
}
function ReferenceFilter({setFilterDataIndex}){
    const [selectedOption, setSelectedOption] = useState("All");

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "Employee":
                setFilterDataIndex(1);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }
    };

    return (
        <div className="filters row" style={{alignItems:"center"}}>
            <span style={{marginRight:"10px"}}>Filter</span>
            <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
                <option value="All">All</option>
                <option value="Employee">Employee</option>
            </select>
        </div>
    );
};
function ViewOTForm({isOpen, 
    onClose,
    viewData})
{

    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Reference Details</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Employee</div>
                            <div className="info-item-input">
                                <input
                                readOnly={true}
                                id="employeePersonalInformationFullNameLeave"
                                placeholder="Employee"
                                value={viewData.employeePersonalInformationFullName}
                                />
                            </div>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Overtime Type</div>
                            <div className="info-item-input">
                                <input
                                readOnly={true}
                                id="employeePersonalInformationFullNameLeave"
                                placeholder="Employee"
                                value={viewData.overtimeType}
                                />
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Date</div>
                                <div className="info-item-input">
                                    <input
                                    readOnly={true}
                                    id="employeePersonalInformationFullNameLeave"
                                    placeholder="Employee"
                                    value={viewData.date}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Hours</div>
                                <div className="info-item-input">
                                    <input
                                    readOnly
                                    type="number"
                                    id="daysLeave"
                                    placeholder="Days"
                                    value={viewData.hours}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Remarks</div>
                            <div className="info-item-input">
                                <textarea id="tamper" className="filterSelect"
                                        style={{width:"100%",minHeight:"50px", borderRadius:"3px", border:"1px solid #80808080",color: "rgb(104, 104, 104)"}}
                                        value={viewData.remarks}
                                        readOnly
                                />
                            </div>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Reason</div>
                            <div className="info-item-input">
                                <textarea id="tamper" className="filterSelect"
                                        style={{width:"100%",minHeight:"50px", borderRadius:"3px", border:"1px solid #80808080",color: "rgb(104, 104, 104)"}}
                                        value={viewData.reason}
                                        readOnly
                                />
                            </div>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={handleClose}>
                                Close
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function PayrollPeriodIdSelect({payrollPeriodId, setPayrollPeriodId}){
    const [isSelected, setIsSelected] = useState(false);
    
    const handleSelectChange = (event) => {
        setIsSelected(true);
        setPayrollPeriodId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        //const currentYear = new Date().getFullYear();
        //const apiUrl =  domain + `/api/PayrollPeriod/year/${currentYear}`;
        const apiUrl =  domain + `/api/PayrollPeriod/active`; // changed

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setData(response.data);
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(payrollPeriodId !== "" && payrollPeriodId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [payrollPeriodId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={payrollPeriodId} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose payroll period</option>
            {data.map((payrollPeriodId) => ( 
                SetPayrollPeriodId(payrollPeriodId)
            ))}
            </select>
        </div>
    );
};
function PayrollPeriodIdSelectFilter({payrollPeriodId, setPayrollPeriodId, payTypeId}){
    const [isSelected, setIsSelected] = useState(false);
    
    const handleSelectChange = (event) => {
        setIsSelected(true);
        setPayrollPeriodId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = useCallback(async () => {
        if(!payTypeId){
            return;
        }
        // const currentYear = new Date().getFullYear();
        // const apiUrl =  domain + `/api/PayrollPeriod/year/${currentYear}`;
        const apiUrl =  domain + `/api/PayrollPeriod/active/paytype/${payTypeId}`; // changed

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setData(response.data);
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }, [payTypeId]);

    useEffect(() => {
        fetchData();
        if(payrollPeriodId !== "" && payrollPeriodId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [fetchData, payrollPeriodId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" disabled={!payTypeId} value={payrollPeriodId} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
                <option value="" disabled hidden>Choose payroll period</option>
                {data.map((payrollPeriodId) => ( 
                    SetPayrollPeriodId(payrollPeriodId)
                ))}
            </select>
        </div>
    );
};
function SetPayrollPeriodId(payrollPeriodId){
    const formattedDateFrom = format(payrollPeriodId.dateFrom, 'MM/dd/yyyy');
    const formattedDateTo = format(payrollPeriodId.dateTo, 'MM/dd/yyyy');

    return(
        <option value={payrollPeriodId.id}>{`${formattedDateFrom} - ${formattedDateTo} ${payrollPeriodId.payTypeDescription ? payrollPeriodId.payTypeDescription : ""}`}
        </option>
    )
}
function PayTypeIdSelect({payTypeId, setPayTypeId}){
    const [isSelected, setIsSelected] = useState(false);
    
    const handleSelectChange = (event) => {
        setIsSelected(true);
        setPayTypeId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/PayType/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(payTypeId !== "" && payTypeId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [payTypeId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={payTypeId} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose pay type</option>
            {data.map((payTypeId) => ( 
                SetPayTypeId(payTypeId)
            ))}
            </select>
        </div>
    );
};
function SetPayTypeId(payTypeId){
    return(
        <option value={payTypeId.id}>{
            payTypeId.description}
        </option>
    )
    
}
function ClassificationIdSelectDummy(){
    return (
        <div>
            <select id="employee-select-PagibigReport">
            </select>
        </div>
    );
};
function ClassificationIdSelectFilter({classificationId, setClassificationId, payTypeId}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        setClassificationId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = useCallback(async () => {
        if(!payTypeId){
            return;
        }
        
        const apiUrl =  domain + "/api/Classification/active";

        try {
            const response = await axios.get(apiUrl, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})

            let finalData = response.data;
            
            if(parseInt(payTypeId) === 1){
                finalData = response.data.filter(i => i.id === 1);
            } else if(parseInt(payTypeId) === 3){
                finalData = response.data.filter(i => i.id === 2 || i.id === 3 || i.id === 4);
            }

            setData(finalData); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }, [payTypeId]);

    useEffect(() => {
        fetchData();
        if(classificationId !== "" && classificationId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [fetchData, classificationId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" disabled={!payTypeId} value={classificationId} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose classification</option>
            {data.map((classificationId) => ( 
                SetClassificationId(classificationId)
            ))}
            </select>
        </div>
    );
};
function ClassificationIdSelectWithAllDummy(){
    return (
        <div>
            <select id="employee-select-PagibigReport">
            </select>
        </div>
    );
};
function ClassificationIdSelectWithAll1({classificationId, setClassificationId}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        setClassificationId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Classification/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(classificationId !== "" && classificationId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [classificationId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={classificationId} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
                <option value="" disabled hidden>Choose classification</option>
                {data.length > 0 && <option value="All">All</option>}
                {data.map((classificationId) => ( 
                    SetClassificationId(classificationId)
                ))}
            </select>
        </div>
    );
};
function SetClassificationId(classificationId){
    return(
        <option value={classificationId.id}>{
            classificationId.description}
        </option>
    )
}
function LocationIdSelect2({locationId, setLocationId}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        setLocationId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Location/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            response.data.sort((a, b) => a.description.localeCompare(b.description));
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(locationId !== "" && locationId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [locationId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={locationId || ""} onChange={handleSelectChange}style={{ height: "30px", color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose location</option>
            {data.map((locationId) => ( 
                SetLocationId(locationId)
            ))}
            </select>
        </div>
    );
};
function SetLocationId(locationId){
    return(
        <option value={locationId.id}>{
            locationId.description}
        </option>
    )

}
function AdditionDescriptionSelect({description, setDescription}){
    const [isSelected, setIsSelected] = useState(false);
    
    const handleSelectChange = (event) => {
        setIsSelected(true);
        setDescription(event.target.value);
    };

    useEffect(() => {
        if(description !== ""){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [description]);

    return (
        <div>
            <select value={description} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose description</option>
            <option value="ExteriorWorks">Exterior Works</option>
            <option value="Addback">Addback</option>
            </select>
        </div>
    );
};
function DeductionDescriptionSelect({description, setDescription}){
    const [isSelected, setIsSelected] = useState(false);
    
    const handleSelectChange = (event) => {
        setIsSelected(true);
        setDescription(event.target.value);
    };

    useEffect(() => {
        if(description !== ""){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [description]);

    return (
        <div>
            <select value={description} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose description</option>
            <option value="VALE">VALE</option>
            </select>
        </div>
    );
};
function GenerateMessage({form, message, isSuccess}){
    return (
        <>
            <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                {form && (
                <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                    <div className='column'>
                        {isSuccess ?
                            <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                <CheckCircleIcon/>
                                <span >{"SUCCESS MESSAGE"}</span>
                            </div>
                            :
                            <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                <ErrorIcon/>
                                <span>{"ERROR MESSAGE"}</span>
                            </div>
                        }
                        <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function DateTimeInput({date, setDate}) {
    const [isSelected, setIsSelected] = useState(false);

    const handleDateTimeChange = (event) => {
        setDate(event.target.value);
        setIsSelected(true);
    };

    useEffect(() => {
        if(date !== undefined && date !== ""){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [date]);

    let formattedDate = "";

    if(date){
        formattedDate = date.split('T')[0];
    }

    return (
        <div>
            <input
            type="date"
            id={"datetime-"}
            name="datetime"
            value={formattedDate} // Exclude milliseconds
            onChange={handleDateTimeChange}
            style={{width:"90%",
                height:"30px", 
                borderRadius:"3px", 
                border:"1px solid #80808080",
                color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
                fontFamily: "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif"
            }}
            />
        </div>
    );
}
export function CreateTable({ dataList = [], dataHeader = [], dataAccessor = [], currentPage, setCurrentPage, editHandleClick, deleteHandleClick }) {
    const itemsPerPage = 10;

    const columns = React.useMemo(() =>
        dataHeader.map((header, index) => ({
            Header: header,
            accessor: dataAccessor[index]
        })),
        [dataHeader, dataAccessor]
    );

    const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        setSortBy
    } = useTable(
        {
            columns,
            data: dataList,
            initialState: {
                sortBy: sortHeaderValue.isDefault
                    ? []  // No sorting if it's default
                    : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }] // Apply sorting if not default
            }
        },
        useSortBy
    );

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    //Sorting Feature
    const sortState = [
        { id: 0, state: "default", textValue: "" },
        { id: 1, state: "ascending", textValue: "↑" },
        { id: 2, state: "descending", textValue: "↓" }
    ];

    const headerClick = (column) => {
        if (sortHeaderValue.id !== column.id) {
            // New column selected, start with ascending order
            setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
            setSortBy([{ id: column.id, desc: false }]);
        } else {
            // Toggle between sorting states (default -> ascending -> descending -> default)
            if (sortHeaderValue.isDefault) {
                setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
                setSortBy([{ id: column.id, desc: false }]);
            } else if (!sortHeaderValue.desc) {
                setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
                setSortBy([{ id: column.id, desc: true }]);
            } else {
                setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
                setSortBy([]); // Clear sorting
            }
        }
    };

    // Ensure sorting is reapplied on dataList reload
    useEffect(() => {
        if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
            setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
        }
    }, [dataList, setSortBy, sortHeaderValue]);

    return (
        <>
            <table {...getTableProps()}>
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <th
                                    {...column.getHeaderProps()}
                                    onClick={() => headerClick(column)}
                                    className="sortable-header"
                                >
                                    {`${column.render("Header")} ${
                                        sortHeaderValue.id === column.id
                                            ? sortState[sortHeaderValue.isDefault ? 0 : sortHeaderValue.desc ? 2 : 1].textValue
                                            : ""
                                    }`}
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {dataList.length <= 0 &&
                        <tr>
                            <td colSpan={columns.length} style={{ textAlign: "center" }}>
                                No data to display
                            </td>
                        </tr>
                    }
                    {currentItems.map((row) => {
                        prepareRow(row)
                        return (
                            <tr key={row.original.id}
                            {...row.getRowProps()}
                            >
                                {row.cells.map((cell) => (
                                    SetInfoMain(cell.render("Cell").props.column.Header, 
                                            cell,
                                            editHandleClick,
                                            deleteHandleClick)
                                ))}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
            {rows.length > itemsPerPage ? (
            <>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                    <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        &lt;&lt;
                    </button>
                    <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                    </button>
                    <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px", height:"26px" }}>
                        NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                    </button>
                    <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"26px"}}>
                        &gt;&gt;
                    </button>
                </div>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"center", padding: "20px 0 0 0"}}>
                    {`${currentPage}/${totalPages}`}
                </div>
            </>
            ) :
            <></>}
        </>
    )
}
function SetInfoMain(header, _cell, editHandleClick, deleteHandleClick) {
    const data = _cell.render("Cell").props.row.original;
    const tdValue = _cell.render("Cell").props.value;

    if (header === "") {
        return(
            <td>
                <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                    <Tooltip text="Update">
                        <div style={{padding:"0 5px"}} onClick={()=>editHandleClick(data)}><ModeEditIcon/></div>
                    </Tooltip>
                    { deleteHandleClick ? 
                    <Tooltip text="Delete">
                        <div style={{padding:"0 5px"}} onClick={()=>deleteHandleClick(data)}><DeleteForeverIcon/></div>
                    </Tooltip>
                    :
                    <></>
                    }
                </div>
            </td>
        )
    }

    if (header === "Benefits List") {
        return(
            <td>
                {tdValue.map((value, index) => (
                    <div style={{margin: "20px 0"}}> {`${value.name ? value.name : "No description"}: ${value.amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`} </div>
                ))}
            </td>
        )
    }

    if (header === "Other Cash Advance List") {
        return(
            <td>
                {tdValue.map((value, index) => (
                    <div style={{margin: "20px 0"}}> {`${value.description ? value.description : "No description"}: ${value.defaultDeduction.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`} </div>
                ))}
            </td>
        )
    }
    if (header === "Company Loans List") {
        return(
            <td>
                {tdValue.map((value, index) => (
                    <div style={{margin: "20px 0"}}> {`${value.description ? value.description : "No description"}: ${value.defaultDeduction.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`} </div>
                ))}
            </td>
        )
    }

    if(header === "Status"){
        if(data.isActive){  
            return(
                <td>
                    Active
                </td>
            )
        }
        else{
            return(
                <td>
                    InActive
                </td>
            )
        }
    }

    if(header === "Approved?"){
        return(
            <td>
                <input type="checkbox" 
                    id="overtime-allowance" 
                    className="checkbox"
                    name="" 
                    checked={data.isApproved}
                    disabled={true}
                />
            </td>
        )
    }

    if(header === "Enabled?"){
        return(
            <td>
                <input type="checkbox" 
                    id="overtime-allowance" 
                    className="checkbox"
                    name="" 
                    checked={data.idEnabled}
                    disabled={true}
                />
            </td>
        )
    }

    if(header === "Time From"
    || header === "Time To"
    || header === "Time In"
    || header === "Time Out"
    ){
        const time = _cell.render("Cell").props.value;
        if(!time) {
            return (
                <td>
                </td>
            );
        }

        let timeParts;
        let formattedTime;

        if (globalTimeFormat === "Standard Time"){
            const timeSplit = time.split('T');
            if (timeSplit.length > 1) {
                timeParts = timeSplit[1].substr(0, 5).split(':');
            } else {
                timeParts = [];
            }
            let hours = parseInt(timeParts[0], 10);
            const minutes = timeParts[1];

            // Convert 24-hour format to 12-hour format and determine AM or PM
            const amPm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

            formattedTime = `${hours}:${minutes} ${amPm}`;
        } else if (globalTimeFormat === "Military Time"){
            const timeSplit = time.split('T');
            if (timeSplit.length > 1) {
                timeParts = timeSplit[1].substr(0, 5).split(':');
            } else {
                timeParts = [];
            }
            let hours = parseInt(timeParts[0], 10);
            const minutes = timeParts[1];

            formattedTime = `${hours}:${minutes}`;
        }

        return (
            <td>
                {formattedTime}
            </td>
        );
    }
    
    if(header === "Date"
    || header === "Date From"
    || header === "Date To"
    || header === "Date Processed"
    || header === "Request Date"
    || header === "Date Requested"
    ){
        const date = new Date(_cell.render("Cell").props.value);
        if(!date) {
            return (
                <td>
                </td>
            );
        }

        const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
        const dd = date.getDate();
        const yyyy = date.getFullYear();

        const formattedDateFrom = `${mm}/${dd}/${yyyy}`;
        
        return(
            <td>
                {formattedDateFrom}
            </td>
        )
    }

    //Double type data
    if(header === "Over Percentage"
    || header === "Deduction"
    || header === "Salary"
    || header === "Employee"
    || header === "Employer"
    || header === "Range From"
    || header === "Range To"
    || header === "Monthly Salary"
    || header === "SSS ER"
    || header === "SSS EE"
    || header === "SSS Total"
    || header === "ECER"
    || header === "Total Contribution ER"
    || header === "Total Contribution EE"
    || header === "Total Contribution Total"
    || header === "SE Total Contribution"
    || header === "Salary Range From"
    || header === "Salary Range To"
    || header === "Total Monthly Premium"
    || header === "Percentage"
    || header === "Amount"
    || header === "Total Loan"
    || header === "Total Balance"
    || header === "Default Deduction"
    || header === "Allowance"
    || header === "Total Days"
    || header === "Daily Salary"
    || header === "Benefits"
    || header === "Allowance"
    || header === "Cash Advance"
    || header === "Other Cash Advance"
    || header === "Company Loans"
    || header === "Total Basic"
    || header === "Rate"
    || header === "Hours OT Regular"
    || header === "Total OT Regular"
    || header === "Hours OT Exceeded"
    || header === "Total OT Exceeded"
    || header === "Hours OT Restday"
    || header === "Total OT Restday"
    || header === "Hours Holiday Special"
    || header === "Total Holiday Special"
    || header === "Hours Holiday Regular"
    || header === "Total Holiday Regular"
    || header === "Hours Restday Holiday Special"
    || header === "Total Restday Holiday Special"
    || header === "Hours Restday Holiday Regular"
    || header === "Total Restday Holiday Regular"
    || header === "Total OT Food Allowance"
    || header === "Additions"
    || header === "SSS"
    || header === "Pagibig"
    || header === "Philhealth"
    || header === "SSS Loan"
    || header === "SSS Calamity Loan"
    || header === "Pagibig Loan"
    || header === "Pagibig Calamity Loan"
    || header === "Tax"
    || header === "Deductions"
    || header === "Adjustments"
    || header === "Total Net Pay"
    || header === "Total Gross Pay"
    || header === "Days Absent"
    || header === "Absent/s"
    || header === "Days Leave"
    || header === "Leave/s"
    || header === "Hours Exceeded"
    || header === "Total Exceeded"
    || header === "Hours Undertime"
    || header === "Undertime"
    || header === "Hours Late"
    || header === "Late"
    || header === "Night Diff"
    || header === "OT Regular"
    || header === "OT Restday"
    || header === "Holiday Special"
    || header === "Holiday Regular"
    || header === "Restday Holiday Special"
    || header === "Restday Holiday Regular"
    || header === "Total Absents"
    || header === "Total Late"
    || header === "Total Undertime"
    || header === "Total Leaves"
    || header === "Total Night Diff"
    || header === "Total Exceed"
    || header === "Exceed"
    || header === "Total Days Regular Holidays"
    || header === "Total Regular Holiday Worked"
    || header === "Total Regular Holidays"
    || header === "Total Days Special Non-Working Holidays"
    || header === "Total Special Non-Working Holidays"
    || header === "Hours Night Differential"
    || header === "Night Differential"
    || header === "Night Differential Adjustment"
    || header === "Exterior Works"
    || header === "Addback"
    || header === "VALE"
    ){
        const value = _cell.render("Cell").props.value;

        if(!value){
            return (
                <td>0.00</td>
            )
        }

        // Check if value is a number
        const isNumber = typeof value === 'number';

        const numberWithCommasAndDecimal = (number) => {
            return number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        };

        if(!isNumber){
            return (
                <td {..._cell.getCellProps()}> {
                    _cell.render("Cell")
                    }
                </td>
            )
        }

        const formattedNumber = numberWithCommasAndDecimal(value);

        return(
            <td>
                {formattedNumber}
            </td>
        )
    }

    return (
        <td {..._cell.getCellProps()}> {
            _cell.render("Cell")
            }
        </td>
    )
}
export function CreateTableForReferenceSelect({ dataList = [], dataHeader = [], dataAccessor = [], viewHandleClick,  setSelectedReference}) {
    const [currentPage, setCurrentPage] = useState(1);
    const [activeRowId, setActiveRowId] = useState(null);
    const itemsPerPage = 10;

    const columns = React.useMemo(() =>
        dataHeader.map((header, index) => ({
            Header: header,
            accessor: dataAccessor[index]
        })),
        [dataHeader, dataAccessor]
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow
    } = useTable({ columns, data: dataList });

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    const handleRowClick = (rowData) => {
        setSelectedReference(rowData); // Pass the clicked row data to the setSelectedEmployee function
        setActiveRowId(rowData.id);
    };

    return (
        <div>
            <table {...getTableProps()}>
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <th {...column.getHeaderProps()}>
                                    {column.render("Header")}
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {dataList.length <= 0 &&
                        <tr>
                            <td colSpan={columns.length} style={{ textAlign: "center" }}>
                                No data to display
                            </td>
                        </tr>
                    }
                    {currentItems.map((row) => {
                        prepareRow(row)
                        return (
                            <tr key={row.original.id}
                            {...row.getRowProps()}
                            onClick={() => handleRowClick(row.original)} // Attach onClick event handler to the row
                            className={row.original.id === activeRowId ? 'active' : ''}
                            >
                                {row.cells.map((cell) => (
                                    SetInfo(cell.render("Cell").props.column.Header, 
                                            cell,
                                            viewHandleClick)
                                ))}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
            {rows.length > itemsPerPage ? (
            <div>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                    <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        &lt;&lt;
                    </button>
                    <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px"}}>
                        <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                    </button>
                    <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px", height:"26px"}}>
                        NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                    </button>
                    <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"26px"}}>
                        &gt;&gt;
                    </button>
                </div>
                <div style={{textAlign:"center"}}>{`${currentPage}/${totalPages}`}</div>
            </div>
            ) :
            <></>}
        </div>
    )
}
function SetInfo(header, _cell, viewHandleClick, deleteHandleClick) {
    const data = _cell.render("Cell").props.row.original;

    if (header === "") {
        return(
            <td>
                <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                    <Tooltip text="View">
                        <div style={{padding:"0 5px"}} onClick={()=>viewHandleClick(data)}><RemoveRedEyeIcon/></div>
                    </Tooltip>
                    { deleteHandleClick ? 
                    <Tooltip text="Delete">
                        <div style={{padding:"0 5px"}} onClick={()=>deleteHandleClick(data)}><DeleteForeverIcon/></div>
                    </Tooltip>
                    :
                    <></>
                    }
                </div>
            </td>
        )
    }

    if(header === "Reference No."){
        const value = _cell.render("Cell").props.value;

        const formattedNumber = value.toString().padStart(6, '0');

        if(data.requestTypeId === 1){
            return (
                <td>
                    OT-{formattedNumber}
                </td>
            );
        } else if(data.requestTypeId === 2){
            return (
                <td>
                    CS-{formattedNumber}
                </td>
            );
        } else if(data.requestTypeId === 3){
            return (
                <td>
                    OT-{formattedNumber}
                </td>
            );
        } else if(data.requestTypeId === 4){
            return (
                <td>
                    CH-{formattedNumber}
                </td>
            );
        } 

        
    }
    
    if(header === "Request Date"){
        const date = new Date(_cell.render("Cell").props.value);

        const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
        const dd = date.getDate();
        const yyyy = date.getFullYear();

        const formattedDateFrom = `${mm}/${dd}/${yyyy}`;
        
        return(
            <td>
                {formattedDateFrom}
            </td>
        )
    }

    return (
        <td {..._cell.getCellProps()}> {
            _cell.render("Cell")
            }
        </td>
    )
}
const Tooltip = ({ text, children }) => {
    const [show, setShow] = useState(false);

    const handleMouseEnter = () => {
        setShow(true);
    };

    const handleMouseLeave = () => {
        setShow(false);
    };

    return (
        <div style={{ position: 'relative', display: 'inline-block',zIndex:"1" }}>
            <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            {children}
            </div>
            {show && (
            <div
                style={{
                position: 'absolute',
                top: '50%',
                left: '-50%',
                transform: 'translateX(-50%)',
                backgroundColor: 'white',
                color: 'gray',
                padding: '5px',
                borderRadius: '5px',
                pointerEvents: "none",
                boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"
                }}
            >
                {text}
            </div>
            )}
        </div>
    );
};
function CustomLoader({loadingPercentage}) {
    return (
        <div style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100vw",
            height: "100vh",
            backgroundColor: "#ffffff59", // Overlay effect
            zIndex: "2000",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
        }}>
            {loadingPercentage !== 0 && <p style={{color: "rgb(104, 104, 104)"}}>{`Loading: ${loadingPercentage}%`}</p>}
            
            <div className="custom-loader">
                <div
                    style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    height: "100%",
                    width: `${loadingPercentage}%`, // Foreground loader showing progress
                    backgroundColor: "rgba(255, 255, 255, 0.8)", // Semi-transparent to let the animation show behind it
                    borderRadius: "inherit"
                    }}
                />
            </div>
        </div>
    );
};
export default Payroll
